import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  Stack,
  Typography
} from "@mui/material";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled, useTheme } from '@mui/material/styles';
import { getter } from "@progress/kendo-react-common";
import { Operators, TextFilter, orderBy, setExpandedState } from "@progress/kendo-react-data-tools";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import {
  GridColumn as Column,
  Grid as KendoReactGrid,
  getSelectedState
} from "@progress/kendo-react-grid";
import React, {
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Spinner from "../../common/Spinner/Spinner";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import CloseIcon from "@mui/icons-material/Close";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SaveIcon from '@mui/icons-material/Save';
import SignalCellular4BarIcon from "@mui/icons-material/SignalCellular4Bar";
import { DatePicker as KendoDatePicker } from "@progress/kendo-react-dateinputs";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { TreeView, processTreeViewItems } from '@progress/kendo-react-treeview';
import { parse } from 'date-fns';
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { drageItemsReducer } from "../../../../shared/ReduxStore/Reducers/dragReducer";
import { addMapData } from "../../../../shared/ReduxStore/Reducers/mapDataReducer";
import { refreshPartialTrip, setPartialTripReducer, refreshRouteAndPT, setAgendaResource, setIsMultiplePT } from "../../../../shared/ReduxStore/Reducers/partialTripReducer";
import { pinReducer } from "../../../../shared/ReduxStore/Reducers/pinReducer";
import { updateSelectedSums } from '../../../../shared/ReduxStore/Reducers/updateHeaderReducer';
import { CellRender } from "../../../../shared/common-utilities/common/CellRender";
import { InfoCell } from "../../../../shared/common-utilities/common/InfoCell";
import RowRender from "../../../../shared/common-utilities/common/RowRender";
import ToggleMenuForConfig from '../../../../shared/common-utilities/common/toggleMenuForConfig/toggleMenuForConfig';
import commonApiService from '../../../../shared/common-utilities/services/commonApiService';
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService";
import ModalComponent from '../../common/Modal/ModalComponent.js';
import ContextMenu from "../ContextMenu/ContextMenu";
import ColumnPopUp from "./ColumnPopUp.jsx";
import { CustomActionDrillDown, CustomBooleanCell, CustomInfoCell, CustomQualificationCell } from "./CustomCells.jsx";
import AlertComponent from "../../../../shared/common-utilities/common/AlertComponent.jsx";
import { Accordion, AccordionDetails, AccordionSummary } from "../../../../shared/common-utilities/common/CommonStyleComponent.jsx";
import { DeleteDepot, DeleteHookOff, InsertDepots, baseUrl, customHookoff, fetchSavedView, getPartialTrip, getRoutes, insertHookOff, planMovementsNew, postContractout, postSavedView, postSetfree, postProcesstrips, postCreateSeparateBookings, postCreateOrAddToExistingBookings, InsertTerminals, DeleteTerminals, createTrips, postponeMovements, ChangePlanDepartment, ChangePlanSubdepartment, postChangesStatus, actionCode, postExecuteCustomActionMovements, postExecuteCustomActionPartialTrips, postSetFreeRoutes } from "../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts";
import { process } from '@progress/kendo-data-query';
import {DropDownRender} from '../../../../shared/common-utilities/common/DropDownRender'
import StarIcon from '@mui/icons-material/Star';
import WindowComponent from '../Window/WindowComponent.jsx';
import SaveFilteredPopUp from '../SaveFilteredPopUp/SaveFilteredPopUp.jsx';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import i18_en from '../../../../jsonStore/i18_en.json';
import { refreshRouteGridData } from '../../../../shared/ReduxStore/Reducers/tripRoutesReducer.jsx';
import SortColumnChooserPopUp from '../SortColumnChooserPopUp/SortColumnChooserPopUp.jsx';
import { PlanFunctionsForFlag } from '../../../../shared/common-utilities/enums/PlanFunctionsEnum.jsx';
import GrandSumTotalPopUp from '../GrandSumTotalPopUp/GrandSumTotalPopUp.jsx';
import dataStorageService from '../../../../shared/common-utilities/services/DataStorageService.jsx';
import { refreshShipmentMovementGridData } from '../../../../shared/ReduxStore/Reducers/shipmentMovementsReducer.jsx';

let service = getSetDataService();
const EDIT_FIELD = "inEdit";
let apiService = commonApiService();
let storageService = dataStorageService();
let dateErrorChecker = {};
let selectedId = {};
let onDroppedRecord = null;

const customInfoCellMemo = props => CustomInfoCell(props);
const customQualificationCellMemo = props => CustomQualificationCell(props);
const customActionDrillDownMemo = props => CustomActionDrillDown(props);

const DataGridComponent = React.forwardRef((data, ref) => {
  const {
    gridFlagVal,
    gridFlagValFor,
    entity,
    griddDtaItemKey,
    gridNewData,
    gridColumnList,
    gridTempColumnList,
    sendDataToParent,
    isShowGridHeader,
    gridDataAction,
    gridPlanAction,
    gridFilterComponents,
    griddefDataRelatedAction,
    isItemVisible,
    loadedGridData,
    gridInitialFilter,
    gridSort,
    editableColumn,
    loadSelectionValue,
    selectableMode,
    gridMeasureFilter,
    gridtotalData,
    routeGuidesData,
    planDepartmentData,
    planSubdepartmentData,
    initialSaveViewData,
    initialFetchReadLinkData,
    changeToChild,
    isRemovePreAndSelection,
    gridDefaultFilters,
    guid,
    customView
  } = data;
  //#region Reference
  const toggleMenuRef = useRef(null);
  const gridRef = useRef(null);
  const groupTreeviewRef = useRef(null);

  const [gridKey, setGridKey] = React.useState(1);
  //#endregion Reference
  const myGrididGetter = getter(griddDtaItemKey);
  let initialSortKeyData = localStorage.getItem(gridFlagValFor + 'Savedview')
    ? JSON.parse(localStorage.getItem(gridFlagValFor + 'Savedview'))[gridFlagValFor].sortings
    : [];
  const initialSavedViewObj = { [gridFlagValFor]: service.initialViewsObj }
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const drageItems = useSelector(state => state.drag);
  const partialTripReducerData = useSelector(state => state.partialTrip);
  const movementReducerData = useSelector(state => state.movement);
  const areaselectionReducerData = useSelector(state => state.areaSelection.layersData);
  const areaselectionRefReducerData = useSelector(state => state.areaSelection.refObj);
  const markerSelectionReducerData = useSelector(state => state.markerSelection);
  const theme = useTheme();

  //#region States - Get set variables
  const [cards, setCards] = useState();
  const [isFilterable, setIsFilterable] = useState(false);
  // const [arrFilterData, setArrFilterData] = useState(gridInitialFilter);
  const [openModalFilter, setOpenModalFilter] = useState(false)
  const [openModalColumnsSelect, setOpenModalColumnsSelect] = useState(false);
  const [openModalSort, setOpenModalSort] = useState(false);
  const [openModalFreeze, setOpenModalFreeze] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [refreshSource, setRefreshSource] = useState(false);
  const [gridColumns, setGridColumns] = useState(gridColumnList);
  const [groupbyGridColumns, setgroupbyGridColumns] = useState(gridTempColumnList);
  const [tempGridColumns, setTempGridColumns] = useState(data.gridTempColumnList);
  const [reorderedCols, setReorderedCols] = useState([]);
  const [savedSortColData, setSavedSortColData] = useState([]);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const userID = localStorage.getItem('userID');
  const [currSelectedStatus, setcurrSelectedStatus] = useState(null);

  let [colMultiFilter, setColMultiFilter] = React.useState({
    sortColumnsData: [],
    movTableColumns: gridTempColumnList,
    draggedItem: {}
  });
  const [measureFilters, setMeasureFilters] = React.useState(gridMeasureFilter);
  const [availableFields, setAvailableFields] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [filterValues, setFilterValues] = useState([]);
  const [toggleconfigcheckboxes, setToggleconfigCheckboxes] = useState({});
  const [toggleconfigcheckboxesplan, setToggleconfigcheckboxesplan] = useState({});
  const [toggleconfigCustomActioncheckboxes, setToggleconfigCustomActioncheckboxes] = useState({});
  const [toggleconfigActions, setToggleconfigActions] = useState([]);
  const [toggleconfigCustomActions, setToggleconfigCustomActions] = useState([]);
  const [menuItemsForCustomActions, setMenuItemsForCustomActions] = useState([]);
  const [toggleDraggedItem, setToggleDraggedItem] = useState([]);
  const [sortKeyViews, setSortKeyViews] = useState(initialSortKeyData);
  const [isMultiSort, setIsMultiSort] = useState(false);
  const [freezeColumnVal, setFreezeColumnVal] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isShow, setFlagShow] = useState(false);
  const [isShowToggleForConfig, setFlagShowToggleForConfig] = useState(false);
  const showToggleMenu = () => {
    setFlagShowToggleForConfig(!isShowToggleForConfig);
  }
  const handleClick = () => {
    setFlagShow(!isShow);
    setExpanded('panel1');
  }
  const [contextData, setContextData] = useState({});
  const [isPin, setIsPin] = useState(true);
  const [isActive, setActive] = useState(isShowGridHeader);
  const [show, setShow] = React.useState(false);
  const [treeViewData, setTreeViewData] = React.useState([]);
  const [selectTreeView, setSelectTreeView] = React.useState(['']);
  const [expand, setExpand] = React.useState({
    ids: [],
    idField: 'text',
  });
  // const [mapOpen, setMapOpen] = useState(false);
  const [gridUpdatedData, setGridUpdatedData] = useState([]);
  const [gridLoadedGridData, setGridLoadedGridData] = useState([]);
  const [gridTempData, setGridTempData] = useState([]);

  const [filterCompValues, setFilterCompValues] = useState(gridFilterComponents);
  const [openPlanNewTripPopup, setOpenPlanNewTripPopup] = useState(false)
  const [currentDate, setCurrentDate] = useState("")
  const [editableCell, setEditableCell] = useState(null);
  const [editableRow, setEditableRow] = useState(null);
  const [editableCol, setEditableCol] = useState(null);
  const [openConfirmationModal, setopenConfirmationModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const initialPaging = { skip: 0, take: 100 }
  const [page, setPage] = React.useState(initialPaging);
  const [pageSizeValue, setPageSizeValue] = React.useState(100);
  const [openModalDepot, setOpenModalDepot] = React.useState(false);
  const [depotModalTital, setdepotModalTital] = React.useState(false);
  const [popupParameters, setPopupParameters] = React.useState({});
  const [commonPopupParameters, setCommonPopupParameters] = React.useState({});
  const [isSuccessSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
  const [successSnackbarMessage, setSuccessSnackbarMessage] = useState('');
  const [isErrorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [errorSnackbarMessage, setErrorSnackbarMessage] = useState('');
  const [collapsedState, setCollapsedState] = React.useState([]);
  const [myselectedState, setMySelectedState] = React.useState({});
  const [myPartialSelectedState, setMyPartialSelectedState] = React.useState({});
  const [myGridDataState, setmyGridDataState] = React.useState({ sort: gridSort, group: [], skip: 0, take: pageSizeValue });
  // const [skip, setSkip] = React.useState(0);
  const [columnChooser, setcolumnChooser] = useState([]);

  const [groupByColumnVal, setGroupByColumnVal] = useState([]);
  const [groupTreeViewData, setGroupTreeViewData] = React.useState([]);
  const [selectGroup, setSelectGroup] = React.useState(['']);
  const [expandGroup, setExpandGroup] = React.useState({
    ids: [],
    idField: 'groupId',
  });
  const [selectedGrpTreeView,setSelectedGrpTreeView] = useState({})
  const [group, setGroup] = React.useState([])//[{field:"planDepartment"},{field:"planSubDepartment"},{field:"sequenceNo"}]);
  const [gridTotalDataLength, setgridTotalDataLength] = useState(500);
  const [treeviewSelectedValues, setTreeviewSelectedValues] = useState({});
  const [selectedTableRows, setSelectedTableRows] = useState([]);
  const [selectedResponseTableRows, setSelectedResponseTableRows] = useState([]);
  const [openAddColumnModal, setOpenAddColumnModal] = useState(false);
  const [resourceType, setResourceType] = useState("");
  const [startRowIndex, setStartRowIndex] = useState(null);
  const [indexSelectedRow,setIndexSelectedRow] = useState([]);
  const [keySelectedRows,setKeySelectedRows] = useState([])
  const [etag, setEtag] = useState("");
  const [onClickRowData, setOnClickRowData] = useState()
  const [disableCODepotHOSURMPTCSBIcons, setdisableCODepotHOSURMPTCSBIcons] = useState(true);
  const [disablePTContractOutIcon, setDisablePTContractOutIcon] = useState(true);
  const [disablePTCOIcon, setDisablePTCOIcon] = useState(false);
  const [disableReportIcon, setDisableReportIcon] = useState(true);
  const [batchTCIcon,setBatchTCIcon] = useState(false)
  const [disableRoutesScreenIcon, setDisableRoutesScreenIcon] = useState(true);
  const [disableRoutesSetFreeIcon, setDisableRoutesSetFreeIcon] = useState(true);
  const [disableMoveUpIcon, setDisableMoveUpIcon] = useState(true);
  const [disableMoveDownIcon, setDisableMoveDownIcon] = useState(true);
  const [disableShipmentMovementScreenIcon, setDisableShipmentMovementScreenIcon] = useState(true);
  const [disableHoldOnOffIcon, setDisableHoldOnOffIcon] = useState(true);
  const [editField, setEditField] = useState("");
  const [savedViewsApiData, setSavedViewsApiData] = useState(initialSaveViewData);
  const [focusField, setFocusField] = useState(null);
  const [resourceData, setResourceData] = useState(null);
  const [editFieldVal, setEditFieldVal] = useState("");
  const [isApiCall, setIsApiCall] = useState(true);
  const [isColumnExist, setIsColumnExist] = useState(false);

  const [filterSortArr, setFilterSortArr] = useState({ filterArray: gridInitialFilter, sortArray: gridSort, groupArray:[] });
  const [filterSortUrl, setFilterSortUrl] = useState({ filterUrl: null, sortUrl: service.convertSortToStringVal(gridSort), groupUrl: null });
  const [isDisplayDrillDownButton, setIsDisplayDrillDownButton] = useState(false);
  const [drillDownButtonURL, setDrillDownButtonURL] = useState();
  const [updatedGridDataAction, setUpdatedGridDataAction] = useState(gridDataAction);
  const [nonFilterableColumnData,setNonFilterableColumnData] = useState([])
  const [nonSortableColumnData,setNonSortableColumnData] = useState([])
  const [timeFieldColumnData,setTimeFieldColumnData] = useState([])
  const [disableSelectAll, setDisableSelectAll] = useState(false);
  const [currentStatusVal, setCurrentStatusVal] = useState('');

  const wasCalled = useRef(false);

  const displayCreateTripToolTip = useMemo(() => <>Create Trips<Typography>A new trip will be created for each selected shipment movement.</Typography></>, []);
  const displayProcessTripToolTip = useMemo(() => <>Process Trips<Typography>New trips will be created based on the route guides of the selected shipment movements.</Typography></>, []);
  const displayMoveToLUToolTip = useMemo(() => <>Move To LU<Typography>Assign the different  movement goods towards the correct loading units, just to know which loading unit holds which goods. This is necessary before you split up a partial trip that has more than 1 loading unit attached.</Typography></>, []);
  const displaySaveToolTip = useMemo(() => <><Typography>F2 (Open left pane/My Views) / Alt + F2 (Open Save View/Filtered Data)</Typography></>, []); 
  
  //#endregion States

  const toDayDate = new Date();
  const minDate = new Date(toDayDate.getFullYear() - 50, toDayDate.getMonth(), toDayDate.getDate());
  const maxDate = new Date(toDayDate.getFullYear() + 50, toDayDate.getMonth(), toDayDate.getDate());
  const gridCustomActions = data?.customActions?.map(x => x.caption);
  const partialTripRefreshReducerData = useSelector(state => state.partialTrip.isRefreshPartialTrip);

  //#region Hooks

  useEffect(() => {
    if (gridFlagVal === 'partialTrips' && window.location.hash.includes("#/CustomView")) {
      wasCalled.current = false;
    }
  }, [partialTripRefreshReducerData])

  // useEffect(() => {
  //   mapOpen && onPopup('/map', false)
  // }, [mapOpen]);
  useEffect(()=>{
    setFilterCompValues(gridFilterComponents)
  },[gridFilterComponents])

  useEffect(() => {
    if (areaselectionReducerData) {
      const ids = new Set(areaselectionReducerData.filter(e => e.source == gridFlagVal).map(item => item.id));

      if (gridFlagVal == "partialTrips") {
        // const updatedSelectedState = Object.fromEntries(
        //   Object.entries(myselectedState).filter(([key]) => !ids.has(key))
        // );
        const updatedPartialSelectedState = Object.fromEntries(
          Object.entries(myPartialSelectedState).filter(([key]) => !ids.has(key))
        );

        const idsPrtSelected = service.genKeyValuePair(areaselectionReducerData?.filter(e => e.isSelection), 'id', 'isSelection');
        // const idsPrtSelected = service.genKeyValuePair(areaselectionReducerData?.filter(e => !e.isSelection), 'id', 'isSelection');

        // const mergedSelected = _.merge(updatedSelectedState, idSelcted)
        let mergedPrtSelected = _.merge(updatedPartialSelectedState, idsPrtSelected)
        // Object.keys(mergedPrtSelected).forEach(key => {mergedPrtSelected[key] = true });

        setMySelectedState([], gridTempData);
        setMyPartialSelectedState(idsPrtSelected);
      } else {
        const updatedSelectedState = Object.fromEntries(
          Object.entries(myselectedState).filter(([key]) => !ids.has(key))
        );
        const updatedPartialSelectedState = Object.fromEntries(
          Object.entries(myPartialSelectedState).filter(([key]) => !ids.has(key))
        );

        const idSelcted = service.genKeyValuePair(areaselectionReducerData?.filter(e => e.isSelection), 'id', 'isSelection');
        const idsPrtSelected = service.genKeyValuePair(areaselectionReducerData?.filter(e => !e.isSelection), 'id', 'isSelection');

        const mergedSelected = _.merge({}, idSelcted)
        let mergedPrtSelected = _.merge([], idsPrtSelected)
        // Object.keys(mergedPrtSelected).forEach(key => {mergedPrtSelected[key] = true });

        setMySelectedState(mergedSelected, gridTempData);
        setMyPartialSelectedState(mergedPrtSelected);
      }
    }
  }, [areaselectionReducerData]);

  useEffect(() => {
    if (areaselectionRefReducerData?.isRefresh) {
      onRefreshIconClick()
    }
  }, [areaselectionRefReducerData]);



  useEffect(() => {
    if (markerSelectionReducerData && markerSelectionReducerData?.selectedData) {
      const tempPrtstate = _.cloneDeep(myPartialSelectedState);
      const tempSelectedstate = _.cloneDeep(myselectedState);

      const id  = markerSelectionReducerData?.selectedData?.id;
      if(!_.isNil(id)) {
        if(markerSelectionReducerData?.selectedData?.isSelection){
          delete tempPrtstate[id]
          tempSelectedstate[markerSelectionReducerData?.selectedData?.id] = true
        }else{
          delete tempSelectedstate[id];
          tempPrtstate[markerSelectionReducerData?.selectedData?.id] = true
        }
      }
      setMyPartialSelectedState(tempPrtstate);
      setMySelectedState(tempSelectedstate);
    }
  }, [markerSelectionReducerData])

  useEffect(() => {
    setActive(isShowGridHeader);
  }, [isShowGridHeader])

  useEffect(() => {
    if(partialTripReducerData.plannedOnAgenda || movementReducerData.plannedOnAgenda.status){
      setMySelectedState([])
    }
  }, [partialTripReducerData.plannedOnAgenda,movementReducerData.plannedOnAgenda])

  useEffect(() => {
    setTreeViewData(generateTreeViewData())
    storageService.setLocalStorageData('currentActive', gridFlagValFor);
    if (window.location.hash.includes(data.routeName)) {
      sendDataToParent(false, 'showGridHeader');
      setIsPin(false)
    }

    // // Add event listener when the component mounts
    // document.addEventListener('keydown', onShortcutKeyPress);

    // // Remove event listener when the component unmounts
    // return () => {
    //   document.removeEventListener('keydown', onShortcutKeyPress);
    // };
    setMenuItemsForCustomActions(data?.customActions?.map(item => {
      return  { icon: service.getActionsIcon(item?.iconName), title: item.caption, shortkey: '' }
    }));

    if(entity) {
      const columnData = storageService.getLocalStorageData("nonFilterableColumn")
      if(!_.isNil(columnData)) {
        const newColumnData = JSON.parse(columnData).filter((elem)=> elem.name === entity)[0]?.fields
        let nonFilteredFields = Object.entries(newColumnData[0]).filter(([key, value]) => value.filter === false).map(([key, value]) => key);
        let nonSortedFields = Object.entries(newColumnData[0]).filter(([key, value]) => value.sort === false).map(([key, value]) => key);
        let timeFilds = Object.entries(newColumnData[0]).filter(([key, value]) => value.type === "Time").map(([key, value]) => key);
        nonFilteredFields.push('ActionColumn')
        nonSortedFields.push('ActionColumn')
        setNonFilterableColumnData(nonFilteredFields)
        setNonSortableColumnData(nonSortedFields)
        setTimeFieldColumnData(timeFilds)

      }
    }
    if (window.location.hash.includes("#/CustomView") || window.location.hash.includes("#/CreateCustomView")) {
      setUpdatedGridDataAction(oldData => oldData?.filter(item => item !== 'New Window'));
    }
  }, []);

  useEffect(()=> {
    if(isColumnExist && selectTreeView[0] == '' && gridFlagVal != 'routes' && gridFlagVal != 'ptmovements') {

      const userData = JSON.parse(localStorage.getItem('userData'));
      let newCards = cards ? [...cards] : [];

      const isFieldPresent = (fieldToCheck) => {
        return data.gridTempColumnList.some(obj => obj.field === fieldToCheck);
      };

      if(userData.planDepartment != "" && isFieldPresent("planDepartment")) 
        newCards.push({ field: 'planDepartment', value: userData.planDepartment });
      if(userData.department != "" && isFieldPresent("department"))
        newCards.push({ field: 'department', value: userData.department });
      if(userData.planSubdepartment != "" && isFieldPresent("planSubdepartment"))
        newCards.push({ field: 'planSubdepartment', value: userData.planSubdepartment });
      if(userData.subdepartment != "" && isFieldPresent("subdepartment"))
        newCards.push({ field: 'subdepartment', value: userData.subdepartment });

      setCards(newCards);

      const newAvailableFields = [];
      const fieldsToIgnore = _.concat(filterCompValues.map(e => e.key), nonFilterableColumnData)
      const tempFieldList = [];
      data.gridTempColumnList.forEach(e => {
        if (!fieldsToIgnore.includes(e.field)) {
          const obj = {
            name: e.field,
            label: e.title,
            filter: TextFilter,
            // operators: Operators.text,
            type: e.type
          };
          tempFieldList.push(obj);
        }
      });

      newAvailableFields.push(tempFieldList?.filter(field => !selectedFields?.map(e => e?.name)?.toString()?.includes(field?.name)));
      const arrayOfArrays = newCards.map(() => newAvailableFields[0]);
      setAvailableFields(arrayOfArrays);
      let sFields = _.cloneDeep(selectedFields)
      newCards.forEach((elem,index) => {
        let selected = newAvailableFields[0].find(x => x?.name == elem?.field)
        sFields[index] = selected
      })
      setSelectedFields(sFields);
    }
  },[isColumnExist])

  useEffect(()=>{
    if(data.gridTempColumnList.length > 0) {
      setIsColumnExist(true)
    }
  },[data.gridTempColumnList])

  useEffect(() => {
    if (initialSaveViewData?.length > 0 || initialFetchReadLinkData !== null) {
      setSavedViewsApiData(initialSaveViewData);
      fetchUpdateSavedViews(gridFlagValFor, initialSaveViewData, false, false);
    }
  }, [initialSaveViewData])

  useEffect(() => {
    if (gridMeasureFilter != null) {
      setMeasureFilters(gridMeasureFilter);
    }
  }, [gridMeasureFilter])

  const onShortcutKeyPress = (event) => {
    const activeComp = storageService.getLocalStorageData('currentActive');
    const createCustomViewRoute = window.location.hash.includes("#/CreateCustomView");
    const toggleconfigActionsList = toggleconfigActions?.map(item => item.title);
    if ((toggleconfigcheckboxes['Filter'] || toggleconfigActionsList.includes('Filter')) && event.altKey && event.key.toLowerCase() === 'y' && !createCustomViewRoute && activeComp === gridFlagValFor) {
      onFilterIconClick()
    } else if (((toggleconfigcheckboxes['Refresh'] || toggleconfigActionsList.includes('Refresh')) && event.altKey && event.key === 'F5') && !createCustomViewRoute && activeComp === gridFlagValFor) {
      onRefreshIconClick('manualRefresh');
    } else if (event.altKey && event.key === 'F2' && !createCustomViewRoute && activeComp === gridFlagValFor) {
      setFlagShow(true);
      setExpanded('panel1');
      addNewView();
    } else if (event.key === 'F2' && !createCustomViewRoute && activeComp === gridFlagValFor) {
      setFlagShow(true);
      toggleMyViewPanel();
    }else if((toggleconfigcheckboxesplan[PlanFunctionsForFlag.PlanOnMap] || toggleconfigActionsList.includes(PlanFunctionsForFlag.PlanOnMap)) && !disableCODepotHOSURMPTCSBIcons && (event.ctrlKey && event.key.toLowerCase() === 'm')){
      onPlanButtons('map')
    }
    else if (gridFlagVal === 'movements') {
      const selectedValues = getSelectedValues();
      if ((toggleconfigcheckboxesplan['Custom Hook Off'] || toggleconfigActionsList.includes('Custom Hook Off')) && !disableCODepotHOSURMPTCSBIcons && (event.altKey && event.key.toLowerCase() === 'j')) {
        onCustomHooksIconClick(selectedValues);
      } else if ((toggleconfigcheckboxesplan['Hook Off'] || toggleconfigActionsList.includes('Hook Off')) && !disableCODepotHOSURMPTCSBIcons && (event.altKey && event.key.toLowerCase() === 'h')) {
        onHooksIconClick(selectedValues);
      } else if ((toggleconfigcheckboxesplan['Delete Hook Off'] || toggleconfigActionsList.includes('Delete Hook Off')) && !disableCODepotHOSURMPTCSBIcons && (event.altKey && event.key.toLowerCase() === 'k')) {
        onDeleteHooksIconClick(selectedValues);
      } else if ((toggleconfigcheckboxesplan['Depot'] || toggleconfigActionsList.includes('Depot')) && !disableCODepotHOSURMPTCSBIcons && (event.altKey && event.key.toLowerCase() === 'i')) {
        onDepotIconClick(selectedValues);
      } else if ((toggleconfigcheckboxesplan['Delete Depot'] || toggleconfigActionsList.includes('Delete Depot')) && !disableCODepotHOSURMPTCSBIcons && (event.altKey && event.key.toLowerCase() === 'o')) {
        onDeleteDepotIconClick(selectedValues);
      } else if ((toggleconfigcheckboxesplan['Plan On New Trip'] || toggleconfigActionsList.includes('Plan On New Trip')) && !disablePTCOIcon && (event.altKey && event.key.toLowerCase() === 'p')) {
        onPlanTripButtons();
      } else if ((toggleconfigcheckboxesplan['Contract Out'] || toggleconfigActionsList.includes('Contract Out')) && !disablePTCOIcon && (event.altKey && event.key.toLowerCase() === 'c')) {
        onPlanButtons('contract-out', getSelectedValues(null, true));
      } else if ((toggleconfigcheckboxesplan['Report'] || toggleconfigActionsList.includes('Report')) && !disableReportIcon && (event.altKey && event.key.toLowerCase() === 'r')) {
        onPlanButtons('reports', selectedValues);
      }
    } else if (gridFlagVal === 'partialTrips') {
      const selectedValues = getSelectedValues();
      if ((toggleconfigcheckboxesplan['Send To OBC'] || toggleconfigActionsList.includes('Send To OBC')) && !disableReportIcon && (event.altKey && event.key.toLowerCase() === 's')) {
        onPlanButtons('send-to obc', selectedValues);
      } else if ((toggleconfigcheckboxesplan[PlanFunctionsForFlag.DeletePartialTrip]|| toggleconfigActionsList.includes(PlanFunctionsForFlag.DeletePartialTrip)) && !disableReportIcon && (event.altKey && event.key === 'Delete')) {
        onPlanButtons('delete-partial trip', selectedValues);
      } else if ((toggleconfigcheckboxesplan['Show On Map'] || toggleconfigActionsList.includes('Show On Map')) && !disableReportIcon && (event.altKey && event.key.toLowerCase() === 'm')) {
        onPlanButtons('show-on map', selectedValues);
      } else if ((toggleconfigcheckboxesplan['Report'] || toggleconfigActionsList.includes('Report')) && !disableReportIcon && (event.altKey && event.key.toLowerCase() === 'r')) {
        onPlanButtons('reports', selectedValues);
      } else if ((toggleconfigcheckboxesplan['Changes Status'] || toggleconfigActionsList.includes('Changes Status')) && !disableCODepotHOSURMPTCSBIcons && (event.shiftKey && event.key === 'F9')) {
        onPlanButtons('changes-status', selectedValues);
      } else if ((toggleconfigcheckboxesplan['Calculate'] || toggleconfigActionsList.includes('Calculate')) && !disableReportIcon && (event.altKey && event.key === 'F7')) {
        onCalculateIconClick(selectedValues);
      } else if ((toggleconfigcheckboxesplan['Contract Out'] || toggleconfigActionsList.includes('Contract Out')) && !disablePTContractOutIcon && (event.altKey && event.key.toLowerCase() === 'c')) {
        onPlanButtons('contract-out', selectedValues);
      }
    }
  };

  useEffect(() => {
    if (measureFilters !== null && measureFilters !== undefined) {
      const movMeasureTableColumns = measureFilters?.movMeasureTableColumns?.filter(item => {
        if (!selectedResponseTableRows.map(item => item.field).includes(item.field)) {
          return item;
        }
      });
      const obj = {
        measureColumnsData: selectedResponseTableRows,
        movMeasureTableColumns: movMeasureTableColumns,
        draggedItem: measureFilters.draggedItem
      }
      setMeasureFilters(obj);
      setSelectedTableRows(selectedResponseTableRows.map(tableRow => tableRow.field));
    }
  }, [selectedResponseTableRows]);

  useEffect(() => {
    setGridColumns([...gridColumnList]);

    // setColMultiFilter({
    //   ...colMultiFilter,
    //   movTableColumns: gridColumnList
    // });

    // set sorting data(from settings) to localStorage
    const views = localStorage.getItem(gridFlagValFor + 'Savedview');
    const updatedRows = views ? JSON.parse(views) : initialSavedViewObj;
    const saveSettingsSelectedColumns = {
      sortColumnsData: colMultiFilter?.sortColumnsData,
      movTableColumns: colMultiFilter?.movTableColumns,
      freezeColumnVal: freezeColumnVal,
      groupByColumnVal: groupByColumnVal
    };
    updatedRows[gridFlagValFor].settingsColumn = saveSettingsSelectedColumns;
    localStorage.setItem(gridFlagValFor + 'Savedview', JSON.stringify(updatedRows));
  }, [gridColumnList])

  useEffect(() => {
    if (gridTempColumnList.length !== tempGridColumns.length) {
      setTempGridColumns([...gridTempColumnList]);
    }
    const gCols = gridTempColumnList?.filter(e => !['ActionColumn', 'instructionsExist', 'qualificationsExist'].includes(e.field));
    setgroupbyGridColumns([...gCols]);

    setColMultiFilter({
      ...colMultiFilter,
      movTableColumns: gridTempColumnList
    });

  }, [gridTempColumnList])

  useEffect(() => {
    if (changeToChild != null) {
      if (changeToChild?.type == "sort") {
        const ds = _.cloneDeep(myGridDataState)
        const changedSort = ds.sort.filter(e => e.field != changeToChild.value);
        setmyGridDataState({ ...myGridDataState, sort: changedSort });
        setFilterSortArr({ ...filterSortArr, sortArray: changedSort });
      } else if (changeToChild?.type == "filter") {
        let changeFilter = [];
        if (changeToChild.field) {
          changeFilter = filterSortArr.filterArray?.filter(e => e.field != changeToChild.field);
        } else {
          changeFilter = filterSortArr.filterArray?.filter(e => e.value != changeToChild.value);
        }
        setFilterSortArr({ ...filterSortArr, filterArray: changeFilter });
      }
      setIsApiCall(false);
    }
  }, [changeToChild])

  useEffect(() => {
    // console.log(filterSortArr,'filterSortArr')
    filterGridData();
    const statusData = filterSortArr.filterArray?.filter(x => x.field === 'status');
    const isRemoveSelection = gridFlagVal === 'movements' && gridFlagValFor === 'movements' && !statusData?.[0]?.value?.includes('0');
    setCurrentStatusVal(statusData?.[0]?.value?.replace(/^[^a-zA-Z0-9]+/, ''));
    setDisableSelectAll(isRemoveSelection);
    if (isRemoveSelection) {
      setMySelectedState({});
    }
  }, [filterSortArr])

  useEffect(() => {
    sendDataToParent({ filter: filterSortUrl.filterUrl, orderby: service.convertSortToStringVal(filterSortArr.sortArray), columns: tempGridColumns, isApiCall: isApiCall }, 'getData');
    setIsApiCall(true);
    setmyGridDataState({ ...myGridDataState, sort: filterSortArr.sortArray, skip: 0 });
  }, [filterSortUrl])

  useEffect(() => {
    if (data.gridDataState) {
      setGridUpdatedData(service.processWithGroups(
        gridNewData,//setSelectedValue(gridNewData, data.gridSelectedState),
        data.gridDataState
      ))
      resetHeaderFields(data.gridSelectedState, gridNewData)
    } else {
      setGridUpdatedData(service.processWithGroups(
        gridNewData,//setSelectedValue(gridNewData, myselectedState),
        myGridDataState
      ))
      // setTimeout(() => {
      resetHeaderFields(myselectedState, gridNewData)
      // }, 10);
    }

    setgridTotalDataLength()
    // selectedId = myselectedState
  }, [gridNewData])

  useEffect(() => {
    if (data.gridSelectedState) {
      resetHeaderFields(data.gridSelectedState, gridTempData)
    } else {
      resetHeaderFields(myselectedState, gridTempData)
    }
    sendDataToParent(myselectedState, 'selectedValues');

    if (gridFlagVal === 'movements') {
      disabledIconsForMovements({...myselectedState, ...myPartialSelectedState}, false);
    } else if (gridFlagVal === 'partialTrips') {
      const trueCount = Object.values({...myselectedState, ...myPartialSelectedState}).filter(value => value === true).length;
      setDisableReportIcon(trueCount > 1 || trueCount === 0);
      setdisableCODepotHOSURMPTCSBIcons(trueCount === 0);
      setDisablePTContractOutIcon(trueCount !== 1);
    } else if (gridFlagVal === 'routes') {
      disabledIconsForRoutes(myselectedState, 0);
    } else if (gridFlagVal === 'ptmovements') {
      const trueCount = Object.values(myselectedState).filter(value => value === true).length;
      setDisableShipmentMovementScreenIcon(trueCount < 1);
    } else {
      setdisableCODepotHOSURMPTCSBIcons(false);
      setDisablePTCOIcon(false);
      setDisableReportIcon(false);
      setDisableRoutesScreenIcon(false);
      setDisableRoutesSetFreeIcon(false);
      setDisableMoveUpIcon(false);
      setDisableMoveDownIcon(false);
      setDisableShipmentMovementScreenIcon(false);
    }
  }, [myselectedState])

  useEffect(() => {
    document.addEventListener('keydown', onShortcutKeyPress);

    // Remove event listener when the component unmounts
    return () => {
      document.removeEventListener('keydown', onShortcutKeyPress);
    };
  }, [onShortcutKeyPress])

  useEffect(() => {
    setGridLoadedGridData(service.processWithGroups(loadedGridData, { sort: myGridDataState?.sort }))
    setGridTempData(service.processWithGroups(loadedGridData, { sort: myGridDataState?.sort }))

    if (loadSelectionValue !== 'All' && myGridDataState?.skip > 0) {
      setmyGridDataState({ ...myGridDataState, skip: 0 });
    }
    setTreeviewSelectedValues({})
    if (columnChooser.length > 0) {
      setFlagShow(true)
      setExpanded("panel2")
      const tempDataState = { ...myGridDataState, take: loadedGridData.length };
      const aggregatesData = service.processWithGroups(loadedGridData, { ...tempDataState, group: columnChooser });
      if (aggregatesData.data.length > 0) {
        onSetGroupTreeviewData(aggregatesData.data);
      }
    } else {
      onSetGroupTreeviewData([]);
    }
    // setTimeout(() => {
    resetHeaderFields(myselectedState, loadedGridData)

    if (gridFlagVal === 'routes' || gridFlagVal === 'ptmovements') {
      if (isRemovePreAndSelection && gridFlagVal === 'routes') {
        setMySelectedState([]);
        // setMyPartialSelectedState([]);
      }
      // if (gridFlagVal === 'ptmovements') {
      //   setMySelectedState([]);
      //   setMyPartialSelectedState([]);
      // }
    }
    // }, 10);

    if (gridFlagVal === 'partialTrips' && window.location.hash.includes("#/CustomView") && !data.isPopup) {
      if(loadedGridData.length > 0) {
        if(wasCalled.current) {
          return;
        }
        wasCalled.current = true;
        // setMySelectedState({ 1: false });
        // if(!data.isChild)
          gridOnRowClick(_.first(loadedGridData));
      }
    }

    const tempstate = JSON.parse(JSON.stringify(myselectedState));
    for (const key in tempstate) {
      if (!loadedGridData?.map(item => item.id)?.includes(key)) {
        delete tempstate[key];
      }
    }
    setMySelectedState(tempstate);

    if(Object.keys(selectedGrpTreeView).length > 0)
      onTreeviewGroupItemClick(selectedGrpTreeView)
  }, [loadedGridData])

  // useEffect(() => {
  //   if (arrFilterData != undefined && isApiCall) {
  //     filterGridData(arrFilterData, true);
  //   } else {
  //     filterGridData(arrFilterData, false);
  //   }
  // }, [arrFilterData])

  useEffect(() => {
    if (!_.isNil(drageItems.source) && drageItems.source != "" && !_.isNil(drageItems.destination) && drageItems.destination != "") {
      if (drageItems.source === gridFlagVal && drageItems.source == 'movements' && drageItems.destination == 'partialTrips') {
        onRefreshIconClick()
      }
    }
  }, [drageItems])

  useEffect(()=>{
    if(window.location.hash.includes("#/CustomView") && gridFlagVal === 'partialTrips' && !data.isChild) {
      const newObj = {...myselectedState,...myPartialSelectedState}
      const trueValuesArray = Object.keys(newObj).filter(key => newObj[key] === true);

      if(trueValuesArray.length == 1) {
        const obj = {
          tripNumber: trueValuesArray[0],
          guid: guid,
          customView: customView
          // partialTrips: [rowData]
        };
        dispatch(setPartialTripReducer(obj));
        dispatch(setIsMultiplePT(false))
      } else {
        dispatch(setIsMultiplePT(true))
      }
    }
  },[myselectedState,myPartialSelectedState])
  useEffect(()=>{
    if(guid == partialTripReducerData.guid && partialTripReducerData.removePartialTrip) {
      setMySelectedState([])
      setMyPartialSelectedState([])
      setGridTempData([])
    }
  },[partialTripReducerData.removePartialTrip])
  React.useImperativeHandle(data.gridRef, () => ({
    filterGridData,
  }));

  // Commented by Bhavesh Panchal - for Sprint 2 release
  // useEffect(() => {
  //   const handleKeyPress = (event) => {
  //     if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'm' && !disableCODepotHOSURMPTCSBIcons) {
  //       planOnMapData();
  //     }
  //   };
    

  //   document.addEventListener('keydown', handleKeyPress);

  //   return () => {
  //     document.removeEventListener('keydown', handleKeyPress);
  //   };

  // }, [myselectedState, myPartialSelectedState])
  //#endregion Hooks

  const planOnMapData = () => {    
    const mapWindow = onPopup('map', false);
    onPopup('resources', false)
    let obj = {};
    const partialSelectedIds = getSelectedValues(myPartialSelectedState);
    const actualSelectedIds = getSelectedValues(myselectedState);
    obj = {
      source: gridFlagVal,
      items: {
        actualSelectedIds: actualSelectedIds,
        partialSelectedIds: partialSelectedIds
      }
    }
    const storedData = storageService.getLocalStorageData('mapItem');
    const mapdata = storedData ? JSON.parse(storedData) : [];
    const filteredData = mapdata?.filter(e => e.source !== gridFlagVal);
    filteredData.push(obj);
    storageService.setLocalStorageData('mapItem', JSON.stringify(filteredData));
    if (mapWindow) {
      mapWindow.onload = () => {
        dispatch(addMapData(filteredData))
      }
    } else {
      dispatch(addMapData(filteredData))
    }
    
    // setTimeout(() => {
    //   dispatch(addMapData(filteredData))
    //   // dispatch(drageItemsReducer(obj))
    // }, 1000);

  }

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.neutral.main,
      color: 'rgba(255, 255, 225, 0.99)',
      boxShadow: theme.shadows[10],
      fontSize: 12,
      paddingLeft: 10,
      paddingRight: 10,
    },
  }));

  // --- Callback methods START ---

  const mygridOnDataStateChange = (e) => {
    e.dataState.group = [];
    setmyGridDataState(e.dataState);
    // console.log(e.dataState.skip)
    // setSkip(e.dataState.skip)
  }

  const disabledIconsForMovements = (selectedRows, isDisablePTCOIcon) => {
    let flag = 0;
    const selectedRow = Object.entries(selectedRows).filter(([key, value]) => value === true).map(([key]) => key);
    const mySelectedRow = Object.entries(myselectedState).filter(([key, value]) => value === true).map(([key]) => key);
    if (gridTempData?.data !== null && gridTempData?.data !== undefined && selectedRow.length > 0) {
      if ((selectedRow.length === 1 && mySelectedRow.length === 0) || (selectedRow.length === 1 && mySelectedRow.length === 1 && !isDisablePTCOIcon)) {
        setDisableReportIcon(false);
        setDisableHoldOnOffIcon(false);
      } else {
        setDisableReportIcon(true);
        setDisableHoldOnOffIcon(true);
      }
      for (const gridData of gridTempData.data) {
        if (selectedRow.find(rowId => rowId === gridData.id) && gridData?.status?.toLowerCase() !== 'to plan') {
          flag = 1;
          break;
        }
      }
    } else {
      if (mySelectedRow.length === 0 || mySelectedRow.length > 1) {
        if (mySelectedRow.length === 0) {
          flag = 1;
        }
        setDisableReportIcon(true);
        setDisableHoldOnOffIcon(true);
      } else {
        setDisableReportIcon(false);
        setDisableHoldOnOffIcon(false);
      }
    }

    if (flag === 1 || currentStatusVal?.toLowerCase() !== '0') {
      setdisableCODepotHOSURMPTCSBIcons(true);
      setDisablePTCOIcon(true);
      setDisableReportIcon(true);
      setDisableHoldOnOffIcon(true);
    } else {
      setdisableCODepotHOSURMPTCSBIcons(false);
      if (mySelectedRow.length >= 1) {
        setDisablePTCOIcon(false);
      } else {
        setDisablePTCOIcon(true);
      }
    }
  }

  const disabledIconsForRoutes = (selectedRows, myselectedStateCount) => {
    const trueCount = Object.values(selectedRows).filter(value => value === true).length;
    if (trueCount >= 1) {
      if (trueCount === 1 && myselectedStateCount === 0 && loadedGridData.length > 1) {
        const selectedRowIndex = loadedGridData.findIndex(x => x.id === Object.entries(selectedRows).filter(([key, value]) => value === true).map(([key]) => key)[0]);
        const enableMoveUpIcon = selectedRowIndex >= 1 ? loadedGridData[selectedRowIndex - 1].statusDescription.toLowerCase() === 'planned' : false;
        const enableMoveDownIcon = selectedRowIndex !== -1 && selectedRowIndex !== loadedGridData.length - 1 && loadedGridData[selectedRowIndex].statusDescription.toLowerCase() === 'planned'
          ? loadedGridData[selectedRowIndex + 1].statusDescription.toLowerCase() === 'planned' : false;
        setDisableMoveUpIcon(!enableMoveUpIcon);
        setDisableMoveDownIcon(!enableMoveDownIcon);
        setDisableRoutesScreenIcon(false);
      } else {
        setDisableMoveUpIcon(true);
        setDisableMoveDownIcon(true);
        setDisableRoutesScreenIcon(true);
      }
      setDisableRoutesSetFreeIcon(false);
    } else {
      setDisableMoveUpIcon(true);
      setDisableMoveDownIcon(true);
      setDisableRoutesScreenIcon(true);
      setDisableRoutesSetFreeIcon(true);
    }
  }

  const gridOnRowClick = (rowData, keyPress = null) => {
    let tempstate = {}
    if (rowData != undefined && rowData !== null) {
      if (keyPress === 'ctrl') {
        tempstate = JSON.parse(JSON.stringify(myPartialSelectedState));
      } else if (keyPress === 'shift') {
        tempstate = rowData.reduce((result, item) => {
          if (!myselectedState[item.id]) {
            result[item.id] = true;
          }
          return result;
        }, {});
      } else {
        tempstate = {};
      }
      if (rowData?.id && !tempstate[rowData.id]) {
        tempstate['' + rowData.id] = true;
        setMyPartialSelectedState(tempstate);
      } else {
        delete tempstate[rowData.id];
        setMyPartialSelectedState(tempstate)
      }

      if (gridFlagVal === 'movements') {
        const selectedRow = Object.entries(tempstate).filter(([key, value]) => value === true).map(([key]) => key);
        const mySelectedRow = Object.entries(myselectedState).filter(([key, value]) => value === true).map(([key]) => key);
        const disablePTCO = mySelectedRow.length === 0;
        if (currentStatusVal?.toLowerCase() !== '0') {
          setMovementIconState(true, true, true, true);
        } else {
          if (keyPress === 'shift') {
            const onHoldCount = rowData.filter(data => data.onHold).length
            if (onHoldCount > 1) {
              setMovementIconState(true, false, disablePTCO, true);
            } else if (onHoldCount === 1) {
              if (selectedRow.length === 1) {
                setMovementIconState(false, false, disablePTCO, false);
              } else if (selectedRow.length > 1) {
                setMovementIconState(true, false, disablePTCO, true);
              } else {
                disabledIconsForMovements(tempstate, true);
              }
            } else {
              disabledIconsForMovements(tempstate);
            }
          } else if (keyPress === 'ctrl') {
            let flag = 0, count = 0;
            for (const data of gridTempData?.data || []) {
              if (selectedRow.includes(data.id) && data.onHold) {
                count++;
                flag = 1;
              }
              if (count >= 2) {
                break;
              }
            }
            if (flag === 1) {
              setMovementIconState(!(count === 1 && selectedRow.length === 1 && mySelectedRow.length === 0), false, disablePTCO, !(count === 1 && selectedRow.length === 1 && mySelectedRow.length === 0));
            } else {
              disabledIconsForMovements(tempstate, true);
            }
          } else if (rowData.onHold) {
            setMovementIconState(!(selectedRow.length === 1 && mySelectedRow.length === 0), false, disablePTCO, !(selectedRow.length === 1 && mySelectedRow.length === 0));
          } else {
            disabledIconsForMovements(tempstate, true);
          }
        }
      } else if (gridFlagVal === 'partialTrips') {
        const trueCount = Object.values(tempstate).filter(value => value === true).length;
        const selectedStateRowCount = Object.values(myselectedState).filter(value => value === true).length;
        if ((trueCount > 1) || (trueCount === 0 && selectedStateRowCount === 0) || (trueCount === 1 && selectedStateRowCount >= 1)) {
          setDisableReportIcon(true);
          setDisablePTContractOutIcon(true);
          setdisableCODepotHOSURMPTCSBIcons((trueCount === 0 && selectedStateRowCount === 0));
        } else if ((trueCount === 0 && selectedStateRowCount === 1) || (trueCount === 1 && selectedStateRowCount === 0)) {
          setDisableReportIcon(false);
          setDisablePTContractOutIcon(false);
          setdisableCODepotHOSURMPTCSBIcons(false);
        }
      } else if (gridFlagVal === 'routes' || gridFlagVal === 'ptmovements') {
        const myselectedStateCount = Object.values(myselectedState).filter(value => value === true).length;
        if (gridFlagVal === 'routes') {
          disabledIconsForRoutes(tempstate, myselectedStateCount);
        } else {
          const tempstateCount = Object.values(tempstate).filter(value => value === true).length;
          setDisableShipmentMovementScreenIcon(tempstateCount < 1 && myselectedStateCount < 1);
        }
      } else {
        setdisableCODepotHOSURMPTCSBIcons(false);
        setDisablePTCOIcon(false);
        setDisableReportIcon(false);
        setDisableRoutesScreenIcon(false);
        setDisableRoutesSetFreeIcon(false);
        setDisableMoveUpIcon(false);
        setDisableMoveDownIcon(false);
        setDisableShipmentMovementScreenIcon(false);
      }
    } else {
      if (gridFlagVal == 'partialTrips') {
        const obj = {
          tripNumber: 0,
          partialTrips: [],
          guid: guid,
          customView: customView
        };
        dispatch(setPartialTripReducer(obj));
      }
    };
  }

  const setMovementIconState = (report, coDepotHOSURMPTCSB, ptco, holdOnOff) => {
    setDisableReportIcon(report);
    setdisableCODepotHOSURMPTCSBIcons(coDepotHOSURMPTCSB);
    setDisablePTCOIcon(ptco);
    setDisableHoldOnOffIcon(holdOnOff);
  }

  // --- Callback methods END ---

  // --- API START ---
  // const fetchReadLinkData = (updatedViews, apiData) => {
  //   if (apiData !== null && apiData !== undefined && apiData.length > 0) {
  //     apiService.fetchReadLinkData(apiData[0]["userMetadata@odata.mediaReadLink"], apiData[0]["@odata.etag"]).then(response => {
  //       getReadLinkData(updatedViews, response);
  //     })
  //       .catch(error => {
  //         console.error('API error:', error);
  //       })
  //   }
  // }

  const getReadLinkData = (updatedViews, response) => {
    if (response !== null && response !== undefined) {
      const resData = response[gridFlagValFor];
      if (resData !== undefined && resData !== null) {
        updatedViews[gridFlagValFor].savedViews = resData.savedViews;
        updatedViews[gridFlagValFor].sortings = resData.sortings;
        // updatedViews[gridFlagValFor].columns = resData.columns;
        // sendDataToParent(resData.columns, "columnsVisible");
        if (resData?.actions?.toggleActions !== null && resData?.actions?.toggleActions !== undefined) {
          if (resData.actions.toggleActions.planRelatedAction !== null && resData.actions.toggleActions.planRelatedAction !== undefined) {
            Object.entries(resData.actions.toggleActions.planRelatedAction).map(([key, value]) => {
              if (key !== gridPlanAction?.find(x => x === key) && value === true) {
                resData.actions.toggleActions.planRelatedAction[key] = false;
              }
            })
          }

          if (resData.actions.toggleActions.dataRelatedAction !== null && resData.actions.toggleActions.dataRelatedAction !== undefined) {
            Object.entries(resData.actions.toggleActions.dataRelatedAction).map(([key, value]) => {
              if (key !== updatedGridDataAction?.find(x => x === key) && value === true) {
                resData.actions.toggleActions.dataRelatedAction[key] = false;
              }
            })
          }

          if (resData.actions.toggleActions.customAction !== null && resData.actions.toggleActions.customAction !== undefined) {
            Object.entries(resData.actions.toggleActions.customAction).map(([key, value]) => {
              if (key !== gridCustomActions?.find(x => x === key) && value === true) {
                resData.actions.toggleActions.customAction[key] = false;
              }
            })
          }
          const droppedItems = resData.actions.toggleActions?.actions;
          getToggleConfigData(droppedItems);
          setToggleconfigCheckboxes(resData.actions.toggleActions.dataRelatedAction);
          setToggleconfigcheckboxesplan(resData.actions.toggleActions.planRelatedAction);
          setToggleconfigCustomActioncheckboxes(resData.actions.toggleActions.customAction || {});
          updatedViews[gridFlagValFor].actions = resData.actions;
        }
        if (resData.measureFields?.tableRows !== null && resData.measureFields?.tableRows !== undefined) {
          setSelectedResponseTableRows(resData.measureFields.tableRows);
          updatedViews[gridFlagValFor].measureFields = resData.measureFields;
        }
      }

      localStorage.setItem(gridFlagValFor + 'Savedview', JSON.stringify(updatedViews));
      setSortKeyViews(updatedViews[gridFlagValFor].sortings || []);
      setTreeViewData(generateTreeViewData());

      if (!window.location.hash.includes("#/CreateCustomView")) {
        const defaultViewExist = updatedViews[gridFlagValFor]?.savedViews?.filter(item => item.defaultView);
        let filterIndex = 0;
        let viewIndex = updatedViews[gridFlagValFor]?.savedViews?.findIndex(item => item.defaultView);
        //Start -> Code for load default view in child screen of custom view
        if(data.isChild && window.location.hash.includes("#/CustomView") && gridFlagVal == 'partialTrips') {
          return
        }
        // End
        if (defaultViewExist?.length > 0 && defaultViewExist[0]?.subviews !== undefined) {
          const favFilterExist = defaultViewExist[0]?.subviews?.filter(subView => subView.isDefaultFilter);
          
          filterIndex = defaultViewExist[0]?.subviews?.findIndex(subView => subView.isDefaultFilter);
          if (favFilterExist?.length > 0) {
            loadSavedView(defaultViewExist[0], false, false, true);
          } else {
            loadSavedView(defaultViewExist[0], false, true, true);
          }
          setFlagShow(true);
          onFilterIconClick();
        } else if (defaultViewExist[0] !== undefined) {
          loadSavedView(defaultViewExist[0], false, false, true);
        } else {
          return;
        }
        
        if (filterIndex !== -1) {
          setSelectTreeView([viewIndex.toString(), `${viewIndex}_${filterIndex}`.toString()]);
        } else if (defaultViewExist?.length > 0 && defaultViewExist?.[0]?.subviews?.length > 0) {
          setSelectTreeView([viewIndex.toString(), `${viewIndex}_0`.toString()]);
        } else {
          setSelectTreeView([viewIndex.toString()]);
        }
        let ids = [defaultViewExist[0].viewName];
        setExpand({ids,idField: 'text'});
      }
    }
  }

  const fetchUpdateSavedViews = (title, savedViewData, isFromToggleConfig, showMsg) => {

    const viewsData = localStorage.getItem(gridFlagValFor + "Savedview");
    let updatedViews = viewsData ? JSON.parse(viewsData) : initialSavedViewObj;

    if (initialSaveViewData?.length > 0 && isFromToggleConfig === false) {
      if (initialFetchReadLinkData !== null) {
        getReadLinkData(updatedViews, initialFetchReadLinkData);
      } else {
        setSavedViewsApiData(initialSaveViewData);
      }
    } else {
      const filterUrl = (gridFlagVal !== "trip") ? `?$filter=(title eq '${title}' and userID eq '${userID}')` : null;
      const url = `${fetchSavedView}${filterUrl}`
      apiService.get(url).then(response => {
        if (response?.value?.length !== 0) {
          apiService.put(response.value[0]["userMetadata@odata.mediaReadLink"], response.value[0]["@odata.etag"], savedViewData).then(response => {
            if (showMsg) {
              setSuccessSnackbarAndMessage(i18_en.operationSuccessful);
            }
          })
        }
      })
        .catch(error => {
          console.error('API error:', error);
        })
    }

  }

  const postSavedViewsData = async (title) => {
    return await apiService.post(postSavedView,{ userID: userID, title: title }).then(response => {
      return response;
    })
      .catch(error => {
        console.error('API error:', error);
      });
  }

  // Table Rows Popup OK function call
  const grandTotalSum = (value) => {
    let col = value?.measureColumnsData?.map(item => item.field);
    saveTableRowsSelectedData(value?.measureColumnsData, value?.movMeasureTableColumns);
    setSelectedTableRows(col);
    resetHeaderFields(myselectedState, gridTempData, col);
  }

  const saveTableRowsSelectedData = (selectedColumns, columsOfTable) => {
    const views = localStorage.getItem(gridFlagValFor + 'Savedview');
    const updatedRows = views ? JSON.parse(views) : initialSavedViewObj;
    const saveSelectedColumns = {
      tableRows: selectedColumns,
      columsTable: columsOfTable
    };
    updatedRows[gridFlagValFor].measureFields = saveSelectedColumns;
    localStorage.setItem(gridFlagValFor + 'Savedview', JSON.stringify(updatedRows));

    if (gridFlagVal !== 'trip') {
      if (savedViewsApiData?.length == 0) {
        postSavedViewsData(gridFlagValFor).then(response => {
          fetchUpdateSavedViews(gridFlagValFor, updatedRows, true, false);
          setSavedViewsApiData(response);
        });
      } else {
        fetchUpdateSavedViews(gridFlagValFor, updatedRows, true, false);
      }
    }
  };

  // --- API END ---
  // For Accordian ---

  const [expanded, setExpanded] = React.useState('panel1');
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const toggleMyViewPanel = () => {
    if (isShow) {
      setExpanded((prevExpanded) => (prevExpanded === 'panel1' ? 'panel2' : 'panel1'));
    } else {
      setExpanded('panel1');
    }
  };
  // ------

  // --- Common method START ---

  const onRefreshIconClick = (flag = null) => {
    sendDataToParent(true, 'refresh');

    if (flag === 'manualRefresh') {
      const tempstate = JSON.parse(JSON.stringify(myselectedState));

      for (const key in tempstate) {
        if (!gridTempData?.data?.map(item => item.id)?.includes(key)) {
          delete tempstate[key];
        }
      }
      setMySelectedState(tempstate);
    }
    // setMyPartialSelectedState([]);
  }

  const onFilterIconClick = () => {
    setIsFilterable(!isFilterable);
  };

  const onColumnIconClick = () => {
    setOpenModalColumnsSelect(true);
  };

  const onSettingClick = (event) => {
    setOpenModalSort(true);
  };

  const onFreezeIconClick = (e) => {
    const views = localStorage.getItem(gridFlagValFor + 'Savedview');
    const updatedViews = views ? JSON.parse(views) : initialSavedViewObj;
    const columnsData = updatedViews[gridFlagValFor]?.measureFields?.tableRows ? updatedViews[gridFlagValFor].measureFields.tableRows : [];
    const movMeasureTableColumns = updatedViews[gridFlagValFor]?.measureFields?.columsTable ? updatedViews[gridFlagValFor].measureFields.columsTable : measureFilters.movMeasureTableColumns;

    const obj = {
      measureColumnsData: columnsData,
      movMeasureTableColumns: movMeasureTableColumns,
      draggedItem: {}
    }
    setMeasureFilters(obj);
    setOpenModalFreeze(true);
  };

  // const onSplitScreenClick = (val) => {
  //   setSplitScreen(val);
  // }

  const onPushpinIconClick = (event) => {
    sendDataToParent(!isShowGridHeader, 'showGridHeader');
    setActive(!isActive)
    const obj = {
      gridFlag: gridFlagVal,
      isPin: !isShowGridHeader,
    }
    dispatch(pinReducer(obj));
  }

  const setErrorParameterAndMessage = (errMsg) => {
    setCommonPopupParameters({
      title: 'Error'
    });
    setErrorMessage(errMsg);
    setopenConfirmationModal(true);
  }

  const setSuccessSnackbarAndMessage = (message, noDrillDown = true) => {
    setSuccessSnackbarMessage(message);
    setSuccessSnackbarOpen(true);
    if (noDrillDown) {
      setDrillDownFlagAndURL(false, '');
    }
  }

  const onDepotIconClick = (movmentkeys) => {
    callPlanFunctionAPIGridAPI(movmentkeys, null, InsertDepots, 'Select Transport Address', PlanFunctionsForFlag.Depot, 'Select Transport Address (Depot)');
  }

  const onHooksIconClick = (movmentkeys) => {
    callPlanFunctionAPIGridAPI(movmentkeys, null, insertHookOff, 'Select Transport Address', PlanFunctionsForFlag.HookOff, 'Select Transport Address (Hook Off)');
  };

  const onSetFreeIconClick = (movmentkeys) => {
    if (gridFlagVal === 'routes') {
      callPlanFunctionAPI(movmentkeys, null, postSetFreeRoutes, PlanFunctionsForFlag.SetFreeRoutes, i18_en.operationSuccessful);
    } else {
      callPlanFunctionAPI(movmentkeys, null, postSetfree, PlanFunctionsForFlag.SetFree, i18_en.operationSuccessful);
    }
  };

  const onDeleteDepotIconClick = (selectedIds) => {
    callPlanFunctionAPI(selectedIds, null, DeleteDepot, PlanFunctionsForFlag.DeleteDepot, i18_en.depotDeletedSuccessfully);
  }

  const onDeleteHooksIconClick = (selectedIds) => {
    callPlanFunctionAPI(selectedIds, null, DeleteHookOff, PlanFunctionsForFlag.DeleteHookOff, i18_en.hookOffSeletedSuccessfully);
  }

  const onCustomHooksIconClick = (selectedIds) => {
    callPlanFunctionAPI(selectedIds, null, customHookoff, PlanFunctionsForFlag.CustomHookOff, i18_en.operationSuccessful);
  }

  const onOnHoldOnOffIconClick = (selectedId) => {
    const obj = {
      "input": "{}"
    };
    setIsLoading(true);
    apiService.postWithId(baseUrl,gridFlagVal,selectedId, 'Microsoft.NAV.toggleOnHold', obj).then((response) => {
      if (response !== null && response !== undefined) {
        if (response.error !== null && response.error !== undefined) {
          setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
        } else {
          const result = JSON.parse(response?.value);
          if (service.apiOKResultChecker(result)) {
            setSuccessSnackbarAndMessage(i18_en.operationSuccessful);
            onRefreshIconClick();
            setMySelectedState([]);
            setMyPartialSelectedState([]);
          } else if (result !== null && result !== undefined && result.parameters[0].name === 'problemCode') {
            const title =result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning;
            setPopupParameters({
              title: title,
              result: response?.value,
              for: PlanFunctionsForFlag.OnHold,
              movementlines: selectedId
            });
            setdepotModalTital(title);
            setOpenModalDepot(true);
          }
        }
      }
    })
    .catch(error => {
      console.log('API error:', error);
    })
    .finally(() => {
      setIsLoading(false);
    });
  }

  const onInsertTerminalIconClick = (movmentkeys) => {
    callPlanFunctionAPIGridAPI(movmentkeys, null, InsertTerminals, 'Select Address', PlanFunctionsForFlag.InsertTerminals, 'Select Address (Terminal)');
  }

  const onDeleteTerminalIconClick = (selectedIds) => {
    callPlanFunctionAPI(selectedIds, null, DeleteTerminals, PlanFunctionsForFlag.DeleteTerminal, i18_en.terminalDeletedSuccessfully);
  }

  const onCalculateIconClick = (selectedId) => {
    setIsLoading(true);
    const param = {
      input: "{}"
    };
    apiService.postWithId(getPartialTrip,null,selectedId,'Microsoft.NAV.calculateIncludingActionTimes', param).then((response) => {
      if (response !== null && response !== undefined) {
        if (response.error !== null && response.error !== undefined && response.error) {
          setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
        } else {
          const result = JSON.parse(response?.value);
          if (service.apiResultChecker(result)) {
            const param = {
              title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
              parameters: result.parameters,
              for: PlanFunctionsForFlag.CalculateNotification
            };
            setopenConfirmationModal(true);
            setCommonPopupParameters(param);
            if (service.apiOKResultChecker(result)) {
              setSuccessSnackbarAndMessage(i18_en.operationSuccessful);
            }
          } else if (result?.parameters && result.parameters[0]?.type === 'Dialog.ConfirmSingleLine') {
            const param = {
              title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
              parameters: result.parameters,
              for: PlanFunctionsForFlag.CalculateConfirmation,
            };
            setopenConfirmationModal(true);
            setCommonPopupParameters(param);
          } else {
            if (service.apiOKResultChecker(result)) {
              setSuccessSnackbarAndMessage(i18_en.operationSuccessful);
            }
          }
        }
      }
    })
      .catch(error => {
        console.error('API error:', error);
      })
      .finally(() => {
        setIsLoading(false);
      })
  }

  const callPlanFunctionAPI = (selectedIds, requestParam, apiEndPointName, forFlag, successMessage = i18_en.operationSuccessful) => {
    const movementObjects = service.movementObject(selectedIds, gridFlagVal, requestParam);
    const obj = requestParam ? requestParam : service.movementLinesAndOperationDeatilObject(movementObjects, "{}", gridFlagVal);
    setIsLoading(true);
    apiService.post(apiEndPointName,obj).then(response => {
      if (response) {
        if (response.error) {
          setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
        } else {
          const result = JSON.parse(response?.operationDetail[0]?.result);
          const input = response.operationDetail[0]?.input ? JSON.parse(response.operationDetail[0]?.input) : null;
          if (result) {
            if (service.apiOKResultChecker(result)) {
              setSuccessSnackbarAndMessage(successMessage);
              if (forFlag === PlanFunctionsForFlag.SetFree) {
                sendDataToParent(null, 'sendApiForSmov');
                if (requestParam) {
                  dispatch(refreshPartialTrip({ isRefreshPartialTrip: true }));
                } else {
                  dispatch(refreshRouteGridData({ isRefreshRouteGridData: true }));
                }
              } else if (forFlag === PlanFunctionsForFlag.SetFreeRoutes) {
                sendDataToParent(null, 'sendApiForRoute');
                if (input?.deleteTripQuestion) {
                  dispatch(refreshPartialTrip({ isRefreshPartialTrip: true }));
                } else {
                  dispatch(refreshShipmentMovementGridData({ isRefreshShipmentMovementGridData: true }));
                }
              } else {
                onRefreshIconClick();
              }
              if (result.drillDownUrl) {
                if (forFlag === PlanFunctionsForFlag.CreateTrip) {
                  setDrillDownFlagAndURL(true, result.drillDownUrl);
                  setMySelectedState({});
                } else {
                  window.open(result.drillDownUrl, '_blank'); 
                }
              }
            } else if (result.parameters && (result.parameters[0]?.type === 'Dialog.SelectMenuSingle' || result.parameters[0]?.name === 'tripDate' || result.parameters[0]?.name === 'postponeDate'
              || (result.parameters[0]?.name === 'hookOffActionCode' && result.parameters[1]?.name === 'hookOnActionCode') || result.parameters[0].name === 'deleteTripQuestion'
              || result.parameters[0].name === 'alreadyPlannedWarning' || result.parameters[0].name === 'planOtherMovements' || result.parameters[0].name === 'planLimitExceeded')) {
              const param = {
                movementlines: movementObjects,
                title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
                parameters: result.parameters,
                for: forFlag,
                input: input,
                data: result.data
              };
              setopenConfirmationModal(true);
              setCommonPopupParameters(param);
            } else if (forFlag === PlanFunctionsForFlag.SetFreeRoutes && result.parameters && result.parameters[0]?.type.toLowerCase() === 'apigrid') {
              setPopupParameters({
                movementlines: movementObjects,
                title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
                result: response?.operationDetail[0]?.result,
                for: forFlag,
                input: response?.operationDetail[0]?.input,
                data: result.data
              });
              setdepotModalTital(i18_en.selectMovement);
              setOpenModalDepot(true);
              sendDataToParent(true, "openResModal");
            }
          }
        }
      }
    })
      .catch(error => {
        console.error('API error:', error);
      })
      .finally(() => {
        setIsLoading(false);
      })
  }

  const onCreateTripIconClick = (selectedIds) => {
    callPlanFunctionAPI(selectedIds, null, createTrips, PlanFunctionsForFlag.CreateTrip);
  }

  const onPostponeIconClick = (selectedIds) => {
    callPlanFunctionAPI(selectedIds, null, postponeMovements, PlanFunctionsForFlag.Postpone);
  }

  const onChangePlanDepartmentIconClick = (selectedIds) => {
    callPlanFunctionAPIGridAPI(selectedIds, null, ChangePlanDepartment, 'Select Department', PlanFunctionsForFlag.ChangePlanDepartment, 'Select Departments (Plan)');
  }

  const onChangePlanSubdepartmentIconClick = (selectedIds) => {
    callPlanFunctionAPIGridAPI(selectedIds, null, ChangePlanSubdepartment, 'Select Subdepartment', PlanFunctionsForFlag.ChangePlanSubdepartment, 'Select Sub Departments (Plan)');
  }

  const callPlanFunctionAPIGridAPI = (selectedIds, requestParam, apiEndPointName, title, forFlag, modalTital) => {
    const movementObjects = service.movementObject(selectedIds, gridFlagVal, requestParam);
    const obj = requestParam ? requestParam : service.movementLinesAndOperationDeatilObject(movementObjects, "{}", gridFlagVal);
    setIsLoading(true);
    apiService.post(apiEndPointName, obj).then(response => {
      if (response) {
        if (response.error) {
          setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
        } else {
          if (service.apiOKResultChecker(JSON.parse(response.operationDetail[0]?.result))) {
            setSuccessSnackbarAndMessage(i18_en.operationSuccessful);
            onRefreshIconClick();
          } else {
            setPopupParameters({
              title: title,
              for: forFlag,
              movementlines: movementObjects,
              result: response?.operationDetail[0]?.result,
              input: response?.operationDetail[0]?.input
            });
            setdepotModalTital(modalTital);
            setOpenModalDepot(true);
          }
        }
      }
    })
      .catch(error => {
        console.error('API error:', error);
      })
      .finally(() => {
        setIsLoading(false);
      })
  }

  const FilterCellRender = (props, column) => {
    const fieldName = props.field;
    let tempfield = filterSortArr.filterArray?.filter((e) => e.field == fieldName);
    const isFilterable = !nonFilterableColumnData?.includes(props.field);
    const val = tempfield.length > 0 ? tempfield[0].value : "";
    // let inputValue = val;
    const [inputValue, setInputValue] = useState(val);

    const isValidDateWithFormat = (dateString, format) => {
      const dateParts = dateString.split('-');

      if (dateParts.length !== 3) {
        return false;
      }

      const [year, month, day] = dateParts.map(Number);

      if (isNaN(year) || isNaN(month) || isNaN(day)) {
        return false;
      }
      if (month < 1 || month > 12) {
        return false;
      }
      if (year < 1900 || year > 2200) {
        return false;
      }
      const lastDayOfMonth = new Date(year, month, 0).getDate();
      if (day < 1 || day > lastDayOfMonth) {
        return false;
      }

      return true;
    }

    const FilterChangeForGrid = (e) => {
      const inputText = e.target.value;
      setInputValue(inputText)
      // setInputValue(inputText);
      let tempIndex = filterSortArr.filterArray?.findIndex((e) => e.field == fieldName);
      if (tempIndex == -1 && inputText == "") {
        return;
      }
      if (tempIndex != -1) {
        if (filterSortArr.filterArray[tempIndex].value == inputText) {
          return;
        }
        filterSortArr.filterArray[tempIndex].value = inputText;
      } else {
        filterSortArr.filterArray.push({
          field: fieldName,
          value: inputText,
          type: column.type,
          isFilter: true,
          isTime : timeFieldColumnData.includes(fieldName) ? true : false
        });
      }
      // const updatedFilterData = [...arrFilterData];
      // updatedFilterData.forEach(a => a.isViewFilter = false)
      // sendDataToParent(updatedFilterData, "arrFilterData");
      // setArrFilterData(arrFilterData)
    };

    // const FilterCheckboxChangeForGrid = (e) => {
    //   const inputText = event.target.checked ? "true" : "false";
    //   setInputValue(inputText);
    //   let tempIndex = filterSortArr.filterArray?.findIndex((e) => e.field == fieldName);
    //   if (tempIndex == -1 && inputText == "") {
    //     return;
    //   }
    //   if (tempIndex != -1) {
    //     if (filterSortArr.filterArray[tempIndex].value == inputText) {
    //       return;
    //     }
    //     filterSortArr.filterArray[tempIndex].value = inputText;
    //   } else {
    //     filterSortArr.filterArray.push({
    //       field: fieldName,
    //       value: inputText,
    //       type: column.type
    //     });
    //   }

    //   setFilterSortArr({ ...filterSortArr });
    //   setFocusField(fieldName)

    //   let tempselectedFields = _.cloneDeep(selectedFields)
    //   let index = tempselectedFields.findIndex((e) => e.name == fieldName);
    //   if (index != -1) {
    //     tempselectedFields[index].value = inputValue
    //     setSelectedFields(tempselectedFields);
    //   }
    // };

    let isFilteredByKeyEvent = false
    const onKeyPress = (e) => {
      if (e.nativeEvent.key == 'Enter') {
        if(fieldName == "planInfo") {
          sendDataToParent({ filter: filterSortUrl.filterUrl, orderby: service.convertSortToStringVal(filterSortArr.sortArray), columns: tempGridColumns, isApiCall: isApiCall }, 'getData');
        }
        
        filterGridData()
        isFilteredByKeyEvent = true
      }else{
        isFilteredByKeyEvent = false
      }
    };
    const onBlurHandler = (e)=>{
      let fName = ""
      if(e?.relatedTarget?.offsetParent?.getElementsByTagName('input')?.length > 0){
        fName = e?.relatedTarget?.offsetParent?.getElementsByTagName('input')[0]?.name;
      } else if (e?.relatedTarget?.name){
        fName = e?.relatedTarget?.name;
      }
      if(e?.relatedTarget && !tempGridColumns?.some(x => x?.field == fName)){
        setFocusField(null)
      } else if(fieldName != fName && tempGridColumns?.some(x => x?.field == fName)){
        setFocusField(fName)
      }
      if(!isFilteredByKeyEvent)
        filterGridData();
    }
    const onFocusHandler = (e)=>{
      if(e?.target?.name != focusField)
        setFocusField(e.target.name)
    }

    let title = "";
    if (props.field == 'startDate' || props.field == 'startingDate' || props.field == 'status') {
      title = "Configurable through default filters";
    } else if (column.type === 'Edm.Boolean' && isFilterable) {
      title = "Enter true or false as filter value";
    }
    return (
      <LightTooltip placement="bottom" title={title}>
      <input
      type="text"
      autoFocus={props.field == focusField}
        className="form-control td-w"
        style={{ border: dateErrorChecker[props.field] && '5px solid red' }}
        name={props.field}
        value={inputValue}
        disabled={props.field == 'startDate' || props.field == 'startingDate' || props.field == 'status' || !isFilterable}
        onKeyUp={(e) => onKeyPress(e)}
        onChange={(e) => FilterChangeForGrid(e)}
        onBlur={(e) => {onBlurHandler(e);}}
        onFocus={(e)=> onFocusHandler(e)}
              />
</LightTooltip>
    );
  };

  const filterGridData = () => {
    let filterUrl = '';
    let filterOrUrl = '';
    filterSortArr.filterArray.forEach((ele) => {
      let operator = "";
      let value = ele.value;
      let cmpValue = ele.value;
      const rangeMatch = ele.value.indexOf("..")

      if(ele.type === 'Edm.String' && ele.isFilter && value.slice(0,1) !== '@' && value !== '' && !ele.isTime) {
        value = '@'+value;
      }
      if(value === "" && ele.type == 'Edm.Date') {
        return
      }
      // const rangeMatch = ele.value.match(/^(\d+)\.{2}(\d+)$/);     
      if (rangeMatch != -1) {
        operator = "..";
      }
      else {
        const operatorMatch = ele.value.match(/[<>=!]+/);
        const pipeMatch = ele.value.match(/\|/);
        if (pipeMatch) {
          operator = "|";
        }
        if (operatorMatch) {
          const operatorIndex = operatorMatch.index;
          operator = ele.value.slice(operatorIndex, operatorIndex + operatorMatch[0].length);
          value = ele.value.slice(operatorIndex + operatorMatch[0].length);
          if(ele.type == 'Edm.Date'){
            value = moment(value,process.env.REACT_APP_MOMENTDATEFORMAT).format('yyyy-MM-DD')
          }
        }else{
          if(ele.type == 'Edm.Date'){
            value = moment(value,process.env.REACT_APP_MOMENTDATEFORMAT).format('yyyy-MM-DD')
          }
        }
      }
      if (value.trim() === "") {
        setFilteredData(gridLoadedGridData?.data);
      } else if (value === 'All' || (gridFlagVal === 'partialTrips' && ele.field === 'status' && value === '1')) { // Need to remove (value === '1) condition when getting status data in partial trip via API
        filterUrl += ' and ' + ele.field + " eq " + null;
      } else if (gridFlagVal === 'partialTrips' && ele.field === 'status' && value === '3') { // Need to remove this condition when getting status data in partial trip via API
        filterUrl += ' and ' + ele.field + " ne " + `'${filterCompValues[2].data[1].code}'`;
      } else {
        if (operator === "|") {
          if (typeof cmpValue === 'string' && (ele.type === 'Edm.Int32' || ele.type === 'Edm.Guid')) {

            const values = cmpValue.split(operator).map(value => value.trim());
            const orConditions = values.map(value => `${ele.field} eq ${value}`).join(' or ');
            filterUrl += ` and (${orConditions})`
          } else if (typeof cmpValue === 'string' && ele.type === 'Edm.String') {
            // console.log(cmpValue)
            const values = cmpValue.split(operator).map(value => value.trim());
            const orConditions = values.map(value => `${ele.field} eq ${"'" + value + "'"}`).join(' or ');
            filterUrl += ` and (${orConditions})`
          }
        } else if (operator === "<") {
          filterUrl += ' and ' + ele.field + ' lt ' + value;
        } else if (operator === "<=") {
          filterUrl += ' and ' + ele.field + ' le ' + value;
        } else if (operator === ">") {
          filterUrl += ' and ' + ele.field + ' gt ' + value;
        } else if (operator === ">=") {
          filterUrl += ' and ' + ele.field + ' ge ' + value;
        } else if (!operator || operator === "=") {
          if (typeof value === 'string' && ele.type === 'Edm.String') {
            const sanitizedEleType = ele.type.toLowerCase();
            if (sanitizedEleType.includes('string')) {
              filterUrl += " and " + ele.field + " eq " + "'" + value + "'";
            }
          } else if (typeof value === 'string' && (ele.type === 'Edm.Int32' || ele.type === 'Edm.Boolean' || ele.type === 'Edm.Decimal' || ele.type === 'Edm.Guid' || ele.type === 'Edm.Date')) {
            if (ele.type === 'Edm.Boolean') {
              value = value.toLocaleLowerCase();
            }
            if (ele.type === 'Edm.Guid' && ele.operator && ele.condition) {
              if (filterOrUrl) {
                filterOrUrl +=  ' ' + ele.operator + ' ' + ele.field + ' ' + ele.condition + ' ' + value;
              } else {
                filterOrUrl +=  ' ' + ele.field + ' ' + ele.condition + ' ' + value;
              }
            } else {
              filterUrl += " and " + ele.field + " eq " + value;
            }
          }
        } else if (operator === "!=") {
          if (typeof value === 'string' && ele.type === 'Edm.String') {
            filterUrl += " and " + ele.field + " ne " + "'" + value + "'";
          } else if (typeof value === 'string' && (ele.type === 'Edm.Int32' || ele.type === 'Edm.Guid')) {
            filterUrl += " and " + ele.field + " ne " + value;
          }
        } else if (operator === "..") {
          let start = moment(ele.value.split("..")[0],process.env.REACT_APP_MOMENTDATEFORMAT).format('yyyy-MM-DD')
          let end = moment(ele.value.split("..")[1],process.env.REACT_APP_MOMENTDATEFORMAT).format('yyyy-MM-DD')

          if (ele.type === 'Edm.Int32' || ele.type === 'Edm.Decimal') {
            start = start != "" && parseFloat(start);
            end = end != "" && parseFloat(end);
          }
          if (start && !_.isNil(start)) {
            filterUrl += " and " + ele.field + " ge " + start + " ";
          }
          if (end && !_.isNil(end)) {
            filterUrl += " and " + ele.field + " le " + end + " ";
          }
        } else {
          console.error("Invalid operator:", operator);
        }
      }
    })
    if (filterOrUrl) {
      if (filterUrl) {
        filterOrUrl = ' and ( ' + filterOrUrl + ' ) ';
      }
      filterUrl += filterOrUrl;
    }
    if (filterSortUrl.filterUrl != filterUrl.replace('and', '')) {
      setPage(initialPaging);
      setFilterSortUrl({ ...filterSortUrl, filterUrl: filterUrl.replace('and', ''), groupUrl: filterSortArr.groupArray });
    } else if (service.convertSortToStringVal(filterSortArr.sortArray) != filterSortUrl.sortUrl) {
      setFilterSortUrl({ ...filterSortUrl, sortUrl: service.convertSortToStringVal(filterSortArr.sortArray) ,groupUrl: filterSortArr.groupArray});
    } else if(filterSortArr.groupArray != filterSortUrl.groupUrl) {
      setFilterSortUrl({ ...filterSortUrl, groupUrl: filterSortArr.groupArray});
    }
  }

  const gridRowRender = (row, props) => {
    const partialSelectedState = myPartialSelectedState[props.dataItem.id];
    const editData = gridTempData?.data?.filter(item => item.id === props?.dataItem?.id);
    const isDraggableRow = data?.isDraggable ? props.dataItem.onHold || (gridFlagVal === 'movements' && gridFlagValFor === 'movements' && currentStatusVal?.toLowerCase() !== '0') ? false : true : false;
    return (
      <RowRender
        props={props}
        row={row}
        draggableProp={isDraggableRow}
        onDragStart={() => myOnDragStart(props)}
        onDrop={(e) => onDropRow(e, props)}
        customStyle={partialSelectedState ? { className: props.dataItem.onHold ? 'partialColor noselect' : 'partialColor' } : props.dataItem['colorPlanningHex'] ? { style: { backgroundColor: ('#' + props.dataItem['colorPlanningHex']), color: '#' + props.dataItem['textColorPlanningHex'], userSelect: (props?.dataItem?.onHold ? 'none' : 'auto')} } : { style: { backgroundColor: 'white', color: 'black', userSelect: (props?.dataItem?.onHold ? 'none' : 'auto') } }}
        exitEdit={exitEdit}
        editField={EDIT_FIELD}
        onEditCellValue={() => editData[0]?.inEdit === 'planInfo' && EditColumnData(editData[0]?.planInfo, props, "planInfo")}
        onRowClick={checkRowClick}
      />
    )
  };

  const headerRender = (props, column) => {
    const sortFields = myGridDataState?.sort && myGridDataState.sort?.map(item => item.field);
    const tempFilterData = filterSortArr.filterArray?.filter(e => e.value != "");
    const filterFields = tempFilterData?.map(item => item.field);
    return (
      <>
        <span {...props} className="sign-hi">
          {filterFields?.includes(props.field) &&
            <FilterAltIcon color='primary' sx={{ verticalAlign: 'middle', fontSize: '18px' }} />
          }
          <span style={{ paddingRight: "5px", display: "inline-flex", alignItems: "center", height: "14px"}}>{props.children}</span>
          <span>{props.title}</span>
        </span>
        {(sortFields?.includes(props.field)) &&
          <SignalCellular4BarIcon className="top-cornaer" />
        }
      </>
    );
  };

  const InfoCellMemo = useMemo(() => (props) => InfoCell(props), []);
  const CustomBooleanCellMemo = useMemo(() => (props) => CustomBooleanCell(props), []);

  const EditColumnData = (routeData, props, type) => {
    let data = {}
    if (type === "planInfo" || type === "routeGuideCode" || type === "planDepartment" || type === "planSubdepartment") {
      data[type] = routeData;
    }
    // if (editFieldVal !== routeData) {
    const url = `${baseUrl}/${gridFlagVal}(${props.dataItem.id})`
    apiService.patch(url, data, props.dataItem['@odata.etag']).then(response => {
      if (response.error === null || response.error === undefined) {
        let updateNewData = gridTempData.data.map((item) => {
          if (item.id === response.id) {
            return {
              ...item,
              "@odata.etag": response["@odata.etag"],
              [type]: response[type],
              [EDIT_FIELD]: undefined
            };
          } else {
            return item
          }
        })
        setSuccessSnackbarAndMessage(i18_en.operationSuccessful);
        setGridTempData({ data: updateNewData })
      } else {
        let updateNewData = gridTempData.data.map((item) => {
          if (item.id === props.dataItem.id && type === "planInfo") {
            return { ...item, planInfo: editFieldVal, [EDIT_FIELD]: undefined }
          } else {
            return item;
          }
        })
        setGridTempData({ data: updateNewData });
        setErrorParameterAndMessage(response?.error?.message.split('CorrelationId')[0]);
      }
    })
    // } else {
    //   let updateNewData = gridTempData.data.map((item) => {
    //     if (item.id === props.dataItem.id && type === "planInfo") {
    //       return { ...item, planInfo: editFieldVal, [EDIT_FIELD]: undefined }
    //     } else {
    //       return item;
    //     }
    //   })
    //   setGridTempData({ data: updateNewData });
    // }
  }

  const FilterCellDropDownRender = (props, column) => {
    const fieldName = props.field;
    let tempfield = filterSortArr.filterArray?.filter((e) => e.field == fieldName);
    const val = tempfield.length > 0 ? tempfield[0].value : "";
    const isFilterable = !nonFilterableColumnData?.includes(props.field);

    let data = [{name:" ",value:""}]
    data = data.concat(column.dropdownData)
    
    let dataValue = column.dropdownData.filter(e=>e.value === val)
    const [dropDownValue, setDropDownValue] = useState(dataValue[0]);

    const handleDropdownChange = (e) => {
      setDropDownValue(e.value)
      let tempIndex = filterSortArr.filterArray?.findIndex((e) => e.field == fieldName);
      if (tempIndex != -1) {
        if (filterSortArr.filterArray[tempIndex].value == e.value) {
          return;
        }
        filterSortArr.filterArray[tempIndex].value = e.value;
      } else {
        filterSortArr.filterArray.push({
          field: fieldName,
          value: e.value,
          type: 'Edm.String'
        });
      }
      setFilterSortArr({ ...filterSortArr });
    }
    const onBlurHandler = (e)=>{
      if(e?.target && !tempGridColumns?.some(x => x?.field == e?.target?.name)){
        setFocusField(null)
      }else if(fieldName != e?.target?.name && tempGridColumns?.some(x => x?.field == e?.target?.name)){
        setFocusField(e.target.name)
      }
    }
    const onFocusHandler = (e)=>{
      let name = e.target.id.split('-').pop();
      if(name != focusField)
        setFocusField(name)
    }
    
    return (

      <FormControl sx={{ m: 0, mt:'-.5', minWidth: 120,width:"100%",verticalAlign:"top"}}  className='k-grid-select' size="small">
        <Select
          autoFocus={props.field == focusField}
          value={dropDownValue?.value}
          disabled={!isFilterable}
          name={fieldName} 
          onBlur={(e) => onBlurHandler(e)} 
          onChange={(e) => handleDropdownChange(e.target)} 
          onFocus={(e)=> onFocusHandler(e)} 
          inputProps={{ 'aria-label': 'Without label' }}
          sx={{width:"100%",verticalAlign:'top'}}
          MenuProps={{ className: 'dropdownStyle'}}
        >
          <MenuItem value='' style={{minHeight:"30px"}}> </MenuItem>
          {
            column.dropdownData.map((elem)=>(
              <MenuItem value={elem.value} key={elem.value}>{elem.caption ? elem.caption : elem.name}</MenuItem>
            ))
          }
        </Select>
      </FormControl>
      // <select 
      //   name={fieldName} 
      //   className="form-control td-w"
      //   value={dropDownValue?.name} 
      //   autoFocus={props.field == focusField} 
      //   onBlur={(e) => onBlurHandler(e)} 
      //   onChange={(e) => handleDropdownChange(e.target)}
      //   onFocus={(e)=> onFocusHandler(e)}
      // >
      //   {
      //     data.map((elem)=>(
      //       <option value={elem.name}>{elem.name}</option>
      //     ))
      //   }
      // </select>
    )
  }

  const renderColumn = (column, index, data, dataField) => {
    const isEditable = editableColumn?.includes(column?.field);
    
    const handleCellClick = (event, type) => {
      setEditableCell(event?.dataItem?.id);
      setEditField(type);
    };

    return (
      <Column
        key={index}
        headerCell={(e) => headerRender(e, column)}
        headerClassName={column.locked ? "leftsty" : "left0"}
        {...column}
        editable={isEditable}
        filterCell={(e) => FilterCellRender(e, column)}
        cell={(props) => {
          const { className, style, dataItem } = props;
          const isCurrentCellEditable = editableCell === dataItem?.id && editField === column?.field;
  
          const handleBlur = (value) => {
            if (value !== undefined && value !== dataItem[dataField]) {
              EditColumnData(value, props, column.field);
              props.onChange(value);
            }
            setEditableCell(null);
          };
  
          return (
            <td 
              onClick={() => handleCellClick(props, column.field)} 
              className={className} 
              style={style}
            >
              {isCurrentCellEditable ? (
                <DropDownRender
                  data={data}
                  value={dataItem[dataField]}
                  disabled={!isEditable}
                  onBlur={handleBlur}
                />
              ) : (
                <div>{dataItem[dataField]}</div>
              )}
            </td>
          );
        }}
        locked={column.locked}
      />
    );
  };

  const columnRender = (column, index) => {
    if(nonSortableColumnData.includes(column.field))
      column.sortable = false 
    let format = ""
    if (column.type == 'Edm.Date') {
      format = `{0:${process.env.REACT_APP_DATEFORMAT}}`;
    } else if (column.type == 'Edm.DateTimeOffset') {
      format = `{0:${process.env.REACT_APP_DATETIMEFORMAT}}`;
    }
    if (column.field == "ActionColumn") {
      return (
        <Column
          key={index}
          locked={column.locked}
          headerClassName={
            (column.locked ? "leftsty" : "left0 k-text-center")
          }
          sortable={false}
          className="k-text-center"
          filterCell={e => FilterCellRender(e, column)}
          field={column.field}
          title={column.title}
          width="45px"
          resizable={false}
          reorderable={false}
          cells={{
            data: InfoCellMemo,
            gridFlagVal: gridFlagVal,
            setErrorParameterAndMessage : setErrorParameterAndMessage
          }}
          //width={column.width}
        />
      );
    } else if (column.field == "qualificationsExist") {
      return (
        <Column
          key={index}
          headerCell={e => headerRender(e, column)}
          headerClassName={
            (column.locked ? "leftsty" : "left0 k-text-center")
          }
          className="k-text-center"
          filterCell={e => FilterCellRender(e, column)}
          {...column}
          locked={column.locked}
          cells={{
            data: customQualificationCellMemo
          }}
          //width={column.width}
          width="87px"
          resizable={false}
          reorderable={false}
          onContextMenu={handleContextMenu}
        />
      );
    } else if (column.field == "instructionsExist") {
      return (
        <Column
          key={index}
          headerCell={e => headerRender(e, column)}
          headerClassName={
            (column.locked ? "leftsty" : "left0 k-text-center")
          }
          className="k-text-center"
          filterCell={e => FilterCellRender(e, column)}
          {...column}
          locked={column.locked}
          cells={{
            data: CustomInfoCell,
            gridFlagVal: gridFlagVal
          }}
          //width={column.width}
          width="77px"
          resizable={false}
          reorderable={false}
          onContextMenu={handleContextMenu}
        />)
    } else if (
      (gridFlagVal === 'movements' && gridFlagValFor === 'movements' && column.field === "routeGuideCode") ||
      (gridFlagVal === 'movements' && gridFlagValFor === 'movements' && column.field === "planDepartment") ||
      (gridFlagVal === 'movements' && gridFlagValFor === 'movements' && column.field === "planSubdepartment")
    ) {
      let data, dataField;
      if (column.field === "routeGuideCode") {
        data = routeGuidesData;
        dataField = "routeGuideCode";
      } else if (column.field === "planDepartment") {
        data = planDepartmentData;
        dataField = "planDepartment";
      } else if (column.field === "planSubdepartment") {
        data = planSubdepartmentData;
        dataField = "planSubdepartment";
      }
    
      return renderColumn(column, index, data, dataField);
    } else if ( gridFlagVal == 'partialTrips' && (column.field === "driver" || column.field === "vehicleCode" || column.field === "trailerCode" || column.field === "chassis" || column.field === "variousResCode" || column.field === "subcontractorCode")) {
      return <Column key={index}
        headerClassName={(column.locked ? "leftsty" : "left0")}
        headerCell={e => headerRender(e, column)}
        {...column}
        editable={editableColumn && editableColumn.includes(column.field) ? true : false}
        cell={addResourceColumnRender}
        filterCell={e => FilterCellRender(e, column)}
      />;
    } else if (column.type === 'Edm.Boolean') {
      return (<Column key={index}
        headerCell={e => headerRender(e, column)}
        headerClassName={(column.locked ? "leftsty" : "left0")}
        {...column}
        // width="120px"
        editable={editableColumn && editableColumn.includes(column.field) ? true : false}
        cells={{
          data: CustomBooleanCellMemo,
          column: column
        }
        }
        filterCell={e => FilterCellRender(e, column)}
        locked={column.locked}
      />);
    } else if(column.type.startsWith("Microsoft.NAV.")) {
      return (
        <Column
          key={index}
          headerCell={e => headerRender(e, column)}
          headerClassName={(column.locked ? "leftsty" : "left0")}
          {...column}
          editable={editableColumn && editableColumn.includes(column.field) ? true : false}
          filterCell={e => FilterCellDropDownRender(e, column)}
          locked={column.locked}
          format={format}
        />
      );
    } else {
      return (
        <Column
          key={index}
          headerCell={e => headerRender(e, column)}
          headerClassName={
            (column.locked ? "leftsty" : "left0")
          }
          {...column}
          editable={editableColumn && editableColumn.includes(column.field) ? true : false}
          filterCell={e => FilterCellRender(e, column)}
          locked={column.locked}
          format={format}
        />
      );
    }
  };

  const addResourceApi = (data) => {
    if (Object.entries(data).length !== 0) {
      let obj = {};
      if (resourceType === "driver") {
        obj = {
          resourceType: 'DRIVERS',
          resourceCode: data.codeDriver
        }
      } else if (resourceType === "vehicleCode") {
        obj = {
          resourceType: 'VEHICLES',
          resourceCode: data.codeVehicle
        }
      } else if (resourceType === "trailerCode") {
        obj = {
          resourceType: 'TRAILERS',
          resourceCode: data.codeTrailer
        }
      } else if (resourceType === "chassis") {
        obj = {
          resourceType: 'CHASSIS',
          resourceCode: data.codeTrailer
        }
      } else if (resourceType === "variousResCode") {
        obj = {
          resourceType: 'VARIOUS',
          resourceCode: data.codeResource
        }
      } else {
        obj = {
          resourceType: 'SUBCONTRACTORS',
          resourceCode: data.codeSubcontractor
        }
      }
      callAPIChangePtResource(obj);
    } else {
      closePopupFilter();
    }
  }

  const callAPIChangePtResource = (obj) => {
    const url = `${baseUrl}/partialTrips(${onClickRowData})/Microsoft.NAV.changePtResource`;
    const param = {
      input: JSON.stringify(obj)
    }
    setIsLoading(true);
    apiService.post(url, param).then(response => {
      if (response !== null && response !== undefined) {
        if (response.error) {
          setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
        } else {
          const result = JSON.parse(response?.value);
          if (result.parameters !== null && result.parameters !== undefined && result.parameters[0].type === 'Dialog.ConfirmSingleLine') {
            const param = {
              title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
              description: result.parameters[0].content,
              for: PlanFunctionsForFlag.ChangePTResourceConfirmation,
              parameters: result.parameters,
              result: result,
              obj: obj
            }
            setopenConfirmationModal(true);
            setCommonPopupParameters(param);
          } else if (service.apiOKResultChecker(result)) {
            setSuccessSnackbarAndMessage(i18_en.operationSuccessful);
            setopenConfirmationModal(false);
            dispatch(setAgendaResource(obj?.resourceCode))
				    onRefreshIconClick();
            closePopupFilter();
          }
        }
      }
    })
    .catch(error => {
      console.error('API error:', error);
    })
    .finally(() => {
      setIsLoading(false);
    })
  }

  const addResourceColumnRender = (props) => {
    const handleClick = (type) => {
      let tempstate = {}
      tempstate['' + props.dataItem.id] = true;
      setMyPartialSelectedState(tempstate);

      if (type === "driver")
        setResourceData(props?.dataItem?.driver !== "" ? props?.dataItem?.driver : null)
      else if (type === "vehicleCode")
        setResourceData(props?.dataItem?.vehicleCode !== "" ? props?.dataItem?.vehicleCode : null)
      else if (type === "trailerCode")
        setResourceData(props?.dataItem?.trailerCode !== "" ? props?.dataItem?.trailerCode : null)
      else if (type === "chassis")
        setResourceData(props?.dataItem?.chassis !== "" ? props?.dataItem?.chassis : null)
      else if (type === "variousResCode")
        setResourceData(props?.dataItem?.variousResCode !== "" ? props?.dataItem?.variousResCode : null)
      else if (type === "subcontractorCode")
        setResourceData(props?.dataItem?.subcontractorCode !== "" ? props?.dataItem?.subcontractorCode : null)

      setEtag(props.dataItem['@odata.etag'])
      setResourceType(type)
      setOpenAddColumnModal(true)
      setOnClickRowData(props.dataItem.id)
      sendDataToParent(true, "openResModal");
    };
    return (
      <td style={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={(e) => handleClick(props.field)}>
        <Button variant="outlined" size="small" sx={{ height: '22px' }} style={{ color: 'black' }}>
          {props.dataItem[props.field] === "" ? "Add" : props.dataItem[props.field]}
        </Button>
      </td>
    );
  };

  const myOnSelectionChange = (event) => {
    setMyPartialSelectedState({})
    if (data.gridOnSelectionChange) {
      data.gridOnSelectionChange(event);
    } else {
      if (event.dataItem?.onHold) {
        return;
      }
      if (gridFlagVal === 'movements' && gridFlagValFor === 'movements' && currentStatusVal?.toLowerCase() !== '0') {
        return;
      }
      let tempSelectedState = getSelectedState({
        event,
        selectedState: myselectedState,
        dataItemKey: griddDtaItemKey,
      });
      if (selectableMode === "single") {
        if (Object.keys(myselectedState)?.[0] === Object.keys(tempSelectedState)?.[0]) {
          tempSelectedState = {};
        } else {
          let dataItem = gridTempData.data.find((elem) => elem.id === Object.keys(tempSelectedState)[0])
          sendDataToParent(event?.dataItem ? event?.dataItem : dataItem, "dataItem")
        }
      }
      setTimeout(() => {
        setMySelectedState(tempSelectedState, gridTempData);
      }, 10)

    }
  }

  const myOnHeaderSelectionChange = (event) => {
    if (data.gridDraggable === false) {
      return;
    }
    setMyPartialSelectedState({});
    if (data.gridOnHeaderSelectionChange) {
      data.gridOnHeaderSelectionChange(event);
    } else {
      const checkboxElement = event.syntheticEvent.target;
      const checked = checkboxElement.checked;
      const tempSelectedState = {};
      gridTempData?.data?.forEach((item) => {
        if (!item?.onHold) {
          tempSelectedState[myGrididGetter(item)] = checked;
        }
      });
      setTimeout(() => {
        setMySelectedState(tempSelectedState, gridTempData);
      }, 10)
    }
  };

  const mygridCheckHeaderSelectionValue = () => {
    if (data.gridCheckHeaderSelectionValue) {
      return data.gridCheckHeaderSelectionValue();
    } else {
      return checkHeaderSelectionValue()
    }
  }
  const checkHeaderSelectionValue = () => {
    if (gridTempData?.data) {
      let selectedItems = Object.entries(myselectedState).filter(([key, value]) => value === true).map(([key]) => key).length;
      // Object.keys(myselectedState).length//getNumberOfSelectedItems(gridTempData?.data);
      return gridTempData?.data.length > 0 && selectedItems == getNumberOfItems(gridTempData?.data.filter(item => !item?.onHold));
    }
  };

  const getNumberOfSelectedItems = (data) => {
    let count = 0;
    data.forEach((item) => {
      if (item.items) {
        if (item.expanded) {
          count = count + getNumberOfSelectedItems(item.items);
        }
      } else {
        count = count + (item.selected == true ? 1 : 0);
      }
    });
    return count;
  };

  const getNumberOfItems = (data) => {
    let count = 0;
    data.forEach((item) => {
      if (item?.items) {
        if (item.expanded) {
          count = count + getNumberOfItems(item.items);
        }
      } else {
        count++;
      }
    });
    return count;
  };

  const resetHeaderFields = (state, griddata, selectedCol) => {
    if (gridFlagVal == "movements") {
      try {
        const newData = griddata?.data ? griddata.data : griddata
        const selectedData = service.getMembers(newData).filter(
          (item) => state[myGrididGetter(item)]
        );
        const selectedMovementsSum = selectedData.length;
        const totalMovementsSum = newData.length;
        const selectedNetWeightSum = selectedData.reduce((sum, item) => sum + item["netWeight"], 0);
        const totalNetWeightSum = newData?.reduce((sum, item) => sum + item["netWeight"], 0);
        const selectedVolumeSum = selectedData.reduce((sum, item) => sum + item["volume"], 0);
        const totalVolumeSum = newData?.reduce((sum, item) => sum + item["volume"], 0);
        const selectedLLSum = selectedData.reduce((sum, item) => sum + item["loadingLength"], 0);
        const totalLLSum = newData?.reduce((sum, item) => sum + item["loadingLength"], 0);
        const selectedWeightSum = selectedData.reduce((sum, item) => sum + item["weight"], 0);
        const totalWeightSum = newData?.reduce((sum, item) => sum + item["weight"], 0);
        const selectedQuantitySum = selectedData.reduce((sum, item) => sum + item["quantity"], 0);
        const totalQuantitySum = newData?.reduce((sum, item) => sum + item["quantity"], 0);
        const measurementField = (selectedCol !== null && selectedCol !== undefined ? selectedCol : selectedTableRows); // localStorage.getItem('measurementData');

        dispatch(updateSelectedSums({
          selectedMovementsSum, totalMovementsSum, selectedNetWeightSum, totalNetWeightSum, selectedVolumeSum,
          totalVolumeSum, selectedLLSum, totalLLSum, selectedWeightSum, totalWeightSum, selectedQuantitySum, totalQuantitySum, measurementField
        }));
      }
      catch {
        return null;
      }
    }
  };

  const getSelectedValues = (tempstate = null, isOnlySelectedRows = false) => {
    if (tempstate) {
      return Object.keys(tempstate).filter((key) => tempstate[key] === true);
    } else {
      const selectedRows = Object.keys(myselectedState).filter((key) => myselectedState[key] === true);
      if (!isOnlySelectedRows) {
        const partialSelectedRows = Object.keys(myPartialSelectedState).filter((key) => myPartialSelectedState[key] === true);
        for (const partialSelectedRow of partialSelectedRows) {
          if (selectedRows.findIndex(selectedRow => partialSelectedRow === selectedRow) === -1) {
            selectedRows.push(partialSelectedRow);
          }
        }
      }
      return selectedRows;
    }
  };

  const setSelectedValue = (data, tempSelectedState) => {
    if (data) {
      let newData = data.map((item) => {
        if (item?.items) {
          return {
            ...item,
            items: setSelectedValue(item.items, tempSelectedState),
          };
        } else {
          return {
            ...item,
            ["selected"]: tempSelectedState[myGrididGetter(item)],
          };
        }
      });
      return newData;
    }
    return []
  };

  const updateColumnsObj = (selectedColumns, tempColumns) => {
    const obj1Map = new Map(selectedColumns.map(item => [item.field, item]));

    const columnsData = tempColumns.map(item2 => {
      const matchedItem1 = obj1Map.get(item2.field);
      return matchedItem1 ? { ...matchedItem1, ...item2 } : null;
    }).filter(Boolean);

    for (const item1 of selectedColumns) {
      if (!columnsData.find(item2 => item2.field === item1.field)) {
        columnsData.push(item1);
      }
    }

    return columnsData;
  };

  const saveColumnsSelectedData = (value, flag) => {
    if (flag === 'filteredData') {
      if(selectTreeView[0] == '' && gridFlagVal != 'routes' && gridFlagVal != 'ptmovements') {
        const indexes = cards?.reduce((acc, item, index) => {
            if (value.findIndex(({ field }) => field === item.field) === -1) {
                acc.push(index);
            }
            return acc;
        }, []);
        if(indexes.length > 0)
          removeCard(indexes[0])
      }

      const gridColumnsObj = updateColumnsObj(value, tempGridColumns);
      const reorderVal = _.sortBy(gridColumnsObj, function (colItem) {
        const index = reorderedCols?.indexOf(colItem.field);
        // If the column is not found in reorderedCols, place it at the end
        return index !== -1 ? index : reorderedCols?.length;
      });
      const sortData = myGridDataState?.sort?.filter(e => gridColumnsObj?.map(x => x.field).indexOf(e.field) != -1);
      reorderVal?.forEach((item, index) => {
        item.orderIndex = index + 1;
      });
      setTempGridColumns(reorderVal);

      const unSelectedColumnsSet = new Set(gridColumnsObj?.map(data => data.field));
      let unSelectedColumns = gridColumnList.filter(item => !unSelectedColumnsSet.has(item.field)).map(data => data.field);
      const tarrFilterData = _.cloneDeep(filterSortArr.filterArray);
      unSelectedColumns = unSelectedColumns?.filter(item => !filterCompValues?.map(item => item.key).includes(item));

      // Loop through each item in unSelectedColumns and remove corresponding elements from filterArray
      unSelectedColumns.forEach(column => {
        const index = tarrFilterData.findIndex(item => item.field === column);
        if (index !== -1) {
          tarrFilterData.splice(index, 1);
        }
      });
      setFilterSortArr({ filterArray: tarrFilterData, sortArray: sortData });
      sendDataToParent(reorderVal, "columnsVisible");
      setGridKey(gridKey + 1);
    }
    if (flag === 'gridSort') {
      setmyGridDataState({ ...myGridDataState, sort: value });
    }
  };

  const saveFilteredPopUpData = (value, flag) => {
    if (flag === 'SaveFilteredData') {
      if (gridFlagVal !== 'trip') {
        if (savedViewsApiData?.length == 0) {
          postSavedViewsData(gridFlagValFor).then(response => {
            fetchUpdateSavedViews(gridFlagValFor, value.updatedViews, true, true);
            setSavedViewsApiData(response);
          });
        } else {
          fetchUpdateSavedViews(gridFlagValFor, value.updatedViews, true, true);
        }
      }
      setTreeViewData(generateTreeViewData());
      
      // highlighted save view/filter
      const updatedSavedView = value?.updatedViews[gridFlagValFor]?.savedViews;
      let viewIndex = updatedSavedView?.findIndex(item => item.viewName === value.viewName) ?? -1;
      let filterIndex = viewIndex !== -1 && updatedSavedView[viewIndex].subviews
        ? updatedSavedView[viewIndex].subviews.findIndex(item => item.viewName === value.filterName)
        : -1;

      setSelectTreeView(filterIndex !== -1 ? [viewIndex.toString(), `${viewIndex}_${filterIndex}`.toString()] : [viewIndex.toString()]);
      setExpand({ ids: [value.viewName], idField: 'text' });
    }
  }

  const saveToggleActionSelectedData = (flag, checkboxSelected) => {
    const views = localStorage.getItem(gridFlagValFor + 'Savedview');
    const updatedView = views ? JSON.parse(views) : initialSavedViewObj;
    const toggleActions = {
      toggleActions: {
        dataRelatedAction: flag === 'Data' ? checkboxSelected : toggleconfigcheckboxes,
        planRelatedAction: flag === 'Plan' ? checkboxSelected : toggleconfigcheckboxesplan,
        customAction: flag === 'CustomAction' ? checkboxSelected : toggleconfigCustomActioncheckboxes,
        actions: flag === 'Action' ? checkboxSelected : toggleconfigActions
      }
    };
    updatedView[gridFlagValFor].actions = toggleActions;

    localStorage.setItem(gridFlagValFor + 'Savedview', JSON.stringify(updatedView));

    if (gridFlagVal !== 'trip') {
      if (savedViewsApiData?.length == 0) {
        postSavedViewsData(gridFlagValFor).then(response => {
          fetchUpdateSavedViews(gridFlagValFor, updatedView, true, false);
          setSavedViewsApiData(response);
        });
      } else {
        fetchUpdateSavedViews(gridFlagValFor, updatedView, true, false);
      }
    }
  };

  const closePopupFilter = () => {
    setOpenModalSort(false);
    setOpenAddColumnModal(false);
    setOpenModalFreeze(false);
    storageService.setLocalStorageData('currentActive', gridFlagValFor);
    sendDataToParent(false, "openResModal");
  };

  const closePopupDepot = (response, forFlag) => {
    if (response !== null && response !== undefined) {
      let isRefreshAndSuccessSnackbarAndMessage = false;
      if (forFlag === PlanFunctionsForFlag.InsertTerminals) {
        callPlanFunctionAPIGridAPI(null, response, InsertTerminals, i18_en.insertTerminal, forFlag, i18_en.selectLastActionBeforeInsertDepot);
      } else {
        if (response.operationDetail !== null && response.operationDetail !== undefined && response.operationDetail.length > 0) {
          const result = JSON.parse(response.operationDetail[0]?.result)
          if (service.apiOKResultChecker(result)) {
            isRefreshAndSuccessSnackbarAndMessage = true;
          }
        } else if (response.data?.operationDetail !== null && response.data?.operationDetail !== undefined && response.data?.operationDetail.length > 0) {
          if (service.apiOKResultChecker(JSON.parse(response.data?.operationDetail[0]?.result))) {
            isRefreshAndSuccessSnackbarAndMessage = true;
          }
        }
      }

      if (response.value !== null && response.value !== undefined) {
        if (service.apiOKResultChecker(JSON.parse(response.value))) {
          isRefreshAndSuccessSnackbarAndMessage = true;
        }
      }

      if (isRefreshAndSuccessSnackbarAndMessage) {
        setSuccessSnackbarAndMessage(i18_en.operationSuccessful);
        if (forFlag === PlanFunctionsForFlag.SetFreeRoutes) {
          sendDataToParent(null, 'sendApiForRoute');
          const input = response.operationDetail[0]?.input ? JSON.parse(response.operationDetail[0]?.input) : null;
          if (input?.deleteTripQuestion) {
            dispatch(refreshPartialTrip({ isRefreshPartialTrip: true }));
          } else {
            dispatch(refreshShipmentMovementGridData({ isRefreshShipmentMovementGridData: true }));
          }
        } else {
          onRefreshIconClick();
        }
        setMySelectedState([]);
        setMyPartialSelectedState([]);
      }
    }
    setOpenModalDepot(false)    
    storageService.setLocalStorageData('currentActive', gridFlagValFor);
  };

  const handleSuccessSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSuccessSnackbarOpen(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorSnackbarOpen(false);
  };

  const createTreeHierarchicalData = (data, arr) => {
    if (data) {
      let newData = data.map((item) => {
        if (item.items[0]?.field) {
          arr.push(item.groupId)
          return {
            ...item,
            items: createTreeHierarchicalData(item.items, arr),
            count: item.items.length
          };
        } else {
          let obj = {
            ...item,
            items: [],
            count: item.items.length
          };
          return obj;
        }
      });
      return newData;
    }
  };


  // Template for Tree view -- Grouping start

  const treeViewGroupItem = (props) => {
    let measureField = (selectedTableRows !== null && selectedTableRows !== undefined && selectedTableRows.length > 0) ? selectedTableRows : null;
    let value = props.item.value;
    const col = gridColumns.find(e => e.field == props.item.field)
    if (props.item.value == "") {
      value = "*BLANK*"
    } else if (_.isDate(props.item.value)) {
      let format = `${process.env.REACT_APP_MOMENTDATEFORMAT}`;
      if (col?.type == 'Edm.DateTimeOffset') {
        format = `${process.env.REACT_APP_MOMENTDATETIMEFORMAT}`;
      }
      value = moment(props.item.value).format(format)
    }

    let tooltipTemplate = (
      <>

        <Box sx={{ fontSize: 15 }}>
          {col?.title} : ({props.item.count})
        </Box>
        <Box style={{ marginLeft: '0px', display: 'flex', flexFlow: 'row', flexWrap: 'wrap' }}>

          {measureField?.includes("LoadingLength") && props.item?.aggregates.loadingLength &&
            <span style={{ padding: '2px', width: '50%', display: 'flex', fontSize: '12px' }}>
              <span style={{ width: '65px' }}> LL (lm) </span>
              :{" "} {props.item?.aggregates.loadingLength.sum.toFixed(2)}
            </span>}
          {measureField?.includes("Volume") && props.item?.aggregates.volume &&
            <span style={{ padding: '2px', width: '50%', display: 'flex', fontSize: '12px' }}>
              <span style={{ width: '65px' }}>Vol. (m3)</span>
              :{" "} {props.item?.aggregates.volume.sum.toFixed(2)}
            </span>
          }
          {measureField?.includes("Weight") && props.item?.aggregates.weight &&
            <span style={{ padding: '2px', width: '50%', display: 'flex', fontSize: '12px' }}>
              <span style={{ width: '65px' }}>W (kg) </span>
              :{" "} {props.item?.aggregates.weight.sum.toFixed(2)}
            </span>
          }
          {measureField?.includes("Quantity") && props.item?.aggregates.quantity &&
            <span style={{ padding: '2px', width: '50%', display: 'flex', fontSize: '12px' }}>
              <span style={{ width: '65px' }}>Qty. (No.) </span>
              :{" "} {props.item?.aggregates.quantity.sum.toFixed(2)}
            </span>
          }
          {measureField?.includes("NetWeight") && props.item?.aggregates.netWeight &&
            <span style={{ padding: '2px', width: '50%', display: 'flex', fontSize: '12px' }}>
              <span style={{ width: '65px' }}>Nw. (kg) </span>
              :{" "} {props.item?.aggregates.netWeight.sum.toFixed(2)}
            </span>
          }
        </Box>
      </>
    );
    return (
      <>
        {/* <span style={{ width: '100%', display: 'flex' }} onClick={() => onTreeviewGroupItemClick(props)}>{props.item.field} : {props.item.value == "" ? "--BLANK--": props.item.value} ({props.item.count})</span> */}


        <span style={{ width: '100%', display: 'flex' }} className={(treeviewSelectedValues?.groupId == props.item.groupId) ? 'highlighted-node' : 'node'} onClick={() => onTreeviewGroupItemClick(props)}>
          <LightTooltip placement="right" title={tooltipTemplate}><span>{value} ({props.item.count})</span></LightTooltip>
          {measureField && <Box sx={{ display: 'flex', gap: '2px', marginLeft: '5px', width: '400px' }}>

            {measureField?.includes("LoadingLength") && props.item?.aggregates.loadingLength &&
              <span class="measure">LL
                :{" "} {props.item?.aggregates.loadingLength.sum.toFixed(2)}
              </span>
            }
            {measureField?.includes("Volume") && props.item?.aggregates.volume &&
              <span class="measure">Vol.
                :{" "} {props.item?.aggregates.volume.sum.toFixed(2)}
              </span>
            }
            {measureField?.includes("Weight") && props.item?.aggregates.weight &&
              <span class="measure">W
                :{" "} {props.item?.aggregates.weight.sum.toFixed(2)}
              </span>
            }
            {measureField?.includes("Quantity") && props.item?.aggregates.quantity &&
              <span class="measure">Qty.
                :{" "} {props.item?.aggregates.quantity.sum.toFixed(2)}
              </span>
            }
            {measureField?.includes("NetWeight") && props.item?.aggregates.netWeight &&
              <span class="measure">Nw.
                :{" "} {props.item?.aggregates.netWeight.sum.toFixed(2)}
              </span>
            }
          </Box>}
        </span>

      </>
    );
  };


  const multiLevelFilter = (data, id, index) => {
    const rowData = groupTreeviewRef.current.getItemById(id);
    if (_.isNil(id) || id == "") {
      return data;
    } else {
      let newdata = data.filter(e => e[rowData.field] == rowData.value);
      if (_.isDate(rowData.value)) {
        newdata = data.filter(e => e[rowData.field].toISOString() == rowData.value.toISOString())
      }
      const rowId = id.split('_').splice(0, id.split('_').length - 1).join('_')
      return multiLevelFilter(newdata, rowId, index + 1)
    }
  };

  const onTreeviewGroupItemClick = (props) => {
    if (props.item.items == 0) {
      setSelectedGrpTreeView(props)
      const o = multiLevelFilter([...loadedGridData || []], props.itemHierarchicalIndex, 0)
      setMySelectedState([])
      setTreeviewSelectedValues(props.item);
      setGridTempData(service.processWithGroups(o, { sort: myGridDataState?.sort }))
    }
  };

  const onExpandGroup = (event) => {
    // const onExpandChange = event => {
    //     event.item.expanded = !event.item.expanded;
    //     setData([...data]);
    //   };
    let ids = expandGroup.ids.slice();
    const index = ids.indexOf(event.item.groupId);
    if (index === -1) {
      ids.push(event.item.groupId);
    } else {
      ids.splice(index, 1);
    }
    setExpandGroup({
      ids,
      idField: 'groupId',
    });
  };

  const onGroupChange = (event) => {
    setGroup(event.group);
    setcolumnChooser(event.group);
    setTreeviewSelectedValues({})
    if (event.group.length > 0) {
      setFlagShow(true)
      setExpanded("panel2")
      if (loadSelectionValue != "All") {
        data.onLoadSelectionChange({ value: "All" })
      }
      const tempDataState = { ...myGridDataState, take: gridLoadedGridData?.data.length };
      const aggregatesData = service.processWithGroups(gridLoadedGridData?.data, { ...tempDataState, group: event.group });
      if (aggregatesData.data.length > 0) {
        onSetGroupTreeviewData(aggregatesData.data);
      }
    } else {
      data.onLoadSelectionChange({ value: loadSelectionValue })
      onSetGroupTreeviewData([])
      setExpanded("panel1")
    }
    setMySelectedState([])
    setGridTempData(service.processWithGroups(gridLoadedGridData?.data, { sort: myGridDataState?.sort }))
  }

  const onSetGroupTreeviewData = (val) => {
    let newArr = []
    const preparedData = createTreeHierarchicalData(val, newArr);
    setGroupTreeViewData(preparedData);
    setExpandGroup({
      ids: newArr,
      idField: 'groupId',
    });
  }

  const onColumnChange = (e, item) => {
    const newGroupFields = columnChooser?.filter(e => e.field !== item.field);
    setGroup(newGroupFields);
    setcolumnChooser(newGroupFields);
    const newGroupCols = groupbyGridColumns?.filter(e => e.field !== item.field);
    const newgroupByColumnVal = newGroupCols?.filter(e => groupByColumnVal.includes(e.title));;
    setGroupByColumnVal(newgroupByColumnVal.map(e => e.title))
    setTreeviewSelectedValues({})
    if (newGroupFields.length > 0) {
      setFlagShow(true)
      setExpanded("panel2")
      if (loadSelectionValue != "All") {
        data.onLoadSelectionChange({ value: "All" })
      }
      const tempDataState = { ...myGridDataState, take: gridLoadedGridData?.data.length };
      const aggregatesData = service.processWithGroups(gridLoadedGridData?.data, { ...tempDataState, group: newGroupFields });
      if (aggregatesData.data.length > 0) {
        onSetGroupTreeviewData(aggregatesData.data);
      }
    } else {
      data.onLoadSelectionChange({ value: loadSelectionValue })
      onSetGroupTreeviewData([]);
      setExpanded("panel1")
    }
    setMySelectedState([])
    setGridTempData(service.processWithGroups(gridLoadedGridData?.data, { sort: myGridDataState?.sort }))
    setSelectedGrpTreeView({});
  }

  // Template for Tree view -- Grouping end

  const toggleDataActionsRendering = (checkboxes) => {
    setToggleconfigCheckboxes(checkboxes);
    saveToggleActionSelectedData('Data', checkboxes);
  };
  const toggleDataActionsRenderingPlan = (checkboxesPlan) => {
    setToggleconfigcheckboxesplan(checkboxesPlan);
    saveToggleActionSelectedData('Plan', checkboxesPlan);
  };

  const droppedItemsChangeForRightClick = (droppedItems) => {
    getToggleConfigData(droppedItems);
    saveToggleActionSelectedData('Action', droppedItems);
    setShow(false);
  };

  const toggleCustomActionsRendering = (checkboxAction) => {
    setToggleconfigCustomActioncheckboxes(checkboxAction);
    saveToggleActionSelectedData('CustomAction', checkboxAction);
  }

  const getToggleConfigData = (droppedItems) => {
    let updatedDroppedItems = droppedItems.map(item => {
      if (typeof item === 'string') {
        return { title: item, source: data?.gridPlanAction?.includes(item) ? "planRelatedAction" : "dataRelatedAction" };
      } else {
        return item;
      }
    });
    
    if (window.location.hash.includes("#/CustomView") || window.location.hash.includes("#/CreateCustomView")) {
      updatedDroppedItems = updatedDroppedItems?.filter(item => item.title !== 'New Window');
    }
    const dropItemActionList = updatedDroppedItems?.filter(x => (x.source === 'dataRelatedAction' || x.source === 'planRelatedAction'));
    const dropItemCustomActionList = updatedDroppedItems?.filter(x => x.source === 'customAction').map(y => y.title);
    const updatedToggleconfigCustomAction = data?.customActions?.filter(x => dropItemCustomActionList.includes(x.caption));
    setToggleconfigActions(dropItemActionList);
    setToggleconfigCustomActions(updatedToggleconfigCustomAction);
    setToggleDraggedItem(updatedDroppedItems);
  }

  const addNewView = () => {
    setOpenModalFilter(true);
  }

  // VIEW START

  const loadSavedView = (tempParsedData, isSubview, isDefaultView, isFavouriteView) => {
    const savedViews = localStorage.getItem(gridFlagValFor + 'Savedview');
    const updatedRows = savedViews ? JSON.parse(savedViews) : initialSavedViewObj;

    if (!savedViews || !tempParsedData) return;

    let parsedData = {};
    const newAvailableFields = [];
    const newCards = [];
    const tempFieldList = [];
    const updateSelectedFields = [];
    let filterData = {};
    gridColumns?.forEach(e => {
      const obj = {
        name: e.field,
        label: e.title,
        filter: TextFilter,
        operators: Operators.text,
        type: e.type
      };
      tempFieldList.push(obj);
    });

    if (isDefaultView) {
      parsedData = JSON.parse(savedViews)[gridFlagValFor].savedViews.find(x =>
        isFavouriteView ? x.viewName === tempParsedData.viewName : x.viewName === tempParsedData.parent
      );
    } else if (isFavouriteView) {
      parsedData = JSON.parse(savedViews)[gridFlagValFor].savedViews.find(x =>
        x.viewName === tempParsedData.viewName
      );
    } else {
      parsedData = JSON.parse(savedViews)[gridFlagValFor].savedViews.find(x =>
        isSubview ? x.viewName === tempParsedData.parent : x.viewName === tempParsedData.text
      );
    }

    const favFilterExist = parsedData?.subviews?.length > 0 ? parsedData?.subviews?.filter(subView => subView.isDefaultFilter) : [];

    if (isSubview) {
      filterData = parsedData?.subviews?.find(item => item.viewName === tempParsedData.text) || {};
    } else if (favFilterExist?.length > 0) {
      if (isDefaultView) {
        filterData = parsedData?.subviews?.[0];
      } else {
        filterData = favFilterExist[0] || {};
      }
    } else if (parsedData?.subviews?.[0]) {
      filterData = parsedData?.subviews?.[0];
    } else {
      if (gridFlagVal === 'movements' && gridFlagValFor === 'movements') {
        filterData.defaultFilter = gridDefaultFilters;
      } else {
        filterData.defaultFilter = gridFilterComponents;
      }
    }

    const sortData = parsedData?.dataState?.sort;
    const validFields = filterCompValues?.map(item => item.key);

    let freezedItems = parsedData?.columns?.filter(({ locked }) => locked)?.map(({ title }) => title).filter(Boolean) || [];
    const tempList = parsedData?.columns?.filter(x => x.visible == true);
    const gCols = tempList?.filter(e => !['ActionColumn', 'instructionsExist', 'qualificationsExist'].includes(e.field));

    let parentFilter = [];
    if (isDefaultView && isFavouriteView) {
      parentFilter = tempParsedData?.subviews?.[0]?.filter ? tempParsedData?.subviews[0]?.filter : service.removeUserFilterData(data.gridInitialFilter);
    } else if (isDefaultView) {
      parentFilter = tempParsedData?.filter;
    } else if (filterData?.filter) {
      parentFilter = filterData?.filter;
    } else {
      parentFilter = service.removeUserFilterData(data.gridInitialFilter);
    }
    
    setFreezeColumnVal(freezedItems);
    setGridTempData(service.processWithGroups(gridLoadedGridData?.data, { sort: sortData }));
    setTempGridColumns(tempList);
    setgroupbyGridColumns([...gCols]);

    if (parsedData?.group?.length > 0) {
      if (loadSelectionValue != "All") {
        data.onLoadSelectionChange({ value: "All" })
      }
      setGroupByColumnVal(parsedData.group?.map(groupedVals => groupedVals?.title));
      setcolumnChooser(parsedData.group);
    } else {
      setGroupByColumnVal([]);
      setcolumnChooser([]);
    }

    const saveSettingsSelectedColumns = {
      sortColumnsData: colMultiFilter?.sortColumnsData,
      movTableColumns: colMultiFilter?.movTableColumns,
      freezeColumnVal: freezedItems,
      groupByColumnVal: parsedData.group?.map(groupedVals => groupedVals?.title) 
    };
    updatedRows[gridFlagValFor].settingsColumn = saveSettingsSelectedColumns;
    localStorage.setItem(gridFlagValFor + 'Savedview', JSON.stringify(updatedRows));

    if (Object.keys(filterData).length != 0 && !data.isChild) {
      filterData?.defaultFilter?.forEach(ele => {
        if (validFields && validFields.includes(ele.key)) {
          const filterComp = filterCompValues.find(e => e.key === ele.key);

          if (filterComp) {
            if (ele.key === 'startDate' || ele.key === 'startingDate') {
              filterComp.value = new Date(service.formateDate(ele.value));
            } else {
              if (ele.key === 'status' && gridFlagVal === 'movements' && gridFlagValFor === 'movements' && !_.isObject(ele?.value)) {
                if (filterComp?.data?.find(e => e?.caption?.toLowerCase() === ele?.value?.toLowerCase())) {
                  let value = filterComp?.data?.find(e => e?.caption?.toLowerCase() === ele?.value?.toLowerCase());
                  filterComp.value = value;
                } else if (ele?.value?.toLowerCase() === 'all') {
                  let value = filterComp?.data?.find(e => e?.caption?.toLowerCase() === ' ');
                  filterComp.value = value;
                } else {
                  filterComp.value = ele.value;  
                }
              } else {
                filterComp.value = ele.value;
              }
            }

            setFilterCompValues([...filterCompValues]);
          }
        }
      });

      filterData?.filter?.forEach(ele => {
        if (validFields && !validFields.includes(ele.field)) {
          newCards.push(null);
          newAvailableFields.push(tempFieldList.filter(field => !updateSelectedFields.map(e => e.name).toString().includes(field.name)));
          let selected = newAvailableFields[0].find(x => x.name == ele.field);
          selected.value = ele.value;
          updateSelectedFields.push(selected);
        }
      });
    }

    setReorderedCols([]);
    let grpBy = parsedData.group?.map(groupedVals => groupedVals?.title);
    if (isSubview) {
      if (tempParsedData.filter) {
        setFilterSortArr({ filterArray: tempParsedData.filter, sortArray: sortData, groupArray: grpBy });
      }
    } else {
      if (parentFilter) {
        setFilterSortArr({ filterArray: parentFilter, sortArray: sortData, groupArray: grpBy});
      } else {
        setFilterSortArr({ ...filterSortArr, sortArray: sortData, groupArray: grpBy });
      }
    }

    setAvailableFields(newAvailableFields);
    setCards(newCards);
    setSelectedFields(updateSelectedFields);
    setmyGridDataState({ ...parsedData.dataState });
    setGridKey(gridKey + 1);
    setSelectedGrpTreeView({});
  };

  const deleteSavedView = (data) => {
    setDeleteItem(data.item);
    // if(!data.item.isSubview){
    //   setSelectTreeView(selectTreeView.filter(e=> e != data.itemHierarchicalIndex));
    // }else{
    setSelectTreeView(selectTreeView.filter(e => e != data.itemHierarchicalIndex));
    // }    
    setDeleteDialogOpen(true);
  };

  const deleteSaveViewCancel = () => {
    setDeleteDialogOpen(false);
  };

  const deleteSaveViewConfirm = () => {
    const item = deleteItem;
    if (item) {
      const viewsData = localStorage.getItem(gridFlagValFor + 'Savedview');

      let updatedViews = viewsData
        ? JSON.parse(viewsData)
        : { [gridFlagValFor]: service.initialViewsObj };
      if (updatedViews && (updatedViews[gridFlagValFor].savedViews !== undefined || updatedViews[gridFlagValFor].savedViews !== null)) {
        const savedViews = updatedViews[gridFlagValFor].savedViews;
        for (let i = 0; i < savedViews.length; i++) {
          if (item?.parent === savedViews[i].viewName) {
            let subviewsArray = savedViews[i].subviews;
            updatedViews[gridFlagValFor].savedViews[i].subviews = subviewsArray.filter((subview) => subview.viewName !== item.text);
          } else if (item?.text === savedViews[i].viewName) {
            const filteredViews = savedViews.filter((view) => view.viewName !== item.text);
            updatedViews[gridFlagValFor].savedViews = filteredViews;
          }
        }
        // localStorage.removeItem('Savedview');
        localStorage.setItem(gridFlagValFor + 'Savedview', JSON.stringify(updatedViews));

        if (gridFlagVal !== 'trip') {
          fetchUpdateSavedViews(gridFlagValFor, updatedViews, true, true);
        }
      }
      setTreeViewData(generateTreeViewData());
      setGridTempData(service.processWithGroups(data.tempGridData, { sort: myGridDataState?.sort }))
      // setGridUpdatedData(data.tempGridData)
      setmyGridDataState({ ...item.dataState });
    }
    setDeleteDialogOpen(false);
  };

  // Generate the tree data based on views
  const generateTreeViewData = () => {
    const tempviews = JSON.parse(localStorage.getItem(gridFlagValFor + 'Savedview'));
    if (!_.isNil(tempviews) && tempviews.toString() !== '' &&
      !_.isNil(tempviews[gridFlagValFor].savedViews) && tempviews[gridFlagValFor].savedViews.toString() !== '') {
      return tempviews[gridFlagValFor].savedViews.map((view, index) => ({
        text: view.viewName,
        items: view.subviews && !data.isChild ? generateSubTreeViewData(view) : [],
        isSubview: false,
        filter: view.filter,
        defaultView: view.defaultView
      }));
    }
    return []
  };
  const generateSubTreeViewData = (parentView) => {
    return parentView.subviews.map((view, index) => ({
      text: view.viewName,
      items: [],
      isSubview: true,
      parent: parentView.viewName,
      filter: view.filter,
      isDefaultFilter: view.isDefaultFilter
    }));
  };
  // Template for Tree view
  const treeViewItem = (props) => {
    return (
      <>
        <span style={{ width: '100%', display: 'flex' }} onClick={() => onTreeviewItemClick(props)}>{(props.item?.defaultView || props.item?.isDefaultFilter) && <StarIcon edge="end" sx={{fontSize:10,color:'#F4B600',marginRight:.5}} />}{props.item.text}</span>
        <IconButton edge="end" sx={{ mr: .2 }} aria-label="delete" size="small" color='primary' onClick={() => deleteSavedView(props)}><CloseIcon /></IconButton>
      </>
    );
  };

  const onTreeviewItemClick = (prop) => {
    const { item, itemHierarchicalIndex } = prop;
    const view = findViewByText(treeViewData, item);
    const hasUnderscore = itemHierarchicalIndex?.includes('_');
    const defaultFilterIndex = itemHierarchicalIndex?.split('_')[1];
    // selectTreeView[0] == prop?.itemHierarchicalIndex?.split('_')[0]

    if (view) {
      const isDefaultView = defaultFilterIndex !== undefined && defaultFilterIndex === '0';
      const isSubview = hasUnderscore && !isDefaultView;

      loadSavedView(item, isSubview, isDefaultView, false);
    }
  };

  const findViewByText = (views, item) => {
    if (item.isSubview) {
      const temp = views.find(e => e.text == item.parent)
      return temp.items.find(e => e.text == item.text)
    } else {
      return views.find(e => e.text == item.text)
    }
  };

  const onExpandSubViews = (event, val) => {
    let ids = expand.ids.slice();
    const index = ids.indexOf(event.item.text);
    if (index === -1) {
      ids.push(event.item.text);
    } else {
      if(!val){
        ids.splice(index, 1);
      }
    }
    setExpand({
      ids,
      idField: 'text',
    });
  };

  const onTreeViewClick = (event) => {
    const tempselect = []
    if (event.item.isSubview) {
      tempselect.push(...event.itemHierarchicalIndex.split("_")[0])
      tempselect.push(event.itemHierarchicalIndex)
    } else {
      tempselect.push(...event.itemHierarchicalIndex)
      tempselect.push(event.itemHierarchicalIndex + "_0")
    }

    const filterIndex = event?.item?.items?.findIndex(subView => subView.isDefaultFilter);
    if (filterIndex !== -1) {
      setSelectTreeView([event.itemHierarchicalIndex.toString(), `${event.itemHierarchicalIndex}_${filterIndex}`.toString()]);
    } else {
      setSelectTreeView(tempselect);
    }

    onExpandSubViews(event, true)
  };

  // VIEW END

  // Generate the tree data based on views
  const addCard = () => {
    const newCards = cards ? [...cards] : [];
    newCards.push({ field: '', value: '' });

    const newAvailableFields = [...availableFields];
    const fieldsToIgnore = _.concat(filterCompValues.map(e => e.key),nonFilterableColumnData)
    const tempFieldList = [];
    data.gridTempColumnList.forEach(e => {
      if (!fieldsToIgnore.includes(e.field)) {
        const obj = {
          name: e.field,
          label: e.title,
          filter: TextFilter,
          // operators: Operators.text,
          type: e.type
        };
        tempFieldList.push(obj);
      }
    });
    newAvailableFields.push(tempFieldList.filter(item => !selectedFields.some(({ name }) => name === item.name)));
    setAvailableFields(newAvailableFields);
    setCards(newCards);
  };

  const removeCard = (index) => {
    const newCards = [...cards];
    newCards.splice(index, 1);
    setCards(newCards);

    const newSelectedFields = [...selectedFields];
    newSelectedFields.splice(index, 1);
    setSelectedFields(newSelectedFields);

    const newFilterValues = [...filterValues];
    newFilterValues.splice(index, 1);
    setFilterValues(newFilterValues);

    const newAvailableFields = [...availableFields];
    newAvailableFields.splice(index, 1);
    setAvailableFields(newAvailableFields);

    const tarrFilterData = _.cloneDeep(filterSortArr.filterArray);
    let tempIndex = tarrFilterData.findIndex((e) => e.field == selectedFields[index]?.name);
    if (tempIndex != -1) {
      tarrFilterData.splice(tempIndex, 1)
      setFilterSortArr({ ...filterSortArr, filterArray: tarrFilterData });
    }

    if (newFilterValues.length > 0) {
      // applyFilter(newFilterValues.length - 1);
    } else {
      setFilteredData(gridLoadedGridData?.data);
    }
  };

  const offSet = React.useRef({
    left: 0,
    top: 0,
  });
  const inputRefs = useRef([]);

  const handleContextMenu = (e) => {
    // if(e?.dataItem?.onHold) {
    //   return;
    // }
    e.syntheticEvent.preventDefault();
    offSet.current = {
      left: e.syntheticEvent.clientX,
      top: e.syntheticEvent.clientY,
    };
    setContextData(e);
    setShow(true);
    // Right Mouse click all Scenarios for Selection & Preselection the rows
    const filteredSelectionState = Object.keys(myselectedState)?.filter(key => myselectedState[key] !== false)?.reduce((state, key) => {
      state[key] = myselectedState[key];
      return state;
    }, {});
    let selectedStateObj = {};
    const id = e?.dataItem?.id;
    const isSelectedItem = filteredSelectionState[id];
    const isPartialSelectedItem = myPartialSelectedState[id];
    const selectedIndex = gridTempData?.data?.findIndex(x => x.id === id);
    
    if (data?.selectableMode === 'single') {
      const { id } = gridTempData.data[selectedIndex];
      setMySelectedState({ [id]: true });
      return;
    }
    const tempState = myPartialSelectedState, onHoldItems = {};
    for (const data of gridTempData?.data || []) {
      const disableDragSelection = gridFlagVal === 'movements' && gridFlagValFor === 'movements' ? (Object.keys(tempState).findIndex(x => x === data.id && currentStatusVal?.toLowerCase() !== '0') !== -1) : false;
      if ((e.dataItem.id === data.id) && data.onHold || disableDragSelection) {
        delete tempState[data.id];
        onHoldItems['' + data.id] = true;
      }
    }
    if (!isSelectedItem) {
      let newSelectedState = _.cloneDeep(filteredSelectionState);
      const shouldSelectedState = gridFlagVal === 'movements' && gridFlagValFor === 'movements'
        ? currentStatusVal?.toLowerCase() === '0' && !gridTempData?.data?.[selectedIndex]?.onHold
        : true;

      if (shouldSelectedState) {
        newSelectedState[gridTempData?.data?.[selectedIndex]?.id] = true;
      }

      checkHeaderSelectionValue();
      
      if (isPartialSelectedItem) {
        if (Object.keys(filteredSelectionState).length > 0) {
          selectedStateObj = {...tempState, ...filteredSelectionState};
        } else {
          selectedStateObj = tempState;
        }
      } else {
        selectedStateObj = newSelectedState;
      }
    } else {
      selectedStateObj = {...tempState, ...filteredSelectionState};
    }

    if (Object.keys(selectedStateObj)?.length > 0) {
      setMySelectedState(selectedStateObj, gridTempData);
    }
    setMyPartialSelectedState(onHoldItems);
  };

  React.useEffect(() => {
    document.addEventListener("click", (e) => {
      if (show) {
        e.preventDefault();
        setShow(false);
      }
      return null;
    });
  }, [show]);

  const handleFieldChange = (e, index) => {
    // setFocusField(null)
    // const newSelectedFields = [...selectedFields];
    // newSelectedFields[index] = e.target.value;
    const selected = availableFields[index].find(x => x.name == e.target.value)
    let sFields = _.cloneDeep(selectedFields)
    sFields[index] = selected

    let tempData = filterSortArr.filterArray?.find((x) => x.field == e.target.value);
    if (tempData) {
      sFields[index].value = tempData.value;
    }
    setSelectedFields(sFields);
  };

  const CustomFilterCellRender = ({ index }) => {
    // setFocusField(null);
    const fieldName = selectedFields[index]?.name;
    const columnType = selectedFields[index]?.type;
    let tempfield = filterSortArr.filterArray?.filter((e) => e.field == fieldName);
    const val = tempfield.length > 0 ? tempfield[0].value : "";
    const [inputVal, setInputVal] = useState(val);

    const handleFilterChange = (e) => {
      const inputText = e.target.value;
      setInputVal(inputText);
      let tempIndex = filterSortArr.filterArray?.findIndex((e) => e.field == fieldName);
      if (tempIndex == -1 && inputText == "") {
        return;
      }
      if (tempIndex != -1) {
        if (filterSortArr.filterArray[tempIndex].value == inputText) {
          return;
        }
        filterSortArr.filterArray[tempIndex].value = inputText;
      } else {
        filterSortArr.filterArray.push({
          field: fieldName,
          value: inputText,
          type: columnType,
          isFilter: true,
          isTime : timeFieldColumnData.includes(fieldName) ? true : false
        });
      }
      // const updatedFilterData = [...arrFilterData];
      // updatedFilterData.forEach(a => a.isViewFilter = false)
      // setArrFilterData(arrFilterData)
    }

    const onfilteredApply = (e) => {
      if (e.nativeEvent.key == 'Enter' || e.nativeEvent.key == 'Tab' || e.nativeEvent.type == 'focusout') {
        // filterGridData(arrFilterData);
        setFocusField(fieldName);

        let tempselectedFields = _.cloneDeep(selectedFields);
        let index = tempselectedFields.findIndex((e) => e.name == fieldName);
        if (index != -1 && inputVal !== tempselectedFields[index]?.value) {
          tempselectedFields[index].value = inputVal;
          setSelectedFields(tempselectedFields);
          setFilterSortArr({ ...filterSortArr });
        }
      }
    };

    return (
      <input
        type="text"
        // autoFocus={props.field == focusField}
        className="form-control w200"
        value={inputVal}
        disabled={!selectedFields[index]?.name}
        onKeyUp={(e) => onfilteredApply(e)}
        onChange={(e) => handleFilterChange(e)}
        onBlur={(e) => onfilteredApply(e)}
      />
    );
  };

  const gridOnSortChange = (event) => {
    if (!isMultiSort) {
      setFilterSortArr({ ...filterSortArr, sortArray: event?.sort });
    } else {
      const updatedSortColumnsData = tempGridColumns.filter(item => {
        if (event.sort.map(item => item.field).includes(item.field)) {
          return item;
        }
      });
      let sortData = [];

      let tempEventData = JSON.parse(JSON.stringify(event.sort));
      let tempData = tempEventData.reverse()[0];
      const filteredData = savedSortColData.filter(item => item.field == tempData?.field);
      if (filteredData.length > 0) {
        filteredData[0].dir = tempData.dir;
      } else {
        savedSortColData.push(tempData);
      }

      savedSortColData.forEach(element => {
        const data = updatedSortColumnsData.filter(e => e.field == element.field)
        if (data.length > 0) {
          sortData.push({
            field: element.field,
            dir: element.dir,
            title: data[0].title
          })
        }
      });
      setFilterSortArr({ ...filterSortArr, sortArray: sortData });
      setSavedSortColData(sortData);
    }
    setFocusField(null);
    //setGridKey(gridKey + 1)
  }

  const disptachDragEvent = (e, source, destination, tstate) => {
    const selectedIds = getSelectedValues(tstate);
    const selectedValues = service.getMembers(gridTempData?.data).filter(e => selectedIds.includes('' + e.id))
    const obj = {
      source: source,
      destination: destination,
      eventType: e,
      isTripGenerated: false,
      items: selectedValues
    }
    dispatch(drageItemsReducer(obj))
  }

  const myOnDragStart = (rowData, e) => {
    if (data.gridDraggable === false) {
      return;
    }
    const tempstate = JSON.parse(JSON.stringify(myselectedState));
    const partialSelectedStateItems = Object.keys(myPartialSelectedState);

    if (Object.keys(myselectedState).findIndex(selectedItem => selectedItem === rowData.dataItem.id && tempstate[rowData.dataItem.id] === true) >= 0 || partialSelectedStateItems.findIndex(partialSelectedItem => partialSelectedItem === rowData.dataItem.id) >= 0 || event.ctrlKey) {
      for (const partialSelectedStateItem of partialSelectedStateItems) {
        // if (Object.keys(tempstate).findIndex(x => x === partialSelectedStateItem) === -1) { //Removed because of presection drag issue
        tempstate['' + partialSelectedStateItem] = true;
        // }
      }
    }
    rowData.dataItem.selected = !rowData.dataItem.selected;
    tempstate['' + rowData.dataItem.id] = true;

    const onHoldItems = {};
    for (const data of gridTempData?.data || []) {
      const disableDragSelection = gridFlagVal === 'movements' && gridFlagValFor === 'movements' && currentStatusVal?.toLowerCase() !== '0';
      if ((Object.keys(tempstate).findIndex(x => x === data.id) !== -1) && data.onHold || disableDragSelection) {
        delete tempstate[data.id];
        onHoldItems['' + data.id] = true;
      }
    }

    resetHeaderFields(tempstate);
    setMySelectedState(tempstate, gridTempData);
    setMyPartialSelectedState(onHoldItems);
    disptachDragEvent('drag', gridFlagVal, null, tempstate);
  }

  const onDropRow = (e, data) => {
    onDroppedRecord = data?.dataItem
  }

  const myOnDrop = (e, data) => {
    if(drageItems?.items?.message){
      setSuccessSnackbarOpen(true)
      setSuccessSnackbarMessage(drageItems?.items?.message)
    }
    if (drageItems.source == gridFlagVal && drageItems.source !== "routes") {
      if (gridFlagVal == "partialTrips") {
        console.log("Don't drop here");
      } else {
        if (e?.target) {
          const selectedIds = getSelectedValues();
          const selectedValues = service.getMembers(gridTempData?.data).filter(e => selectedIds.includes('' + e.id))
          const gridValues = service.getMembers(gridTempData?.data).filter(e => !selectedIds.includes('' + e.id))

          const tempindex = selectedIds.filter(x => service.getMembers(gridTempData?.data).findIndex(y => y.id == +x) < +e.target.parentElement.dataset.gridRowIndex).length
          const index = +e.target.parentElement.dataset.gridRowIndex - tempindex

          gridValues.splice(index, 0, ...selectedValues);
          setGridTempData(service.processWithGroups(gridValues, { sort: myGridDataState?.sort }))
        }
      }
    } else if (["movements","ptmovements"].includes(drageItems.source) && gridFlagVal == "partialTrips") {
      setRefreshSource(true)
      if (onDroppedRecord !== null && onDroppedRecord !== undefined) {
        const actualSelectedIds = drageItems.items.map(e => e.id);
        if (actualSelectedIds) {
          const movementObjects = service.movementObject(actualSelectedIds, drageItems.source);
          const inputTripDateObject = {
            planOnPartialTrip: onDroppedRecord.id
          };
          if(drageItems.source === "ptmovements") {
            inputTripDateObject.rePlan = true
          }
          const obj = service.movementLinesAndOperationDeatilObject(movementObjects, JSON.stringify(inputTripDateObject), drageItems.source);
          postPlanMovementsAPI(obj, movementObjects, true);
          onDroppedRecord = null
        }
      } else {
        onPlanTripButtons();
      }
    } else if (drageItems.source == "routes") {
      if (onDroppedRecord && drageItems?.items) {
        callChangeSequence(drageItems.items[0].id, onDroppedRecord.lineNo);
      }
    } else {
      // let newDataFirst = [drageItems.items, ...service.getMembers(gridLoadedGridData?.data)];
      // // tempMovementsData.push(drageItems.items)
      // setGridLoadedGridData(service.processWithGroups(newDataFirst, { sort: myGridDataState?.sort }))

      // const obj = {
      //   source: 'PartialTrip',
      //   destination: 'movements',
      //   eventType: drageItems.eventType,
      //   items: drageItems.items
      // }
      // dispatch(drageItemsReducer(obj))
    }
  };


  const callChangeSequence = (drageItemId, dropItemLineNo) => {
    const obj = {
      "beforeLineNo": dropItemLineNo,
    };
    apiService.postWithId(getRoutes,null,drageItemId,'Microsoft.NAV.changeSequence', obj).then(response => {
      if (response !== null && response !== undefined) {
        if (response.error !== null && response.error !== undefined && response.error) {
          setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
        } else if (response === 204) {
          setSuccessSnackbarAndMessage(i18_en.sequenceChangedSuccessfully);
          sendDataToParent(drageItemId, 'sendApiForRoute', true);
        }
      }
    })
      .catch(error => {
        console.error('API error:', error);
      })
      .finally(() => {
        setIsLoading(false);
      })
  }

  const onMoveUpIconClick = (id) => {
    const obj = {
      "input": "{}"
    };
    callPlanFunctionPostWithIdAPI(getRoutes, null, id, 'Microsoft.NAV.moveUp', obj, PlanFunctionsForFlag.WarningsMoveUp, false, true, i18_en.sequenceChangedSuccessfully);
  }

  const onMoveDownIconClick = (id) => {
    const obj = {
      "input": "{}"
    };
    callPlanFunctionPostWithIdAPI(getRoutes, null, id, 'Microsoft.NAV.moveDown', obj, PlanFunctionsForFlag.WarningsMoveDown, false, true, i18_en.sequenceChangedSuccessfully);
  }

  const onRegroupTripIconClick = (id) => {
    const obj = {
      "input": "{}"
    };
    callPlanFunctionPostWithIdAPI(getPartialTrip,null,id,'Microsoft.NAV.regroupTrip', obj, PlanFunctionsForFlag.RegroupTrip, true, false, i18_en.operationSuccessful);
  }

  const callPlanFunctionPostWithIdAPI = (url, flag, id, routeExpand, obj, forFlag, isRefresh, isSendDataToParent = false, snackbarMessage = i18_en.operationSuccessful) => {
    setIsLoading(true);
    apiService.postWithId(url, flag, id, routeExpand, obj).then(response => {
      if (response) {
        if (response.error) {
          setErrorParameterAndMessage(response?.error?.message.split('CorrelationId')[0]);
        } else {
          const result = JSON.parse(response?.value);
          if (result) {
            if (service.apiOKResultChecker(result)) {
              setSuccessSnackbarAndMessage(snackbarMessage);
              if (isRefresh) {
                onRefreshIconClick();
              }
              if (isSendDataToParent) {
                sendDataToParent(id, 'sendApiForRoute', false);
              }
              setopenConfirmationModal(false);
            } else if (result.parameters[0] !== null && result.parameters[0] !== undefined && (result.parameters[0].name === 'confirmation' || result.parameters[0].name === 'warnings')) {
              const params = {
                title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
                id: id,
                for: forFlag,
                parameters: result.parameters
              }
              setopenConfirmationModal(true);
              setCommonPopupParameters(params);
            } else {
              setopenConfirmationModal(false);  
            }
          } else {
            setopenConfirmationModal(false);
          }
        }
      }
    })
      .catch(error => {
        console.error('API error:', error);
      })
      .finally(() => {
        setIsLoading(false);
      })
  }

  const closeConfirmationModal = (e, flag, id = null) => {
    setopenConfirmationModal(false);
    setCommonPopupParameters({});
    if (e && flag && (flag === PlanFunctionsForFlag.DeleteDepot || flag === PlanFunctionsForFlag.DeleteHookOff || flag === PlanFunctionsForFlag.DeleteTerminal ||
                      flag === PlanFunctionsForFlag.Postpone || flag === PlanFunctionsForFlag.SetFree || flag === PlanFunctionsForFlag.CreateTrip ||
                      flag === PlanFunctionsForFlag.SetFreeRoutes)) {
      let apiEndPointName = DeleteDepot;
      if (flag === PlanFunctionsForFlag.DeleteHookOff) {
        apiEndPointName = DeleteHookOff;
      } else if (flag === PlanFunctionsForFlag.DeleteTerminal) {
        apiEndPointName = DeleteTerminals;
      } else if (flag === PlanFunctionsForFlag.Postpone) {
        apiEndPointName = postponeMovements;
      } else if (flag === PlanFunctionsForFlag.SetFree) {
        apiEndPointName = postSetfree;
      } else if (flag === PlanFunctionsForFlag.CreateTrip) {
        apiEndPointName = createTrips;
      } else if (flag === PlanFunctionsForFlag.SetFreeRoutes) {
        apiEndPointName = postSetFreeRoutes;
      }
      callPlanFunctionAPI(null, e, apiEndPointName, flag, i18_en.operationSuccessful);
    } else if (e && flag && flag === PlanFunctionsForFlag.CustomHookOff) {
      callPlanFunctionAPIGridAPI(null, e, customHookoff, 'Select Transport Address', flag, 'Select Transport Address (Hook Off)')
    } else if (e && flag && flag === PlanFunctionsForFlag.WarningsMoveUp) {
      callPlanFunctionPostWithIdAPI(getRoutes,null,id,'Microsoft.NAV.moveUp', e, flag, false, true, i18_en.sequenceChangedSuccessfully);
    } else if (e && flag && flag === PlanFunctionsForFlag.WarningsMoveDown) {
      callPlanFunctionPostWithIdAPI(getRoutes,null,id,'Microsoft.NAV.moveDown', e, flag, false, true, i18_en.sequenceChangedSuccessfully);
    } else if (e && flag && flag === PlanFunctionsForFlag.RegroupTrip) {
      callPlanFunctionPostWithIdAPI(getPartialTrip,null,id,'Microsoft.NAV.regroupTrip', e, flag, true, false, i18_en.operationSuccessful);
    } else if (e && flag && flag === PlanFunctionsForFlag.CalculateConfirmation) {
      callPlanFunctionPostWithIdAPI(getPartialTrip,null,getSelectedValues(),'Microsoft.NAV.calculateIncludingActionTimes', e, flag, false, false, i18_en.operationSuccessful);
    } else if (e && flag && flag === PlanFunctionsForFlag.PlanMovementsNewConfirmation) {
      postPlanMovementsAPI(e, e.movementlines);
    } else if (e && flag && flag === PlanFunctionsForFlag.NewpartialTrip) {
      PlanNewPartialTrip(getPartialTrip,null,getSelectedValues(),'Microsoft.NAV.newPartialTrip',e)
    } else if (e && flag && flag === PlanFunctionsForFlag.ChangePTResourceConfirmation) {
      callAPIChangePtResource(e);
    } else if (e && flag && flag === PlanFunctionsForFlag.InsertExtraAction) {
      PlanNewPartialTrip(getPartialTrip,null,getSelectedValues(),'Microsoft.NAV.insertExtraAction',e)
    } else {
      closePopupFilter();
    }
  }

  const onPlanButtons = (e, Id, contextData, isCustomActions = false) => {
    if (Id !== null && Id !== undefined && Id.length === 0 && e !== 'copy-cell value' && e !== 'filter' && e !== 'table-rows'
      && e !== 'view-columns' && e !== 'settings' && e !== 'refresh' && e !== 'split-screen' && e !== 'new-window' && e !== 'batch-trip creation') {
      setErrorSnackbarMessage(i18_en.selectPreselectRow);
      setErrorSnackbarOpen(true);
      return;
    } else if (eval(service.planActions?.find(planAction => planAction?.key?.toLowerCase().replace(' ','-') === e)?.disabled)) {
      setErrorSnackbarMessage(i18_en.planActionDisabled);
      setErrorSnackbarOpen(true);
      return;
    }

    if (typeof Id !== 'string' && Id?.length > 1) {
      if (e === "move-up" || e === "move-down") {
        setErrorSnackbarMessage(i18_en.multipleSelectionOperationNotAllowed);
        setErrorSnackbarOpen(true);
        return;
      }
    }

    if (isCustomActions) {
      const actionsData = data?.customActions?.filter(x => x.id === e);
      const obj = {
        "customActionId": actionsData?.[0]?.id
      }
      const url = gridFlagVal === 'movements' ? postExecuteCustomActionMovements : postExecuteCustomActionPartialTrips;
      onPlanButtonDrillDownNVT(url, Id, JSON.stringify(obj));
      return;
    }
    let drageItemId;
    if (contextData && contextData !== undefined && contextData !== null) {
      drageItemId = contextData?.dataItem?.id;
    } else {
      if (Id && Id?.length >= 1) {
        drageItemId = gridLoadedGridData?.data?.find(item => item.id === Id[0])?.id;
      }
    }

    if (e === "move-up") {
      onMoveUpIconClick(drageItemId);
      return;
    } else if (e === "move-down") {
      onMoveDownIconClick(drageItemId);
      return;
    }

    if (e == "report" || e == "reports") {
      onPlanButtonsNetworkCall(baseUrl,gridFlagVal, Id,'Microsoft.NAV.reports', {});
    } else if (e == "send-to obc") {
      onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.sendTripOBC', {});
    } else if (e == "change-route") {
      onPlanButtonsNetworkCall(getRoutes,null,Id,'Microsoft.NAV.changeRoute', {});
    } else if (e == "change-status") {
      onPlanButtonsNetworkCall(getRoutes,null,Id,'Microsoft.NAV.changeStatus', {});
    } else if (e == "transfer-goods") {
      onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.transferGoods', {});
    } else if (e == "split-trip") {
      onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.splitTrip', {});
    } else if (e == "insert-begin - end action") {
      onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.insertBeginEndAction', {});
    } else if (e == "regroup") {
      onRegroupTripIconClick(Id);
    } else if (e == "delete-partial trip") {
      setIsLoading(true);
      apiService.deleteData(getPartialTrip,Id).then(response => {
        if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
          setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
        } else {
          setSuccessSnackbarAndMessage(i18_en.tripDeletedSuccessfully);
          sendDataToParent("", 'deleteTrip')
          setMySelectedState({})
          const obj = {
            tripNumber: 0,
            partialTrips: [],
            guid: guid,
            customView: customView
          };
          dispatch(setPartialTripReducer(obj));
        }
      })
        .catch(error => {
          console.error('API error:', error);
        })
        .finally(() => {
          setIsLoading(false);
        })
    } else if (e == "copy-cell value") {
      const cellValue = contextData.dataItem[contextData.field];
      navigator.clipboard.writeText(cellValue)
        .then(() => {
          // console.log('Value copied to clipboard:', cellValue);
        })
        .catch((error) => {
          console.error('Error copying to clipboard:', error);
        });
    } else if (e == 'filter-on this value') {
      const field = contextData.field
      let format = '';
      const fieldType = tempGridColumns?.filter((item)=>item.field === field)[0];
      let cellValue = contextData.dataItem[contextData.field].toString();

      if (fieldType?.type == 'Edm.Date') {
        format = `${process.env.REACT_APP_MOMENTDATEFORMAT}`;
        cellValue = moment(cellValue).format(format)
      } else if (fieldType?.type == 'Edm.DateTimeOffset') {
        format = `${process.env.REACT_APP_MOMENTDATETIMEFORMAT}`;
        cellValue = moment(cellValue).format(format)
      }

      let tempIndex = filterSortArr.filterArray?.findIndex((e) => e.field == field);
      if (tempIndex == -1 && cellValue == "") {
        return;
      }
      if (tempIndex != -1) {
        if (filterSortArr.filterArray[tempIndex].value == cellValue) {
          return;
        }
        filterSortArr.filterArray[tempIndex].value = cellValue;
      } else {
        if (fieldType?.type.startsWith("Microsoft.NAV.") && fieldType?.enumField && fieldType?.dropdownData?.find(value => value.name === cellValue)?.value) {
          cellValue = fieldType?.dropdownData?.find(value => value.caption === cellValue)?.value;
        }
        filterSortArr.filterArray.push({
          field: field,
          value: cellValue,
          type: fieldType?.type.startsWith("Microsoft.NAV.") ? 'Edm.String' : fieldType?.type,
          isFilter: fieldType?.type.startsWith("Microsoft.NAV.") ? false : true,
          isTime : timeFieldColumnData.includes(field) ? true : false
        });
      }
      filterGridData();
    } else if (e == "depot") {
      onDepotIconClick(Id);
    } else if (e == "delete-depot") {
      onDeleteDepotIconClick(Id);
    } else if (e == "hook-off") {
      onHooksIconClick(Id);
    } else if (e == "delete-hook off") {
      onDeleteHooksIconClick(Id);
    } else if (e == "custom-hook off") {
      onCustomHooksIconClick(Id);
    } else if (e == "split-up") {
      onPlanButtonsNetworkCall(baseUrl, gridFlagVal, Id, 'Microsoft.NAV.splitMovement', {});
    } else if (e == "regroup-movement") {
      onPlanButtonsNetworkCall(baseUrl, gridFlagVal, Id, 'Microsoft.NAV.regroupMovement', {});
    } else if (e == 'process-trips') {
      onPlanButtonDrillDownNVT(postProcesstrips,getSelectedValues(null,true));
      setMySelectedState({});
    } else if (e == 'create-separate bookings') {
      onPlanButtonDrillDownNVT(postCreateSeparateBookings, Id);
    } else if (e == 'create/add-existing bookings') {
      onPlanButtonDrillDownNVT(postCreateOrAddToExistingBookings, Id);
    } else if (e == 'view-e-cmr') {
      onPlanButtonsNetworkCall(baseUrl, gridFlagVal, Id, 'Microsoft.NAV.viewECMR', {});
    } else if (e == 'create-e-cmr') {
      onPlanButtonsNetworkCall(baseUrl, gridFlagVal, Id, 'Microsoft.NAV.createECMR', {});
    } else if (e == 'print-cmr') {
      onPlanButtonsNetworkCall(baseUrl, gridFlagVal, Id, 'Microsoft.NAV.printCMR', {});
    } else if (e == 'on-hold on/off') {
      onOnHoldOnOffIconClick(Id);
    } else if (e == 'truck-appointment overview') {
      onPlanButtonsNetworkCall(baseUrl, gridFlagVal, Id, 'Microsoft.NAV.showTruckAppointmentOverview', {});
    } else if (e == 'truck-appointment new') {
      onPlanButtonsNetworkCall(baseUrl, gridFlagVal, Id, 'Microsoft.NAV.newTruckAppointment', {});
    } else if (e == 'truck-appointment add to') {
      onPlanButtonsNetworkCall(baseUrl, gridFlagVal, Id, 'Microsoft.NAV.addToTruckAppointment', {});
    } else if (e == 'insert-terminal') {
      onInsertTerminalIconClick(Id);
    } else if (e == 'delete-terminal') {
      onDeleteTerminalIconClick(Id);
    } else if (e == 'postpone') {
      onPostponeIconClick(Id);
    } else if (e == 'create-trips') {
      onCreateTripIconClick(getSelectedValues(null,true));
    } else if (e == 'change-plan department') {
      onChangePlanDepartmentIconClick(Id);
    } else if (e == 'change-plan subdepartment') {
      onChangePlanSubdepartmentIconClick(Id);
    } else if (e == 'batch-trip creation') {
      onPlanButtonsNetworkCall(getPartialTrip,null,newData[0].id,'Microsoft.NAV.batchTripCreation', {});
    } else if (e == 'exchange-trailer') {
      onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.exchangeTrailer', {});
    } else if (e == 'new-partial trip') {
      PlanNewPartialTrip(getPartialTrip,null,Id,'Microsoft.NAV.newPartialTrip')
    } else if (e == 'split-trailer') {
      onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.splitTrailerPB', {});
    } else if (e == 'insert-shipping line') {
      onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.insertShippingLine', {});
    } else if (e == 'changes-status') {
      onPlanButtonDrillDownNVT(postChangesStatus, Id);
    } else if (e == 'insert-extra action') {
      apiService.get(actionCode).then((response)=>{
        PlanNewPartialTrip(getPartialTrip,null,Id,'Microsoft.NAV.insertExtraAction',null,response.value)
      })
    } else if (e == 'e-mail-trip sheet') {
      onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.emailTripSheet', {});
    } else if (e == 'print-outsource confirmation') {
      onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.printOutsourceConfirmation', {});
    } else if (e == 'e-mail-outsource confirmation') {
      onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.emailOutsourceConfirmation', {});
    } else if (e == 'print-trip sheet') {
      onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.printTripSheet', {});
    } else if (e == 'move-to lu') {
      onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.moveToLU', {});
    } else if (e == "refresh") {
      onRefreshIconClick('manualRefresh')
    } else if (e == "settings") {
      onSettingClick(e)
    } else if (e === 'plan-on map' || e === 'map') {
      const count = Object.values({...myselectedState,...myPartialSelectedState}).filter(value => value === true).length;
      if(count > 775) {
        setErrorSnackbarMessage('Please Select less than 775 rows');
        setErrorSnackbarOpen(true);   
        return 
      } else 
        planOnMapData();
    } else if (e == "plan-on new trip") {
      onPlanTripButtons()
    } else if (e == "contract-out") {
      if (gridFlagVal === 'partialTrips') {
        onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.contractOut',{});
      } else {
        onContractOutButton(getSelectedValues(null,true));
      }
    } else if (e == "set-free") {
      onSetFreeIconClick(Id);
    } else if (e == "calculate") {
      onCalculateIconClick(Id);
    } else if (e == 'show-on map') {
      onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.showOnMap', {});
    } else if (e === 'filter') {
      onFilterIconClick();
    } else if (e === 'table-rows') {
      onFreezeIconClick()
    } else if (e === 'view-columns') {
      onColumnIconClick();
    } else if (e === 'split-screen') {
      data.onSplitScreenClick(true)
    } else if (e === 'new-window') {
      onPopup(null);
    } else if (e === 'actions' || e === 'custom-actions') {
      return;
    } else {
      if (getSelectedValues().length > 0) {
        disptachDragEvent('click', gridFlagVal, e)
        navigate('/' + e);
      }
    }
  };

  const PlanNewPartialTrip = (url, flag, id, routeExpand, obj = null,data = null) => {
    if(obj == null) {
      obj= {
        "input" : "{}"
      }
    }
    setIsLoading(true);
    apiService.postWithId(url,flag,id,routeExpand,obj).then(response => {
      if (response) {
        const result = JSON.parse(response?.value);
        if (result?.parameters && result.parameters[0]?.type === 'APIGrid' && result.parameters[0]?.name === "transportAddress") {
          setPopupParameters({
            title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
            for: PlanFunctionsForFlag.InsertExtraAction,
            movementlines: null,
            result: result.parameters[0].entityName,
            input: null,
            obj: obj
          });
          setdepotModalTital(result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning)
          setOpenModalDepot(true);
        } else if (result?.parameters && ['Dialog.SelectRadioButton','APIGrid','Edm.String','Label'].includes(result.parameters[0].type)) {
          const param = {
            title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
            for: routeExpand === "Microsoft.NAV.newPartialTrip" ? PlanFunctionsForFlag.NewpartialTrip : PlanFunctionsForFlag.InsertExtraAction,
            parameters: result.parameters,
            options : data,
            obj : obj
          };
          setopenConfirmationModal(true);
          setCommonPopupParameters(param);
        } else if (result !== null && result !== undefined && result.status.toLowerCase() === 'ok') {
          onRefreshIconClick();
          setSuccessSnackbarAndMessage(i18_en.operationSuccessful);
          dispatch(refreshRouteAndPT({ isRefreshRouteAndPT: !partialTripReducerData.isRefreshRouteAndPT }))
        }
      }
    }).catch(error => {
      console.error('API error:', error);
    }).finally(() => {
      setIsLoading(false);
    })
  }

  const onPlanButtonsNetworkCall = (url, flag, id, routeExpand, obj, isDisplaySnackbar) => {
    apiService.postWithId(url,flag, id,routeExpand, obj).then(response => {
      if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
        setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
      } else {
        if (isDisplaySnackbar) {
          setSuccessSnackbarAndMessage(i18_en.operationSuccessful, false);
          setDrillDownFlagAndURL(true, response.value);
        } else {
          const url = response.value;
          window.open(url, '_blank');
        }
      }
    })
      .catch(error => {
        console.error('API error:', error);
      })
      .finally(() => {
        setIsLoading(false);
      })
  }

  const setDrillDownFlagAndURL = (flag = false, drillDownULR = '') => {
    setIsDisplayDrillDownButton(flag);
    setDrillDownButtonURL(drillDownULR);
  }

  const onPopup = (routeName, isClose) => {
    const gridRouteName = routeName ? routeName : data.routeName;
    if (isClose) {
      window.close();
    }
    const variable = 'is_' + gridRouteName + '_open';
    let isOpen = JSON.parse(storageService.getSeassionStorageData(variable));
    if (!isOpen) {
      const href = window.location.href
      const path = href.substring(0, href.lastIndexOf("/") + 0);
      const mapNewWindow = window.open(path + gridRouteName, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,height=200");
      storageService.setSeassionStorageData(variable, JSON.stringify(true));

      const checkWindowClosed = setInterval(() => {
        if (mapNewWindow?.closed) {
          clearInterval(checkWindowClosed);
          storageService.removeLocalStorageData('mapItem');
          storageService.removeLocalStorageData('listSelection');
          storageService.removeSeassionStorageData(variable);
        }
      }, 1000);
      return mapNewWindow;
    } else {
      return null;
    }
    
  }

  const onPlanTripButtons = () => {
    let actualSelectedIds = getSelectedValues(null, true), tempGridFlagVal = gridFlagVal;
    if (gridFlagVal == "partialTrips" && drageItems.source == "movements") {
      actualSelectedIds = drageItems.items.map(e => e.id);
      tempGridFlagVal = drageItems.source;
    }
    if (actualSelectedIds === null || actualSelectedIds === undefined || actualSelectedIds.length <= 0) {
      setErrorSnackbarOpen(true);
      setErrorSnackbarMessage(i18_en.selectAnyRow);
      return;
    }
    const movmentLines = service.movementObject(actualSelectedIds, tempGridFlagVal);
    const obj = service.movementLinesAndOperationDeatilObject(movmentLines, "{}", tempGridFlagVal);
    setIsLoading(true);
    apiService.post(planMovementsNew, obj).then(response => {
      if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
        setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
      } else {
        const result = JSON.parse(response?.operationDetail[0]?.result);
        if (result !== null && result !== undefined && result.parameters !== null && result.parameters !== undefined && result.parameters[0].name === 'tripDate') {
          let newDate = new Date(result.parameters[0].defaultValue);
          setCurrentDate(newDate);
          setOpenPlanNewTripPopup(true);
        }
      }
    })
      .catch(error => {
        console.error('API error:', error);
      })
      .finally(() => {
        setIsLoading(false);
      })
  }

  const handleDateChange = event => {
    let newDate = event.target.value;
    // console.log(newDate)
    setCurrentDate(newDate)
  }

  const planNewTrip = () => {
    let actualSelectedIds = getSelectedValues(null, true), tempGridFlagVal = gridFlagVal;
    if (gridFlagVal == "partialTrips" && drageItems.source == "movements") {
      actualSelectedIds = drageItems.items.map(e => e.id);
      tempGridFlagVal = drageItems.source;
    }
    let date = currentDate.getDate();
    let month = currentDate.getMonth() + 1;
    let year = currentDate.getFullYear();
    let tripDate = year + "-" + month + "-" + date;
    const movementObjects = service.movementObject(actualSelectedIds, tempGridFlagVal);
    const inputTripDateObject = {
      "tripDate": moment(tripDate).format('yyyy-MM-DD')
    };
    const obj = service.movementLinesAndOperationDeatilObject(movementObjects, JSON.stringify(inputTripDateObject), tempGridFlagVal);
    postPlanMovementsAPI(obj, movementObjects);
    setOpenPlanNewTripPopup(false);
  }

  const postPlanMovementsAPI = (obj, movementObjects, rSource) => {
    setIsLoading(true);
    apiService.post(planMovementsNew,obj).then(response => {
      if (response !== null && response !== undefined) {
        if (response.error !== null && response.error !== undefined && response.error) {
          setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
        } else {
          const result = JSON.parse(response?.operationDetail[0]?.result);
          const successMessage = result?.drillDownMessage ? result?.drillDownMessage : i18_en.tripCreatedSuccessfully;
          const drillDownURL = result?.drillDownUrl ? result?.drillDownUrl : '';
          if (service.apiResultChecker(result)) {
            const param = {
              title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
              for: PlanFunctionsForFlag.PlanMovementsNewNotification,
              parameters: result.parameters
            };
            setopenConfirmationModal(true);
            setCommonPopupParameters(param);
            if (service.apiOKResultChecker(result)) {
              setSuccessSnackbarAndMessage(successMessage);
              setDrillDownFlagAndURL(false, drillDownURL);
              setMySelectedState([]);
              sendDataToParent(true, 'refresh');
              if(window.location.hash.includes("#/CustomView")) {
                dispatch(refreshRouteAndPT({ isRefreshRouteAndPT: !partialTripReducerData.isRefreshRouteAndPT }))
              }
              if (rSource || refreshSource) {
                disptachDragEvent('refresh', 'movements', gridFlagVal)
                setRefreshSource(false)
              }
            }
          } else if (result?.parameters && (['Dialog.ConfirmSingleLine','Dialog.SelectRadioButton','Edm.Date'].includes(result.parameters[0]?.type))) {
            const input = response?.operationDetail[0]?.input ? JSON.parse(response?.operationDetail[0]?.input) : null;
            const param = {
              movementlines: movementObjects,
              title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
              for: PlanFunctionsForFlag.PlanMovementsNewConfirmation,
              parameters: result.parameters,
              input: input,
              obj : obj?.operationDetail[0]?.input
            };
            if (result.parameters[0].type === 'Dialog.ConfirmSingleLine') {
              param.data = result.data;
            } else if (result.parameters[0].type === 'Dialog.SelectRadioButton') {
              param.planOnPartialTrip = input?.planOnPartialTrip;
            }
            setopenConfirmationModal(true);
            setCommonPopupParameters(param);
          } else {
            if (service.apiOKResultChecker(result)) {
              setSuccessSnackbarAndMessage(successMessage);
              setDrillDownFlagAndURL(false, drillDownURL);
              setopenConfirmationModal(false);
              setMySelectedState([])
              sendDataToParent(true, 'refresh');
              dispatch(refreshRouteAndPT({ isRefreshRouteAndPT: !partialTripReducerData.isRefreshRouteAndPT }))
              if (rSource || refreshSource) {
                disptachDragEvent('refresh', 'movements', gridFlagVal)
                setRefreshSource(false)
              }
            }
          }
        }
      }
    })
      .catch(error => {
        console.error('API error:', error);
      })
      .finally(() => {
        setIsLoading(false);
      })
  }

  const onContractOutButton = (actualSelectedIds) => {
    const movementObjects = service.movementObject(actualSelectedIds, gridFlagVal);

    let obj = {
      "movementlines": movementObjects,
      "contractoutaction": [
        {
          "action": "contractout"
        }
      ]
    }
    apiService.post(postContractout,obj).then(response => {
      const callbackURL = response?.contractoutaction[0]?.callbackURL;
      if (callbackURL) {
        setMySelectedState({});
        window.open(callbackURL, '_blank');
      }
    })
  }

  const onPlanButtonDrillDownNVT = (url, actualSelectedIds, input = "{}") => {
    const movementObjects = service.movementObject(actualSelectedIds, gridFlagVal);
    const obj = service.movementLinesAndOperationDeatilObject(movementObjects, input, gridFlagVal);
    setIsLoading(true);
    apiService.post(url,obj).then(response => {
      if (response) {
        if (response.error) {
          setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
        } else {
          const result = JSON.parse(response?.operationDetail[0]?.result);
          if (result?.drillDownUrl) {
            window.open(result.drillDownUrl, '_blank');
          }
        }
      }
    })
    .catch(error => {
      console.error('API error:', error);
    })
    .finally(() => {
      setIsLoading(false);
    })
  }

  const onStartDateChange = (componentValue, e) => {
    // setFocusField(null)
    if (event.type == 'click') {
      const obj = { type: "blur", target: { value: e } }
      onStartDateSelection(componentValue.key, obj)
    }
  }
const getSelectedDateValue = (value) =>{  
  if(! (value instanceof Date)){
    value = parse(value, 'dd-MM-yyyy', new Date())
  }
  return value
}

  const onStartDateSelection = (key, value) => {
    let tempDate = typeof (value?.target?.value) == 'object' ? (service.tempFormat(value?.target?.value)) : (value?.target?.value)
    // setFocusField(null)
    if ((value.key == "Enter") || (value.type == "blur")) {
      let newValue = parse(tempDate, 'dd-MM-yyyy', new Date());
      if (newValue == 'Invalid Date' || (newValue < minDate) || (newValue > maxDate)) {
        setErrorSnackbarOpen(true);
        setErrorSnackbarMessage(i18_en.invalidDate);
        return;
      }

      const daysToShow = filterCompValues.find(e => e.key == 'daysToShow').value;
      const startVal = service.dateFormat(parse(tempDate, 'dd-MM-yyyy', new Date()), 'startDate', 0);
      const tempFilterCompValues = [...filterCompValues];
      sendDataToParent(tempDate,"updateStartDate")
      tempFilterCompValues.find(e => e.key == key).value = tempDate;
      setFilterCompValues(tempFilterCompValues);
      if (daysToShow > 0) {
        const endVal = service.dateFormat(parse(tempDate, 'dd-MM-yyyy', new Date()), 'startDate', parseInt(daysToShow));
        newValue = startVal + ".." + endVal;
      } else {
        newValue = ">=" + startVal;
      }

      if (newValue !== undefined && newValue !== null) {
        const tarrFilterData = _.cloneDeep(filterSortArr.filterArray);
        const filteredField = tarrFilterData.find(e => e.field == key)
        if (!_.isNil(filteredField)) {
          filteredField.value = newValue;
          setFilterSortArr({ ...filterSortArr, filterArray: tarrFilterData });
        }
      }

    }
  }

  const onDayChange = (componentValue, e) => {
    // setFocusField(null)
    if (event.type == 'keydown' || event.type == 'click' || event.type == 'focusout') {
      let key = componentValue.key;
      let newValue;
      if (event.type == 'click') {
        newValue = e.value ? e.value : e.target.value//e.syntheticEvent.target.value
      } else {
        newValue = e.value ? e.value : e.syntheticEvent.target.value
      }      
      if (key === 'daysToShow' && parseInt(newValue) > 36500) {
        setErrorSnackbarOpen(true);
        setErrorSnackbarMessage(i18_en.daysNotGgreater36500);
        return;
      } else if (key === 'daysToShow' && parseInt(newValue) < 0) {
        setErrorSnackbarOpen(true);
        setErrorSnackbarMessage(i18_en.daysNotLess0);
        return;
      }
      if (newValue == 0) {
        newValue = ""
      }
      if (_.isString(newValue)) {
        newValue = newValue.replaceAll(",", "")
      }
      sendDataToParent(newValue,"updateDays")
      const tempFilterCompValues = [...filterCompValues];
      tempFilterCompValues.find(e => e.key == key).value = newValue;
      setFilterCompValues(tempFilterCompValues);
      let startDate = tempFilterCompValues.find(e => e.key == componentValue.relationalField).value;

      if(/^\d{2}-\d{2}-\d{4}$/.test(startDate)) {
        startDate = moment(startDate, 'DD-MM-YYYY').format('ddd MMM DD YYYY HH:mm:ss');
      } 
      const startVal = service.dateFormat(startDate, 'startDate', 0);
      if (newValue != "") {
        if (newValue > 0) {
          const endVal = service.dateFormat(startDate, 'startDate', parseInt(newValue));
          newValue = startVal + ".." + endVal;
        }
      } else {
        newValue = ">=" + startVal;
      }
      if (componentValue.relationalField) {
        const tarrFilterData = _.cloneDeep(filterSortArr.filterArray);
        const filteredField = tarrFilterData.find(e => e.field == componentValue.relationalField)
        if (!_.isNil(filteredField)) {
          filteredField.value = newValue;
          setFilterSortArr({ ...filterSortArr, filterArray: tarrFilterData });
        }
      }
    }
  }

  const onStatusChange = (key, value) => {
    // setFocusField(null)
    let newValue = value?.target?.value
    if (_.isObject(value?.target?.value)) {
      if (gridFlagVal === 'movements' && gridFlagValFor === 'movements') {
        newValue = value?.target?.value?.value
      } else {
        newValue = value?.target?.value.code
      }
    }
    const tempFilterCompValues = [...filterCompValues];
    tempFilterCompValues.find(e => e.key == key).value = value?.target?.value;
    setFilterCompValues(tempFilterCompValues);
    setcurrSelectedStatus(newValue)
    sendDataToParent(value?.target?.value,"updateStatus")
    if (newValue !== undefined && newValue !== null) {
      let tarrFilterData = _.cloneDeep(filterSortArr.filterArray);
      const filteredField = tarrFilterData.find(e => e.field == key)
      if (!_.isNil(filteredField)) {
        const input = filteredField.value.match(/[<>=!]+/)[0]
        if (newValue == "") {
          filteredField.value = newValue
        } else {
          filteredField.value = input + newValue
        }
        if(key == "resourceType") {
          tarrFilterData = tarrFilterData.map(item => {
            if (item.field === 'planGroup') {
              return {...item,value: `=${newValue}`};
            }
            return item;
          });
        }
        setFilterSortArr({ ...filterSortArr, filterArray: tarrFilterData });
      }
    }
  };

  const itemChange = (event) => {
    let field = event.field || editableCol;
    let dataItem = (event.dataItem && event.dataItem[griddDtaItemKey]) ? event.dataItem[griddDtaItemKey] : editableRow[griddDtaItemKey];

    let newData = gridTempData?.data?.map((item) => {
      if (item[griddDtaItemKey] === dataItem) {
        return {
          ...item,
          [field || '']: event.value
        };
      }
      return item;
    });

    setGridTempData({ data: newData });
  };

  const enterEdit = (dataItem, field, id) => {
    const newData = gridTempData?.data?.map((item) => ({
      ...item,
      [EDIT_FIELD]: item[griddDtaItemKey] === dataItem[griddDtaItemKey] ? field : undefined
    }));
    setGridTempData({ data: newData })
    const editData = newData?.filter(item => item.id === id);
    if (editData[0]?.inEdit !== undefined) {
      setEditFieldVal(editData[0].planInfo);
    }
  };

  const exitEdit = () => {
    const newData = gridTempData?.data?.map((item) => ({
      ...item,
      [EDIT_FIELD]: undefined
    }));
    setGridTempData({ data: newData })
  };

  const customCellRender = (td, props) => {
    if (gridFlagVal == "movements") {
      let measureField = (selectedTableRows !== null && selectedTableRows !== undefined && selectedTableRows.length > 0) ? selectedTableRows : null;
      if (td && td.props.children && props.rowType === "groupHeader") {
        let children = (
          <>
            <span>
              {td.props.children.props.children}
            </span>
            <span style={{ marginLeft: '40px' }}>
              <span style={{ backgroundColor: '#e3ecf1', padding: '5px', marginLeft: '10px' }}>
                Items :
                {props.dataItem.items.length}
              </span>
              {measureField?.includes("LoadingLength") && <span style={{ backgroundColor: '#e3ecf1', padding: '5px', marginLeft: '5px' }}>
                LL (lm) :{" "}
                {props.dataItem.aggregates.length.sum}
              </span>}
              {measureField?.includes("Volume") && <span style={{ backgroundColor: '#e3ecf1', padding: '5px', marginLeft: '5px' }}>
                Volume (m3) :{" "}
                {props.dataItem.aggregates.volume.sum}
              </span>}
              {measureField?.includes("Weight") && <span style={{ backgroundColor: '#e3ecf1', padding: '5px', marginLeft: '5px' }}>
                Weight (kg) :{" "}
                {props.dataItem.aggregates.weight.sum}
              </span>}
              {measureField?.includes("Quantity") && <span style={{ backgroundColor: '#e3ecf1', padding: '5px', marginLeft: '5px' }}>
                Quantity (No.) :{" "}
                {props.dataItem.aggregates.quantity.sum}
              </span>}
              {measureField?.includes("NetWeight") && <span style={{ backgroundColor: '#e3ecf1', padding: '5px', marginLeft: '5px' }}>
                Net Weight (kg) :{" "}
                {props.dataItem.aggregates.netWeight.sum}
              </span>}
            </span>
          </>
        );
        return React.cloneElement(td, td.props, children);
      }
      return (
        <CellRender
          originalProps={props}
          td={td}
          enterEdit={(dataItem, field) => enterEdit(dataItem, field, props.dataItem.id)}
          editField={EDIT_FIELD}
        />)
    }
    return (
      <CellRender
        originalProps={props}
        td={td}
        enterEdit={(dataItem, field) => enterEdit(dataItem, field, props.dataItem.id)}
        editField={EDIT_FIELD}
      />
    )
  };

  const checkRowClick = (e, isEdit = true) => {
    if (data.gridDraggable == false) {
      return;
    }
    const cell = event.target.closest('td');
    const checkbox = cell?.querySelector('input[type="checkbox"]');

    if (cell) {
      // Get the column field name from the column index
      const columnIndex = cell.cellIndex;
      const columnName = tempGridColumns[columnIndex - 1]?.field;

      if ((editField !== columnName && !editableColumn?.includes(columnName)) || (editableCell !== null && isEdit)) {
        setEditableCell(null);
      }

      let flag = 0;
      const selectedRows = Object.entries(myselectedState).filter(([key, value]) => value === true).map(([key]) => key);
      for (const selectedRow of selectedRows) {
        if (selectedRow === e.dataItem?.id) {
          flag = 1;
          break;
        }
      }
      if (flag === 1) {
        return;
      }

      if (event.ctrlKey) {
        gridOnRowClick(e.dataItem, 'ctrl')
        if (!indexSelectedRow.includes( gridNewData.findIndex(item => item.id === e.dataItem.id))) {
          setIndexSelectedRow([...indexSelectedRow,  gridNewData.findIndex(item => item.id === e.dataItem.id)]);
        }
        setStartRowIndex( gridNewData.findIndex(item => item.id === e.dataItem.id))
      } else if (event.shiftKey && startRowIndex !== null) {
        const endRowIndex = gridNewData.findIndex(item => item.id === e.dataItem.id)
        const start = Math.min(startRowIndex, endRowIndex);
        const end = Math.max(startRowIndex, endRowIndex);
        let rangeSelection = gridNewData?.slice(start, end + 1); 

        setKeySelectedRows([...keySelectedRows,...rangeSelection]) 
        let newArr = [...rangeSelection,gridNewData[indexSelectedRow[0]]]

        if(keySelectedRows.length > 0)
          newArr =  [...newArr, ...keySelectedRows];

        gridOnRowClick(newArr, 'shift')
      } else {
        setKeySelectedRows([]) 
        setIndexSelectedRow([gridNewData.findIndex(item => item.id === e.dataItem.id)]);
        setStartRowIndex(gridNewData.findIndex(item => item.id === e.dataItem.id))
        gridOnRowClick(e.dataItem)
      }
    }
  }
  const tdata = service.processWithGroups(setSelectedValue(gridTempData?.data ? gridTempData?.data : gridTempData, myselectedState), myGridDataState)
  // const datax = gridTempData?.data ? gridTempData?.data?.slice(skip, skip + pageSizeValue)  : []
  // console.log(tdata)

  // setGridUpdatedData(tdata)
  let newData = setExpandedState({
    data: tdata?.data,
    collapsedIds: collapsedState,
  });

  const columnResize = (e) => {
    setTempGridColumns(prevTempGridColumns => {
      const updatedColumns = prevTempGridColumns?.map(col => {
        const resizedColumn = e?.columns?.find(c => c.field === col.field);
        if (resizedColumn) {
          return { ...col, width: resizedColumn.width };
        }
        return col;
      });
      return updatedColumns;
    });
    setFocusField(null)
  }

  const columnReorder = (e) => {
    const reorderedArr = [];
    const tempCols = e.target._columns?.map(c => c.field);

    const updatedColsList = [
      ...service.nonReorderableColumns.filter(item => tempCols.includes(item)),
      ...tempCols.filter(item => !service.nonReorderableColumns.includes(item))
    ];
    updatedColsList?.splice(0, 1);

    updatedColsList?.forEach((fieldName, index) => {
      const item = tempGridColumns?.find(item => item.field === fieldName);
      if (item) {
        reorderedArr.push({ ...item, orderIndex: index + 1 });
      }
    });

    setReorderedCols(updatedColsList);
    setTempGridColumns(reorderedArr);
    setFocusField(null)
  }

  const planFunctionTooltip = (key, title) => {
    if (key === 'Create Trips') {
      return displayCreateTripToolTip;
    } else if (key === 'Process Trips') {
      return displayProcessTripToolTip;
    } else if(key === 'Move To LU') {
      return displayMoveToLUToolTip;
    }else {
      return title;
    }
  }

  const PlanNewTripData = (prop) => {
    if (prop?.sendDataToParent) {
      setTimeout(() => {
        prop.sendDataToParent("planNewPopup");
      }, 100);
    }

    return (
      <Box
        sx={{
          bgcolor: "background.paper",
          p: 2
        }}
        id="planNewPopup"
      >
        <Typography variant="body2" sx={{ pr: .5 }}>Trip Date:</Typography>

        <KendoDatePicker defaultValue={currentDate || null} min={minDate} max={maxDate} onChange={handleDateChange} required={true} format={"dd-MM-yyyy"}/>
      </Box>
    )
  }

  const PlanNewTripActionButtons = () => {
    return (
      <>
        <Button variant="contained" style={{}} onClick={planNewTrip}>
          OK
        </Button>
        <Button variant="outlined" onClick={() => setOpenPlanNewTripPopup(false)}>
          Cancel
        </Button>
      </>
    )
  }

  const saveSortColumnChooserPopUpData = (value, flag) => {
    if (flag === 'deleteSavedSortKeyView') {
      if (gridFlagVal !== 'trip') {
        fetchUpdateSavedViews(gridFlagValFor, value.views, true, true);
      }
      setSortKeyViews(value.parsedData);
    } else if (flag === 'saveNewViewSortKey') {
      if (gridFlagVal !== 'trip') {
        if (savedViewsApiData?.length == 0) {
          postSavedViewsData(gridFlagValFor).then(response => {
            fetchUpdateSavedViews(gridFlagValFor, value.views, true, true);
            setSavedViewsApiData(response);
          });
        } else {
          fetchUpdateSavedViews(gridFlagValFor, value.views, true, true);
        }
      }
      setSortKeyViews(value.sortKeyViews);
    } else if (flag === 'sortColumnsData') {
      saveSortColumnsData(value);
    }
  }

  const saveSortColumnsData = (columnData) => {
    let arr = []
    setTempGridColumns(oldData => {
      let updatedData = oldData.map(item => {
        if (columnData?.groupByColumnVal?.includes(item.title)) {
          arr.push({ field: item.field, title: item.title });
          if (columnData?.freezeColumnVal?.includes(item.title)) {
            return { ...item, locked: true };
          } else {
            return { ...item, locked: false };
          }

        } else if (columnData?.freezeColumnVal?.includes(item.title)) {
          return { ...item, locked: true };
        } else {
          return { ...item, locked: false };
        }
      });

      if (reorderedCols?.length > 0) {
        updatedData = service.existingColumns(reorderedCols, updatedData);
      }

      return updatedData;
    });
    setGridColumns(oldData => {
      const updatedData = oldData.map(item => {
        if (columnData?.freezeColumnVal?.includes(item.title)) {
          return { ...item, locked: true };
        } else {
          return { ...item, locked: false };
        }
      });
      return updatedData;
    });
    const sortedArr = _.sortBy(arr, function (item) { return columnData?.groupByColumnVal?.indexOf(item.title) });
    setGroup(sortedArr);
    setcolumnChooser(sortedArr);

    setGridKey(gridKey + 1);
    setTreeviewSelectedValues({})
    if (sortedArr.length > 0) {
      setFlagShow(true)
      setExpanded("panel2")
      if (loadSelectionValue != "All") {
        data.onLoadSelectionChange({ value: "All" })
      }
      const tempDataState = { ...myGridDataState, take: gridLoadedGridData?.data.length };
      const aggregatesData = service.processWithGroups(gridLoadedGridData?.data, { ...tempDataState, group: sortedArr });
      if (aggregatesData.data.length > 0) {
        onSetGroupTreeviewData(aggregatesData.data);
      }
    } else {
      onSetGroupTreeviewData([]);
      setExpanded("panel1")
    }
    setMySelectedState([])
    setGridTempData(service.processWithGroups(gridLoadedGridData?.data, { sort: myGridDataState?.sort }))

    const sortData = columnData?.colMultiFilter.sortColumnsData.map(item => ({
      field: item.field,
      dir: item.order,
      title: item.title
    }));
    setFilterSortArr({ ...filterSortArr, sortArray: sortData });
    setSavedSortColData(sortData);
    setGroupByColumnVal(columnData.groupByColumnVal);
    setFreezeColumnVal(columnData.freezeColumnVal);
    setColMultiFilter(columnData.colMultiFilter);
    setIsMultiSort(true);
  }

  const DeleteConfirmationComponent = (prop) => {
    if (prop?.sendDataToParent) {
      setTimeout(() => {
        prop.sendDataToParent('deletePopup');
      }, 100);
    }

    return (
      <Box sx={{ width: 350, bgcolor: "background.paper", p: 3 }} id="deletePopup">
        <Typography variant="h6" sx={{ pr: .5, justifyContent: 'center', fontSize: '15px' }}>{i18_en.deleteConfirmationMessage}{" "}<span style={{ fontWeight: "bold" }}>{deleteItem?.text}</span> item?</Typography>
      </Box>
    )
  }

  const RenderActionButtons = () => {
    return (
      <>
        <Button
          variant="outlined"
          size="small"
          onClick={deleteSaveViewCancel}
        >
          Cancel
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={deleteSaveViewConfirm}
        >
          Confirm
        </Button> 
      </>
    )
  }

  // --- Common method END ---
  return (
    <>
      {/* <Box component="main" sx={{ flexGrow: 1, p: 0, pb: 0 }} className="max-wgrid"> */}
      {isLoading ? (<Spinner />) : (<></>)}
      <Box sx={{ p: 0, display: 'flex' }} className="filterbar-bg ">

        {isShow &&
          <Grid item={true} component={Card} elevation={0} width={groupTreeViewData.length > 0 ? 350 : 250} square className='overflow-datafix' sx={{ backgroundColor: 'info.light' }}>
            <CardContent sx={{ padding: 0 }}>
              <Box sx={{ flexGrow: 0, p: 1, backgroundColor: 'info.light', marginBottom: 0 }}>
                <div style={{ position: 'relative' }}>
                  {!data.hideSavedView && <IconButton aria-label="Save" color='primary' sx={{ padding: .3, position: 'absolute', right: 3, top: 3, zIndex: 10 }} onClick={addNewView}>
                    <SaveIcon />
                  </IconButton>}
                  <Accordion className="mui-acc" expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                    {(!data.hideSavedView) && <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Tooltip placement="bottom" title={displaySaveToolTip}>
                      <Typography variant="body2" sx={{ fontWeight: 'bold', paddingLeft: .5 }} color="primary" gutterBottom>My Views</Typography>
                    </Tooltip>
                    </AccordionSummary>}
                    <AccordionDetails>
                      {(!data.hideSavedView) && <Box className='border-b' sx={{ marginBottom: 1 }}>
                        <TreeView
                          data={processTreeViewItems(treeViewData, {
                            select: selectTreeView,
                            expand: expand,
                          })}
                          item={treeViewItem}
                          onItemClick={onTreeViewClick}
                          expandIcons={true}
                          onExpandChange={onExpandSubViews}
                          className="top-viewitem"
                        />
                      </Box>}
                      {!data.isChild && 
                        <>
                          <Box className='border-b' sx={{ flexGrow: 0, p: 0, backgroundColor: 'info.light', marginBottom: 1 }}>
                            <Stack spacing={1} sx={{}}>
                              {filterCompValues && filterCompValues?.map((component, index) => {
                                return (
                                  <>
                                    {component.visible === undefined &&
                                      <Box key={index} sx={{ justifyContent: 'center' }}>
                                        <Typography variant="body2" sx={{ pr: 0.5 }}>{component.label} :</Typography>
                                        {component.type === 'DatePicker' && (
                                          <DatePicker
                                            dateFormat="dd-MM-yyyy"
                                            showIcon
                                            todayButton="Today"
                                            selected={getSelectedDateValue(component.value) || null}
                                            minDate={minDate}
                                            maxDate={maxDate}
                                            autoComplete="off"
                                            onKeyDown={(value) => onStartDateSelection(component.key, value)}
                                            onBlur={(value) => onStartDateSelection(component.key, value)}
                                            onChange={(value) => { onStartDateChange(component, value) }}
                                          />
                                        )}
                                        {component.type === 'NumericTextBox' && (
                                          <NumericTextBox
                                            placeholder={component.placeholder}
                                            format="n"
                                            min={0}
                                            max={36500}
                                            autoComplete="off"
                                            value={component.value || ''}
                                            valid={component.value < 36500 && component.value > -1}
                                            onChange={(value) => onDayChange(component, value)}
                                            onBlur={(value) => onDayChange(component, value)}
                                          />
                                        )}
                                        {component.type === 'DropDownList' && gridFlagVal === 'movements' && gridFlagValFor === 'movements' && (
                                          <DropDownList
                                            data={component.data}
                                            textField={"caption"}
                                            dataItemKey={"caption"}
                                            value={component.value || ''}
                                            onChange={(value) => onStatusChange(component.key, value)}
                                            onBlur={(item) => onStatusChange(component.key, item)}
                                          />
                                        )}
                                        {component.type === 'DropDownList' && gridFlagVal !== 'movements' && gridFlagValFor !== 'movements' && (
                                          <DropDownList
                                            data={component.data}
                                            gridFlagVal={"partialTrips"}
                                            textField={gridFlagVal == "partialTrips" ? "status" : "code"}
                                            dataItemKey={gridFlagVal == "partialTrips" ? "status" : "code"}
                                            value={component.value || ''}
                                            onChange={(value) => onStatusChange(component.key, value)}
                                            onBlur={(item) => onStatusChange(component.key, item)}
                                          />
                                        )}
                                      </Box>
                                    }
                                  </>

                                )
                              }
                              )}
                            </Stack>
                          </Box>
                          <Box className="filterExternal border-b" sx={{ flexGrow: 0, p: 0, backgroundColor: 'info.light', marginBottom: 1 }}>
                            <Box direction="row" alignItems="center" justifyContent="space-between" spacing={0} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <Typography variant="body2" sx={{ fontWeight: 'bold' }} color="primary" gutterBottom>
                                Filter List By
                              </Typography>
                              <IconButton aria-label="Add" color='primary' onClick={addCard} sx={{ padding: .3 }} style={{ marginLeft: 'auto' }}>
                                <AddIcon />
                              </IconButton>
                               {!data.hideSavedView && <IconButton aria-label="Save" color='primary' sx={{ padding: .3 }} onClick={addNewView}>
                                <SaveIcon />
                              </IconButton>}
                            </Box>
                            <Box >
                              {cards?.map((_, index) => (
                                <div key={index}>
                                  <select
                                    value={selectedFields[index]?.name ? selectedFields[index].name : []}
                                    disabled={selectedFields[index]?.name}
                                    onChange={(e) => handleFieldChange(e, index)}
                                    className='form-control w200'
                                  >
                                    <option value="" disabled>Select Field</option>
                                    {availableFields[index] && availableFields[index].map((field) => (
                                      <option key={field.label} value={field.name}>
                                        {field.label}
                                      </option>
                                    ))}
                                  </select>
                                  <IconButton aria-label="Add" className='closeicn' onClick={() => removeCard(index)} sx={{ p: 0 }} >
                                    <CloseIcon />
                                  </IconButton>
                                  {/* <input
                                type="text"
                                className="form-control w200"
                                disabled={!selectedFields[index]?.name}
                                ref={(ref) => (inputRefs.current[index] = ref)}
                                // value={selectedFields[index]?.value}
                                value={selectedFields[index]?.value}
                                onChange={(e) => handleFilterChange(e, index)}
                                onKeyUp={(e) => onfilterApply(e, index)}
                                // value={selectedFields[index]?.value}
                                // onBlur={(e) => onKeyPress(e)}
                                onBlur={(e) => onfilterApply(e, index)}
                              /> */}
                                  <CustomFilterCellRender index={index} />
                                </div>
                              ))}

                            </Box>
                          </Box>
                        </>
                      }
                    </AccordionDetails>
                  </Accordion>
                  {groupTreeViewData.length > 0 &&
                    <Accordion className="mui-acc groupTree" expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                      <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                        <Typography variant="body2" sx={{ fontWeight: 'bold', marginBottom: 0, paddingLeft: .5 }} color="primary" gutterBottom>Grouping</Typography>
                      </AccordionSummary>
                      <AccordionDetails>

                        <Box className='border-b' sx={{ flexGrow: 0, p: 1, backgroundColor: 'info.light', marginBottom: 0 }}>
                          {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }} color="primary" gutterBottom>
                      Grouping
                    </Typography>
                  </Box> */}
                          <Box>
                            <TreeView
                              ref={groupTreeviewRef}
                              data={processTreeViewItems(groupTreeViewData, {
                                select: selectGroup,
                                expand: expandGroup,
                              })}
                              item={treeViewGroupItem}
                              textField="value"
                              expandIcons={true}
                              onExpandChange={onExpandGroup}
                            />
                          </Box>
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  }
                </div>
                {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }} color="primary" gutterBottom>
                      My Views
                    </Typography>
                    <IconButton aria-label="Save" color='primary' onClick={addNewView}>
                      <SaveIcon />
                    </IconButton>
                  </Box> */}

                {/* open modal for save filtered data */}
                {openModalFilter && <SaveFilteredPopUp treeViewData={treeViewData} gridFlagVal={data.gridFlagValFor} tempGridColumns={tempGridColumns} myGridDataState={myGridDataState} columnChooser={columnChooser} openModalFilter={openModalFilter} setOpenModalFilter={setOpenModalFilter} filterCompValues={filterCompValues} filterSortArr={filterSortArr} sendDataToParent={saveFilteredPopUpData} reorderedCols={reorderedCols} isChild={data.isChild} />}
              </Box>
            </CardContent>
          </Grid>
        }

        <Grid item={true} elevation={0} className="disable-in-custom-view" sx={{ flexGrow: 0, pl: '0', alignItems: 'center' }}>
          <Box className="arrow-btn" onClick={handleClick}>
            {isShow ? <ArrowBackIosRoundedIcon color='secondary.contrastText' /> : <ArrowForwardIosRoundedIcon color='secondary.contrastText' />}
          </Box>
        </Grid>


        <Grid item={true} xs component={Card} elevation={0} pl={0} sx={{ flexGrow: 1 }} className='grid-movement'>
          {/* position: { md: "absolute", lg: "absolute" } */}
          <Stack direction="row" className='disable-in-custom-view' spacing={1} zIndex={50} sx={{ position: 'absolute', borderRadius: 3, right: 2, top: { md: "0", lg: "4px", justifyContent: 'end', marginBottom: "10px" } }}>
            {/* Plan Actions */}
            {gridPlanAction?.length > 0 && gridPlanAction.map((item) => {
              if(toggleconfigcheckboxesplan[item] && service.planActions.filter(e => e.key == item).length > 0){
                const planActionBtn = service.planActions.filter(e => e.key == item)[0]

                return (
                  <>
                    <span>
                      <Tooltip placement="bottom" title={planFunctionTooltip(planActionBtn?.key, planActionBtn?.title)}>
                        <span>
                          {planActionBtn?.btnType == "Button" && (
                            <Button variant="outlined"
                              onClick={() => eval(planActionBtn?.onClick)}
                              disabled={eval(planActionBtn?.disabled)}
                              size="small" sx={{ px: .0, minWidth: '34px' }}>
                              {planActionBtn.icon}
                            </Button>
                          )
                                }
                          {planActionBtn.btnType == "IconButton" && (
                            <IconButton size="large" sx={{ m: 0, p: 0, marginTop: .5, }} color="primary"
                              onClick={() => eval(planActionBtn?.onClick)}
                              disabled={eval(planActionBtn?.disabled)}>
                              {planActionBtn.icon}
                            </IconButton>
                          )}
                        </span>
                      </Tooltip>
                    </span>
                  </>
                )
              }
            })}
            {/* Data Related Actions */}
            {updatedGridDataAction?.length > 0 && updatedGridDataAction.map((item) => {
              if(toggleconfigcheckboxes[item] && service.dataActions.filter(e => e.key == item).length > 0){
                const dataActionBtn = service.dataActions.filter(e => e.key == item)[0]
                if(eval(dataActionBtn?.isVisible))
                  return (
                    <>
                      <span>
                        <Tooltip placement="bottom" title={dataActionBtn?.title}>
                          <span>
                            {dataActionBtn.btnType == "IconButton" && (
                              <IconButton size="large" sx={dataActionBtn?.sx} color="primary"
                                id={dataActionBtn?.id}
                                aria-haspopup={dataActionBtn?.ariaHaspopup}
                                onClick={(e) => eval(dataActionBtn?.onClick)}>
                                {dataActionBtn.icon}
                              </IconButton>
                            )}
                          </span>
                        </Tooltip>
                      </span>
                    </>
                  )
                return null
              }
            })}
            {/* Custom Actions */}
            {toggleconfigCustomActioncheckboxes && Object.keys(toggleconfigCustomActioncheckboxes)?.length > 0 && data?.customActions?.length > 0 && data?.customActions?.map((item, index) => {
              const trueKeys = Object.entries(toggleconfigCustomActioncheckboxes)?.filter(([key, value]) => value === true)?.map(([key, value]) => key);
              if(trueKeys?.includes(item.caption)) {
                return (
                  <span key={index}>
                    <Tooltip placement="bottom" title={item.caption}>
                      <span>
                        <IconButton size="large" color="primary" sx={{ m: 0, p: 0, marginTop: .5 }}
                          onClick={(e) => onPlanButtons(item.id, getSelectedValues(), null, true)}>
                          {service.getActionsIcon(item?.iconName)}
                        </IconButton>
                      </span>
                    </Tooltip>
                  </span>
                )
              }
            })}

            {isPin &&
              <span>
                <IconButton size="large" sx={{ pointerEvents: 'all !important', m: 0, p: 0, marginTop: .5, }} style={{ transform: `rotate(${isActive ? '0deg' : '45deg'})` }} color="primary"
                  onClick={(event) => onPushpinIconClick(event)}
                >
                  <PushPinOutlinedIcon />

                </IconButton>
              </span>
            }
          </Stack>

          {/* <Box zIndex={1} sx={{ mt: 0, position: 'absolute', left: '5px', top: '10px', fontWeight: 'bold', color: 'primary.main' }}>
            {gridData.data?.length} items on grid
          </Box> */}

          {/* {treeviewSelectedValues.aggregates &&
            <Box zIndex={1} sx={{ display: 'flex', gap: '2px', marginLeft: '5px', mt: 0, position: 'absolute', left: '5px', top: '35px', }}>
              <span style={{ backgroundColor: 'rgba(0,0,0,.1)', padding: '0 3px', borderRadius: '3px' }}>L
                :{" "} {treeviewSelectedValues.aggregates.length.sum}
              </span>
              <span style={{ backgroundColor: 'rgba(0,0,0,.1)', padding: '0 3px', borderRadius: '3px' }}>V
                :{" "} {treeviewSelectedValues.aggregates.volume.sum}
              </span>
              <span style={{ backgroundColor: 'rgba(0,0,0,.1)', padding: '0 3px', borderRadius: '3px' }}>W
                :{" "} {treeviewSelectedValues.aggregates.weight.sum}
              </span>
              <span style={{ backgroundColor: 'rgba(0,0,0,.1)', padding: '0 3px', borderRadius: '3px' }}>Q
                :{" "} {treeviewSelectedValues.aggregates.quantity.sum}
              </span>
              <span style={{ backgroundColor: 'rgba(0,0,0,.1)', padding: '0 3px', borderRadius: '3px' }}>N
                :{" "} {treeviewSelectedValues.aggregates.netWeight.sum}
              </span>
            </Box>
          } */}
          <Box zIndex={1} className='disable-in-custom-view' sx={{ mt: 0, position: 'absolute', left: '5px', top: '8px', fontWeight: 'bold', color: 'primary.main' }}>

            <DropDownList
              variant="contained"
              size="small"
              sx={{ lineHeight: 1.5 }}
              color="primary"
              data={[100, 200, 500, "All"]}
              value={loadSelectionValue}
              disabled={columnChooser.length > 0}
              onChange={(value) => data.onLoadSelectionChange(value)}
            />
          </Box>
          <Box zIndex={1} sx={{ mt: 0, position: 'absolute', left: '75px', top: '8px', fontWeight: 'bold', color: 'primary.main' }}>
            {gridtotalData &&
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {/* {(loadSelectionValue == gridTempData?.data?.length && gridTempData?.data?.length == gridLoadedGridData?.data?.length) ? '' : gridTempData?.data?.length} / {gridtotalData} rows */}
                {(isLoading == false && loadSelectionValue == "All") ? gridTempData?.data?.length : ''} / {gridtotalData} rows
              </Typography>}
          </Box>

          <Box zIndex={1} className={columnChooser.length > 0 && 'filtergroup'} sx={{ height: "30px", mt: 0, left: '180px', top: '8px', fontWeight: 'bold', color: 'primary.main', position: 'absolute' }}>
            <div class="" role="toolbar" aria-label="Group panel" aria-controls="6295d786-04d2-4ee0-9393-1be81710a3c8">
              <div class="k-chip-list k-chip-list-md" role="none">
                {columnChooser.length > 0 && columnChooser.map((item) => {
                  return (
                    <div class="k-chip k-chip-md k-chip-solid k-chip-solid-base k-rounded-md me-1" role="button" >
                      <span>
                        <span class="k-icon k-svg-icon k-svg-i-sort-asc-small k-icon-sm">
                          <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path d="M256 192v224h-32V192h-96L240 64l112 128h-96z"></path></svg>
                        </span>
                      </span>
                      <span class="k-chip-content">{item.title}</span>
                      <span class="k-chip-actions">
                        <span class="k-chip-action k-chip-remove-action" onClick={e => onColumnChange(e, item)}>
                          <span class="k-icon k-svg-icon k-svg-i-x-circle k-icon-sm">
                            <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                              <path d="M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224 224-100.3 224-224S379.7 32 256 32zm128 306.7L338.7 384 256 301.3 173.3 384 128 338.7l82.7-82.7-82.7-82.7 45.3-45.3 82.7 82.7 82.7-82.7 45.3 45.3-82.7 82.7 82.7 82.7z"></path></svg>
                          </span>
                        </span>
                      </span>
                    </div>
                  )
                })}
              </div>
              <div class="k-grouping-drop-container">&nbsp;</div>
            </div>
          </Box>
          <div
            ref={data.gridRef}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => myOnDrop(e)}
            className="disable-in-custom-view select-custom"
            style={{ maxHeight: 'calc(100%)', height: '100%', minHeight: data?.isPopup ? '650px' : '' }}
          >
            {/* <KendoReactGrid
              ref={data.gridRef}
              groupable={true}
            ></KendoReactGrid> */}

            <KendoReactGrid
              style={{
                // height: '95%',
                height: columnChooser.length > 0 ? "calc(100% - 78px)" : "calc(100% - 40px)",
              }}
              data={newData}
              ref={gridRef}
              key={gridKey}
              //?.map((item) => ({
              //   ...item,
              //   ["selected"]: myselectedState[myGrididGetter(item)],
              // }))}
              dataItemKey={griddDtaItemKey}
              selectedField={"selected"}
              // expandField={"expanded"}
              onItemChange={itemChange}
              rowRender={gridRowRender}
              cellRender={customCellRender}
              editField={EDIT_FIELD}
              // onScroll={data.gridOnscroll}
              // onExpandChange={myGridOnExpandChange}
              rowHeight={20}
              pageSize={pageSizeValue}
              total={gridTempData?.data?.length}
              scrollable={'virtual'}
              // skip={skip}
              onDataStateChange={mygridOnDataStateChange}//data.gridOnDataStateChange}
              // onPageChange={pageChange}
              {...myGridDataState}
              onSelectionChange={myOnSelectionChange}//{myOnSelectionChange}//data.gridOnSelectionChange}
              onHeaderSelectionChange={myOnHeaderSelectionChange}//data.gridOnHeaderSelectionChange}
              onRowClick={checkRowClick}
              onContextMenu={handleContextMenu}
              onColumnResize={columnResize}
              onColumnReorder={columnReorder}
              onSortChange={gridOnSortChange}
              // fixedScroll={true} 
              // scrollable="virtual"
              // columnVirtualization={true}
              sortable={{
                mode: "multiple"
              }}
              selectable={{
                enabled: (data.selectableMode ? true : false),
                drag: false,
                cell: false,
                mode: data.selectableMode === "single" ? data.selectableMode : "multiple",
              }}
              // onFilterChange={FilterChangeForGrid}
              // filter={filter}
              // total={gridLoadedGridData?.data.length}
              // rowHeight={40}
              // pageSize={75}
              // pageable={{
              //   buttonCount: 4,
              //   // pageSizes: [100, 200, 500, "All"],
              //   pageSizeValue: pageSizeValue,
              // }}
              // onPageChange={pageChange}//data.gridonPageChange}
              // skip={skip}
              // take={page.take}
              // selectable={ data.gridFlagVal == 'depot'? {
              //   mode:'single'
              // }: {mode:'multiple'}}
              filterable={isFilterable}
              // groupable={true}
              resizable={true}
              reorderable={true}
              onGroupChange={onGroupChange}
              group={group}
              className={`${(gridFlagVal == 'partialTrips' && currSelectedStatus == 90) || (gridFlagVal == 'movements' && currSelectedStatus != "All") ? 'AltGrid' : ''} ${columnChooser.length > 0 ? 'mt48' : 'mt40'}`}
            >
              <Column
                field={"selected"}
                locked={true}
                width="28px"
                headerSelectionValue={mygridCheckHeaderSelectionValue()}//data.gridCheckHeaderSelectionValue()}
                headerClassName={(data.selectableMode === 'single' || disableSelectAll) ? "hideHeaderCheckbox": 'center-box'}
                filterable={false}
                className={"bts-1 center-box"}
                reorderable={false}
                resizable={false}
                orderIndex={0}
              />
              {tempGridColumns && tempGridColumns.map((column, index) => {
                return columnRender(column, index);
              })}
              {/* {gridColumns && gridColumns.map((column, index) => {
                return columnRenderMemo(column, index);
              })} */}
            </KendoReactGrid>
          </div>

          {show ? <ContextMenu flag="dataGrid" Id={getSelectedValues()} nonFilterableColumnData={nonFilterableColumnData} contextData={contextData} gridFlagVal={gridFlagValFor} offset={offSet.current} data={toggleconfigActions} customActions={toggleconfigCustomActions} sendToParent={onPlanButtons} /> : null}
        </Grid>


        <Box className='filterbar-bg disable-in-custom-view' sx={{ display: 'flex', }}>
          <Box className="arrow-btn" onClick={showToggleMenu}>
            {isShowToggleForConfig ? <ArrowForwardIosRoundedIcon color='secondary.contrastText' /> : <ArrowBackIosRoundedIcon color='secondary.contrastText' />}
          </Box>
          <Box className="overflow-datafix fix-heightMovement" sx={{ position: 'relative' }}>
            {isShowToggleForConfig &&
              <ToggleMenuForConfig gridFlagVal={gridFlagValFor} gridSelectedDataAction={toggleconfigcheckboxes} gridSelectedPlanAction={toggleconfigcheckboxesplan} gridSelectedCustomAction={toggleconfigCustomActioncheckboxes} toggleDraggedItem={toggleDraggedItem} gridMenuItems={updatedGridDataAction} griddefDataRelatedAction={griddefDataRelatedAction} gridPlanMenuItems={gridPlanAction} gridCustomActionMenuItems={menuItemsForCustomActions} ref={toggleMenuRef} onCheckboxChange={toggleDataActionsRendering} onDroppedItemsChange={droppedItemsChangeForRightClick} onCheckboxChangePlan={toggleDataActionsRenderingPlan} onCheckboxChangeCustomAction={toggleCustomActionsRendering}/>
            }
          </Box>
        </Box>

      </Box >
      {/* </Box> */}

      {/* open modal for driver resource */}
      {openAddColumnModal && <WindowComponent title={"Select Resource"} visible={openAddColumnModal} initialWidth={1000} initialHeight={700} minWidth={300} minHeight={500} onClose={closePopupFilter} gridFlagVal={gridFlagVal} resourceType={resourceType} openAddColumnModal={openAddColumnModal} resourceData={resourceData} addResourceApi={addResourceApi}/>}

      {/* open modal for sort columns & freeze columns */}
      {openModalSort && <SortColumnChooserPopUp gridFlagVal={data.gridFlagValFor} openModalSort={openModalSort} setOpenModalSort={setOpenModalSort} columnMultiFilter={colMultiFilter} nonSortableColumnData ={nonSortableColumnData} filterSortArr={filterSortArr} sendDataToParent={saveSortColumnChooserPopUpData} gridTempColumnList={gridTempColumnList} 
      myGroupByColumnVal={groupByColumnVal} isChild={data.isChild} myFreezeColumnVal={freezeColumnVal} sortKeyViews={sortKeyViews} />}

      {/*open modal for plan on new trip details */}
      {openPlanNewTripPopup && <WindowComponent title={"Plan New Trip"} visible={openPlanNewTripPopup} initialWidth={420} initialHeight={200} minWidth={420} minHeight={200} onClose={() => setOpenPlanNewTripPopup(false)} dataComponent={PlanNewTripData} actionButtons={<PlanNewTripActionButtons />}/>}

      {/* open modal for columns selection  */}
      {openModalColumnsSelect && <ColumnPopUp gridSort={myGridDataState?.sort} gridTempColumnList={gridColumns} gridColumnList={tempGridColumns} gridFlagVal={data.gridFlagValFor} savedViewTitle={data.gridFlagValFor} openModalColumnsSelect={openModalColumnsSelect} setOpenModalColumnsSelect={setOpenModalColumnsSelect} sendDataToParent={saveColumnsSelectedData} />}

      {/* open modal for measurement column selection */}
      {openModalFreeze && <GrandSumTotalPopUp openModalFreeze={openModalFreeze} setOpenModalFreeze={setOpenModalFreeze} colMeasureFilters={measureFilters} sendDataToParent={grandTotalSum} />}     
      
      {openModalDepot && <WindowComponent title={depotModalTital} visible={openModalDepot} isWindowContent={true} params={popupParameters} initialWidth={1000} initialHeight={700} minWidth={300} minHeight={500} onClose={closePopupDepot} closeConfirmationModal={closeConfirmationModal}/>}

      <AlertComponent isSuccessSnackbarOpen={isSuccessSnackbarOpen} successSnackbarMessage={successSnackbarMessage} handleSuccessSnackbarClose={handleSuccessSnackbarClose}
        isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessage} handleErrorSnackbarClose={handleErrorSnackbarClose}
        isDisplayDrillDownButton={isDisplayDrillDownButton} drillDownButtonURL={drillDownButtonURL} />

      <ModalComponent message={errorMessage} params={commonPopupParameters} openConfirmationModal={openConfirmationModal} closeConfirmationModal={closeConfirmationModal} />

      {/* open delete confirmation modal for saved view  */}
      {isDeleteDialogOpen && <WindowComponent title={"Delete Confirmation"} visible={isDeleteDialogOpen} initialWidth={400} initialHeight={210} minWidth={400} minHeight={210} onClose={deleteSaveViewCancel} dataComponent={DeleteConfirmationComponent} actionButtons={<RenderActionButtons />} resizable={false} minimizeButton={() => { return null }} maximizeButton={() => { return null }} doubleClickStageChange={false}/>}
    </>
  );
});

export default DataGridComponent;
